export const images = {
  AEROPLANE: require("./assets/images/aeroplane.png"),
  BAZAARONE: require("./assets/images/bazaarOne.png"),
  BAZAARTWO: require("./assets/images/bazaarTwo.png"),
  BAZAARTHREE: require("./assets/images/bazaarThree.png"),
  BELL: require("./assets/images/bell.png"),
  BELLCOMPLETE: require("./assets/images/bellFull.png"),
  BELLRAPPER: require("./assets/images/bellRapper.png"),
  COLLECTOR: require("./assets/images/collector.png"),
  COLLECTORROOM: require("./assets/images/collector_room.png"),
  COLLECTORROOMNEW: require("./assets/images/collector_room_without_clock.png"),
  COLLECTORROOMNEWEST: require("./assets/images/collection_room_newest.webp"),
  COLLECTORROOMVERTICAL: require("./assets/images/collectors_room_extended_vertically.png"),
  COLLECTORROOMVERTICALIMAGE: require("./assets/images/collection_room_vertical_image.webp"),
  DOWNLOAD: require("./assets/images/download_brown.png"),
  FULL_COLLECTION_ROOM: require("./assets/images/room_with_all_matchbox.webp"),
  LABEL: require("./assets/images/label.png"),
  LEFTARROW: require("./assets/images/left_arrow.png"),
  OLDCAR: require("./assets/images/oldCar.png"),
  ORIENTATION: require("./assets/images/orientation.png"),
  PGNRBUS: require("./assets/images/pgnrBus.png"),
  PHIRKI: require("./assets/images/phirki.png"),
  PHIRKICOMPLETE: require("./assets/images/phirkiFull.png"),
  PHIRKIRAPPER: require("./assets/images/phirkiRapper.png"),
  REDBUS: require("./assets/images/redBus.png"),
  RELOAD: require("./assets/images/reload_brown.png"),
  RIGHTARROW: require("./assets/images/right_arrow.png"),
  ROLLONE: require("./assets/images/rollOne.webp"),
  ROLLTWO: require("./assets/images/rollTwo.webp"),
  ROLLTHREE: require("./assets/images/rollThree.webp"),
  ROLLFOUR: require("./assets/images/rollFour.webp"),
  ROLLFIVE: require("./assets/images/rollFive.webp"),
  ROLLSIX: require("./assets/images/rollSix.webp"),
  ROOM: require("./assets/images/room.png"),
  SHARE: require("./assets/images/share_brown.png"),
  TRAIN: require("./assets/images/train.png"),
  SHELL: require("./assets/images/shell.png"),
  SHELLRAPPER: require("./assets/images/shellRapper.png"),
  SHELLCOMPLETE: require("./assets/images/shellFull.png"),
  VOILIN: require("./assets/images/voilin.png"),
  VOILINRAPPER: require("./assets/images/voilinRapper.png"),
  VOILINCOMPLETE: require("./assets/images/voilinFull.png"),
  IBUTTON: require("./assets/images/IButton.png"),
  FRONTONE: require("./assets/images/frontOne.png"),
  BACKONE: require("./assets/images/backOne.png"),
  FRONTWO: require("./assets/images/frontTwo.png"),
  BACKTWO: require("./assets/images/backTwo.png"),
  FRONTTHREE: require("./assets/images/frontThree.png"),
  BACKTHREE: require("./assets/images/backThree.png"),
  FRONTFOUR: require("./assets/images/frontFour.png"),
  BACKFOUR: require("./assets/images/backFour.png"),
  BULB: require("./assets/images/bulb.png"),
  BACKGROUND: require("./assets/images/background.webp"),
  COLLECTORROOMFINALPAGE: require("./assets/images/collection_room_newest.webp"),
  MARKETONENEW: require("./assets/images/market_horizontal1.webp"),
  MARKETTWONEW: require("./assets/images/market_horizontal2.webp"),
  MARKETTHREENEW: require("./assets/images/market_vertical1.webp"),
  COLLECTORROOMWITHCLOCK: require("./assets/images/collectors_room_with_clock.webp"),
  INFORMATION: require("./assets/images/Information.webp"),
  INSTRUCTION: require("./assets/images/Instruction.webp"),
  LANGUAGE: require("./assets/images/Language.webp"),
  RESTART: require("./assets/images/Restart.webp"),
  VOLUMEOOF: require("./assets/images/Volumeoff.webp"),
  VOLUMEON: require("./assets/images/Volumeon.webp"),
  MATCHBOX_DOOR_2: require("./assets/images/matchbox_door2.webp"),

  HINDIENGLISHBUTTON: require("./assets/images/hindiEnglishButton.png"),
  ABOUTBUTTON: require("./assets/images/aboutButton.png"),
  RESTARTBUTTON: require("./assets/images/restartButton.png"),
  SHAREBUTTON: require("./assets/images/shareButton.webp"),
  MUTEBUTTON: require("./assets/images/muteButton.png"),
  UNMUTEBUTTON: require("./assets/images/unMuteButton.png"),
  Logo: require("./assets/images/GAC_text_logo_white.webp"),
  TASVEER_GHAR_LOGO: require("./assets/images/tasveer_ghar_white_logo.webp"),
  MAP_LOGO: require("./assets/images/map_logo_white.webp"),

  // Strips
  MATCHBOXSTRIPRESTART: require("./assets/images/matchboxRestart.png"),
  MATCHBOXSTRIPAUDIOOFF: require("./assets/images/matchbox_bottom_strip_audiooff.png"),
  MATCHBOXSTRIPAUDIOON: require("./assets/images/matchbox_bottom_strip_audioon.png"),
  MATCHBOXSTRIPLANGUAGE: require("./assets/images/matchbox_bottom_strip_languageonly.png"),
  MATCHBOXSTRIPINFO: require("./assets/images/matchbox_top_bottom_strip_information_icon.webp"),
  // MATCHBOXSTRIP: require("./assets/images/matchbox_top_bottom_strip_without_any_icons.png"),
  MATCHBOXSTRIPAUDIOOFFANDLANGUAGE: require("./assets/images/matchbox_top_bottom_strips_audiooff_language_bottom_2.webp"),
  MATCHBOXSTRIPAUDIOONLANGUAGE: require("./assets/images/matchbox_top_bottom_strips_audioon_language_bottom_2.webp"),
  MATCHBOXSTRIPAUDIOOFFSHARELANGUAGE: require("./assets/images/matchbox_begin_top_bottom_strips_audioof_language_bottom_2.webp"),
  MATCHBOXSTRIPAUDIOONSHARELANGUAGE: require("./assets/images/matchbox_begin_top_bottom_strips_audioon_language_bottom_2.webp"),
  MATCHBOXSTRIPINFORMATION: require("./assets/images/matchbox_top_information_only.png"),
  MATCHBOXSTRIPINFOANDRESTART: require("./assets/images/matchbox_top_information_restart.png"),
  MATCHBOXSTRIPCATEGORYTOP: require("./assets/images/mobile_category_3_iconstop2.webp"),
  MATCHBOXSTRIPCATEGORYTOP2: require("./assets/images/mobile_category_3_iconstop3.webp"),
  MATCHBOXSTRIPCATEGORYBOTTOMOFF: require("./assets/images/mobile_category_page_bottomvolume1.webp"),
  MATCHBOXSTRIPCATEGORYBOTTOMON: require("./assets/images/mobile_category_page_bottomvolume2.webp"),
  BULBBRIGHT: require("./assets/images/bulbBright.png"),
  MATCHBOXMOMENTOS: require("./assets/images/landing_page_matchbox_name.webp"),
  MATCHBOXMOMENTOSHINDI: require("./assets/images/matchis_masti_hindi_logoform-01.webp"),
  ROOMHINDI: require("./assets/images/room_hindi.webp"),
  RIGHTARROW:require("./assets/images/right.png"),
  BACKARROW:require("./assets/images/back.png"),
  BACKARROWTWO: require("./assets/images/Vectorbhbhbg.png"),
  MATCHBOXSTRIP:require("./assets/images/matchbox_strip_small_section.png"),

  //artwork Images
  // ADSFANS: require("./assets/images/ads_fans.webp"),
  // BABIES: require("./assets/images/babies.webp"),
  // BUILDING: require("./assets/images/building.webp"),
  // CINEMA: require("./assets/images/cinema.webp"),
  // FARMING: require("./assets/images/farming.webp"),
  // FLOWERS: require("./assets/images/flowers.webp"),
  // FOOD: require("./assets/images/food.webp"),
  // INDIA: require("./assets/images/india.webp"),
  // LAMP: require("./assets/images/lamp.webp"),
  // MACHINES: require("./assets/images/machines.webp"),
  // MEN: require("./assets/images/men.webp"),
  // MUSIC1: require("./assets/images/music1.webp"),
  // OLDLABELS: require("./assets/images/old_labels.webp"),
  // SPORT: require("./assets/images/sport.webp"),
  // SYMBOLS: require("./assets/images/symbols.webp"),
  // TOOLS: require("./assets/images/tools.webp"),
  // TRANSPORT: require("./assets/images/transport.webp"),
  // WILDLIFE: require("./assets/images/wildlife.webp"),
  // WOMEN: require("./assets/images/women.webp"),
  ADS1: require("./assets/images/ads1.webp"),
  ADS2: require("./assets/images/ads2.webp"),
  ADS3: require("./assets/images/ads3.webp"),
  ADS4: require("./assets/images/ads4.webp"),
  ADS5: require("./assets/images/ads5.webp"),
  ADS6: require("./assets/images/ads6.webp"),
  ADS7: require("./assets/images/ads7.webp"),
  ADS8: require("./assets/images/ads8.webp"),
  ADS9: require("./assets/images/ads9.webp"),
  ADS10: require("./assets/images/ads10.webp"),

  BABIES1: require("./assets/images/babies1.webp"),
  BABIES2: require("./assets/images/babies2.webp"),
  BABIES3: require("./assets/images/babies3.webp"),
  BABIES4: require("./assets/images/babies4.webp"),
  BABIES5: require("./assets/images/babies5.webp"),
  BABIES6: require("./assets/images/babies6.webp"),
  BABIES7: require("./assets/images/babies7.webp"),
  BABIES8: require("./assets/images/babies8.webp"),
  BABIES9: require("./assets/images/babies9.webp"),
  BABIES10: require("./assets/images/babies10.webp"),

  BUILDINGS1: require("./assets/images/buildings1.webp"),
  BUILDINGS2: require("./assets/images/buildings2.webp"),
  BUILDINGS3: require("./assets/images/buildings3.webp"),
  BUILDINGS4: require("./assets/images/buildings4.webp"),
  BUILDINGS5: require("./assets/images/buildings5.webp"),
  BUILDINGS6: require("./assets/images/buildings6.webp"),
  BUILDINGS7: require("./assets/images/buildings7.webp"),
  BUILDINGS8: require("./assets/images/buildings8.webp"),
  BUILDINGS9: require("./assets/images/buildings9.webp"),
  BUILDINGS10: require("./assets/images/buildings10.webp"),

  CINEMA1: require("./assets/images/cinema1.webp"),
  CINEMA2: require("./assets/images/cinema2.webp"),
  CINEMA3: require("./assets/images/cinema3.webp"),
  CINEMA4: require("./assets/images/cinema4.webp"),
  CINEMA5: require("./assets/images/cinema5.webp"),
  CINEMA6: require("./assets/images/cinema6.webp"),
  CINEMA7: require("./assets/images/cinema7.webp"),
  CINEMA8: require("./assets/images/cinema8.webp"),
  CINEMA9: require("./assets/images/cinema9.webp"),
  CINEMA10: require("./assets/images/cinema10.webp"),

  FARMING1: require("./assets/images/farming1.webp"),
  FARMING2: require("./assets/images/farming2.webp"),
  FARMING3: require("./assets/images/farming3.webp"),
  FARMING4: require("./assets/images/farming4.webp"),
  FARMING5: require("./assets/images/farming5.webp"),
  FARMING6: require("./assets/images/farming6.webp"),
  FARMING7: require("./assets/images/farming7.webp"),
  FARMING8: require("./assets/images/farming8.webp"),
  FARMING9: require("./assets/images/farming9.webp"),
  FARMING10: require("./assets/images/farming10.webp"),

  FLOWERS1: require("./assets/images/flowers1.webp"),
  FLOWERS2: require("./assets/images/flowers2.webp"),
  FLOWERS3: require("./assets/images/flowers3.webp"),
  FLOWERS4: require("./assets/images/flowers4.webp"),
  FLOWERS5: require("./assets/images/flowers5.webp"),
  FLOWERS6: require("./assets/images/flowers6.webp"),
  FLOWERS7: require("./assets/images/flowers7.webp"),
  FLOWERS8: require("./assets/images/flowers8.webp"),
  FLOWERS9: require("./assets/images/flowers9.webp"),
  FLOWERS10: require("./assets/images/flowers10.webp"),

  FOOD1: require("./assets/images/food1.webp"),
  FOOD2: require("./assets/images/food2.webp"),
  FOOD3: require("./assets/images/food3.webp"),
  FOOD4: require("./assets/images/food4.webp"),
  FOOD5: require("./assets/images/food5.webp"),
  FOOD6: require("./assets/images/food6.webp"),
  FOOD7: require("./assets/images/food7.webp"),
  FOOD8: require("./assets/images/food8.webp"),
  FOOD9: require("./assets/images/food9.webp"),
  FOOD10: require("./assets/images/food10.webp"),

  INDIA1: require("./assets/images/india1.webp"),
  INDIA2: require("./assets/images/india2.webp"),
  INDIA3: require("./assets/images/india3.webp"),
  INDIA4: require("./assets/images/india4.webp"),
  INDIA5: require("./assets/images/india5.webp"),
  INDIA6: require("./assets/images/india6.webp"),
  INDIA7: require("./assets/images/india7.webp"),
  INDIA8: require("./assets/images/india8.webp"),
  INDIA9: require("./assets/images/india9.webp"),
  INDIA10: require("./assets/images/india10.webp"),

  LAMPS1: require("./assets/images/lamps1.webp"),
  LAMPS2: require("./assets/images/lamps2.webp"),
  LAMPS3: require("./assets/images/lamps3.webp"),
  LAMPS4: require("./assets/images/lamps4.webp"),
  LAMPS5: require("./assets/images/lamps5.webp"),
  LAMPS6: require("./assets/images/lamps6.webp"),
  LAMPS7: require("./assets/images/lamps7.webp"),
  LAMPS8: require("./assets/images/lamps8.webp"),
  LAMPS9: require("./assets/images/lamps9.webp"),
  LAMPS10: require("./assets/images/lamps10.webp"),

  MACHINES1: require("./assets/images/machines1.webp"),
  MACHINES2: require("./assets/images/machines2.webp"),
  MACHINES3: require("./assets/images/machines3.webp"),
  MACHINES4: require("./assets/images/machines4.webp"),
  MACHINES5: require("./assets/images/machines5.webp"),
  MACHINES6: require("./assets/images/machines6.webp"),
  MACHINES7: require("./assets/images/machines7.webp"),
  MACHINES8: require("./assets/images/machines8.webp"),
  MACHINES9: require("./assets/images/machines9.webp"),
  MACHINES10: require("./assets/images/machines10.webp"),

  MEN1: require("./assets/images/men1.webp"),
  MEN2: require("./assets/images/men2.webp"),
  MEN3: require("./assets/images/men3.webp"),
  MEN4: require("./assets/images/men4.webp"),
  MEN5: require("./assets/images/men5.webp"),
  MEN6: require("./assets/images/men6.webp"),
  MEN7: require("./assets/images/men7.webp"),
  MEN8: require("./assets/images/men8.webp"),
  MEN9: require("./assets/images/men9.webp"),
  MEN10: require("./assets/images/men10.webp"),

  MUSIC1: require("./assets/images/music1.webp"),
  MUSIC2: require("./assets/images/music2.webp"),
  MUSIC3: require("./assets/images/music3.webp"),
  MUSIC4: require("./assets/images/music4.webp"),
  MUSIC5: require("./assets/images/music5.webp"),
  MUSIC6: require("./assets/images/music6.webp"),
  MUSIC7: require("./assets/images/music7.webp"),
  MUSIC8: require("./assets/images/music8.webp"),
  MUSIC9: require("./assets/images/music9.webp"),
  MUSIC10: require("./assets/images/music10.webp"),

  OLD_LABELS1: require("./assets/images/old_labels1.webp"),
  OLD_LABELS2: require("./assets/images/old_labels2.webp"),
  OLD_LABELS3: require("./assets/images/old_labels3.webp"),
  OLD_LABELS4: require("./assets/images/old_labels4.webp"),
  OLD_LABELS5: require("./assets/images/old_labels5.webp"),
  OLD_LABELS6: require("./assets/images/old_labels6.webp"),
  OLD_LABELS7: require("./assets/images/old_labels7.webp"),
  OLD_LABELS8: require("./assets/images/old_labels8.webp"),
  OLD_LABELS9: require("./assets/images/old_labels9.webp"),
  OLD_LABELS10: require("./assets/images/old_labels10.webp"),

  SPORTS1: require("./assets/images/sports1.webp"),
  SPORTS2: require("./assets/images/sports2.webp"),
  SPORTS3: require("./assets/images/sports3.webp"),
  SPORTS4: require("./assets/images/sports4.webp"),
  SPORTS5: require("./assets/images/sports5.webp"),
  SPORTS6: require("./assets/images/sports6.webp"),
  SPORTS7: require("./assets/images/sports7.webp"),
  SPORTS8: require("./assets/images/sports8.webp"),
  SPORTS9: require("./assets/images/sports9.webp"),
  SPORTS10: require("./assets/images/sports10.webp"),

  SYMBOLS1: require("./assets/images/symbols1.webp"),
  SYMBOLS2: require("./assets/images/symbols2.webp"),
  SYMBOLS3: require("./assets/images/symbols3.webp"),
  SYMBOLS4: require("./assets/images/symbols4.webp"),
  SYMBOLS5: require("./assets/images/symbols5.webp"),
  SYMBOLS6: require("./assets/images/symbols6.webp"),
  SYMBOLS7: require("./assets/images/symbols7.webp"),
  SYMBOLS8: require("./assets/images/symbols8.webp"),
  SYMBOLS9: require("./assets/images/symbols9.webp"),
  SYMBOLS10: require("./assets/images/symbols10.webp"),

  TOOLS1: require("./assets/images/tools1.webp"),
  TOOLS2: require("./assets/images/tools2.webp"),
  TOOLS3: require("./assets/images/tools3.webp"),
  TOOLS4: require("./assets/images/tools4.webp"),
  TOOLS5: require("./assets/images/tools5.webp"),
  TOOLS6: require("./assets/images/tools6.webp"),
  TOOLS7: require("./assets/images/tools7.webp"),
  TOOLS8: require("./assets/images/tools8.webp"),
  TOOLS9: require("./assets/images/tools9.webp"),
  TOOLS10: require("./assets/images/tools10.webp"),

  TRANSPORT1: require("./assets/images/transport1.webp"),
  TRANSPORT2: require("./assets/images/transport2.webp"),
  TRANSPORT3: require("./assets/images/transport3.webp"),
  TRANSPORT4: require("./assets/images/transport4.webp"),
  TRANSPORT5: require("./assets/images/transport5.webp"),
  TRANSPORT6: require("./assets/images/transport6.webp"),
  TRANSPORT7: require("./assets/images/transport7.webp"),
  TRANSPORT8: require("./assets/images/transport8.webp"),
  TRANSPORT9: require("./assets/images/transport9.webp"),
  TRANSPORT10: require("./assets/images/transport10.webp"),

  WILDLIFE1: require("./assets/images/wildlife1.webp"),
  WILDLIFE2: require("./assets/images/wildlife2.webp"),
  WILDLIFE3: require("./assets/images/wildlife3.webp"),
  WILDLIFE4: require("./assets/images/wildlife4.webp"),
  WILDLIFE5: require("./assets/images/wildlife5.webp"),
  WILDLIFE6: require("./assets/images/wildlife6.webp"),
  WILDLIFE7: require("./assets/images/wildlife7.webp"),
  WILDLIFE8: require("./assets/images/wildlife8.webp"),
  WILDLIFE9: require("./assets/images/wildlife9.webp"),
  WILDLIFE10: require("./assets/images/wildlife10.webp"),

  WOMEN1: require("./assets/images/women1.webp"),
  WOMEN2: require("./assets/images/women2.webp"),
  WOMEN3: require("./assets/images/women3.webp"),
  WOMEN4: require("./assets/images/women4.webp"),
  WOMEN5: require("./assets/images/women5.webp"),
  WOMEN6: require("./assets/images/women6.webp"),
  WOMEN7: require("./assets/images/women7.webp"),
  WOMEN8: require("./assets/images/women8.webp"),
  WOMEN9: require("./assets/images/women9.webp"),
  WOMEN10: require("./assets/images/women10.webp"),

  //artwork images in HD
  ADS1_HD: require("./assets/images/ads1_hd.jpg"),
  ADS2_HD: require("./assets/images/ads2_hd.jpg"),
  ADS3_HD: require("./assets/images/ads3_hd.jpg"),
  ADS4_HD: require("./assets/images/ads4_hd.jpg"),
  ADS5_HD: require("./assets/images/ads5_hd.jpg"),
  ADS6_HD: require("./assets/images/ads6_hd.jpg"),
  ADS7_HD: require("./assets/images/ads7_hd.jpg"),
  ADS8_HD: require("./assets/images/ads8_hd.jpg"),
  ADS9_HD: require("./assets/images/ads9_hd.jpg"),
  ADS10_HD: require("./assets/images/ads10_hd.jpg"),

  BABIES1_HD: require("./assets/images/babies1_hd.jpg"),
  BABIES2_HD: require("./assets/images/babies2_hd.jpg"),
  BABIES3_HD: require("./assets/images/babies3_hd.jpg"),
  BABIES4_HD: require("./assets/images/babies4_hd.jpg"),
  BABIES5_HD: require("./assets/images/babies5_hd.jpg"),
  BABIES6_HD: require("./assets/images/babies6_hd.jpg"),
  BABIES7_HD: require("./assets/images/babies7_hd.jpg"),
  BABIES8_HD: require("./assets/images/babies8_hd.jpg"),
  BABIES9_HD: require("./assets/images/babies9_hd.jpg"),
  BABIES10_HD: require("./assets/images/babies10_hd.jpg"),

  BUILDINGS1_HD: require("./assets/images/buildings1_hd.jpg"),
  BUILDINGS2_HD: require("./assets/images/buildings2_hd.jpg"),
  BUILDINGS3_HD: require("./assets/images/buildings3_hd.jpg"),
  BUILDINGS4_HD: require("./assets/images/buildings4_hd.jpg"),
  BUILDINGS5_HD: require("./assets/images/buildings5_hd.jpg"),
  BUILDINGS6_HD: require("./assets/images/buildings6_hd.jpg"),
  BUILDINGS7_HD: require("./assets/images/buildings7_hd.jpg"),
  BUILDINGS8_HD: require("./assets/images/buildings8_hd.jpg"),
  BUILDINGS9_HD: require("./assets/images/buildings9_hd.jpg"),
  BUILDINGS10_HD: require("./assets/images/buildings10_hd.jpg"),

  CINEMA1_HD: require("./assets/images/cinema1_hd.jpg"),
  CINEMA2_HD: require("./assets/images/cinema2_hd.jpg"),
  CINEMA3_HD: require("./assets/images/cinema3_hd.jpg"),
  CINEMA4_HD: require("./assets/images/cinema4_hd.jpg"),
  CINEMA5_HD: require("./assets/images/cinema5_hd.jpg"),
  CINEMA6_HD: require("./assets/images/cinema6_hd.jpg"),
  CINEMA7_HD: require("./assets/images/cinema7_hd.jpg"),
  CINEMA8_HD: require("./assets/images/cinema8_hd.jpg"),
  CINEMA9_HD: require("./assets/images/cinema9_hd.jpg"),
  CINEMA10_HD: require("./assets/images/cinema10_hd.jpg"),

  FARMING1_HD: require("./assets/images/farming1_hd.jpg"),
  FARMING2_HD: require("./assets/images/farming2_hd.jpg"),
  FARMING3_HD: require("./assets/images/farming3_hd.jpg"),
  FARMING4_HD: require("./assets/images/farming4_hd.jpg"),
  FARMING5_HD: require("./assets/images/farming5_hd.jpg"),
  FARMING6_HD: require("./assets/images/farming6_hd.jpg"),
  FARMING7_HD: require("./assets/images/farming7_hd.jpg"),
  FARMING8_HD: require("./assets/images/farming8_hd.jpg"),
  FARMING9_HD: require("./assets/images/farming9_hd.jpg"),
  FARMING10_HD: require("./assets/images/farming10_hd.jpg"),

  FLOWERS1_HD: require("./assets/images/flowers1_hd.jpg"),
  FLOWERS2_HD: require("./assets/images/flowers2_hd.jpg"),
  FLOWERS3_HD: require("./assets/images/flowers3_hd.jpg"),
  FLOWERS4_HD: require("./assets/images/flowers4_hd.jpg"),
  FLOWERS5_HD: require("./assets/images/flowers5_hd.jpg"),
  FLOWERS6_HD: require("./assets/images/flowers6_hd.jpg"),
  FLOWERS7_HD: require("./assets/images/flowers7_hd.jpg"),
  FLOWERS8_HD: require("./assets/images/flowers8_hd.jpg"),
  FLOWERS9_HD: require("./assets/images/flowers9_hd.jpg"),
  FLOWERS10_HD: require("./assets/images/flowers10_hd.jpg"),

  FOOD1_HD: require("./assets/images/food1_hd.jpg"),
  FOOD2_HD: require("./assets/images/food2_hd.jpg"),
  FOOD3_HD: require("./assets/images/food3_hd.jpg"),
  FOOD4_HD: require("./assets/images/food4_hd.jpg"),
  FOOD5_HD: require("./assets/images/food5_hd.jpg"),
  FOOD6_HD: require("./assets/images/food6_hd.jpg"),
  FOOD7_HD: require("./assets/images/food7_hd.jpg"),
  FOOD8_HD: require("./assets/images/food8_hd.jpg"),
  FOOD9_HD: require("./assets/images/food9_hd.jpg"),
  FOOD10_HD: require("./assets/images/food10_hd.jpg"),

  INDIA1_HD: require("./assets/images/india1_hd.jpg"),
  INDIA2_HD: require("./assets/images/india2_hd.jpg"),
  INDIA3_HD: require("./assets/images/india3_hd.jpg"),
  INDIA4_HD: require("./assets/images/india4_hd.jpg"),
  INDIA5_HD: require("./assets/images/india5_hd.jpg"),
  INDIA6_HD: require("./assets/images/india6_hd.jpg"),
  INDIA7_HD: require("./assets/images/india7_hd.jpg"),
  INDIA8_HD: require("./assets/images/india8_hd.jpg"),
  INDIA9_HD: require("./assets/images/india9_hd.jpg"),
  INDIA10_HD: require("./assets/images/india10_hd.jpg"),

  LAMPS1_HD: require("./assets/images/lamps1_hd.jpg"),
  LAMPS2_HD: require("./assets/images/lamps2_hd.jpg"),
  LAMPS3_HD: require("./assets/images/lamps3_hd.jpg"),
  LAMPS4_HD: require("./assets/images/lamps4_hd.jpg"),
  LAMPS5_HD: require("./assets/images/lamps5_hd.jpg"),
  LAMPS6_HD: require("./assets/images/lamps6_hd.jpg"),
  LAMPS7_HD: require("./assets/images/lamps7_hd.jpg"),
  LAMPS8_HD: require("./assets/images/lamps8_hd.jpg"),
  LAMPS9_HD: require("./assets/images/lamps9_hd.jpg"),
  LAMPS10_HD: require("./assets/images/lamps10_hd.jpg"),

  MACHINES1_HD: require("./assets/images/machines1_hd.jpg"),
  MACHINES2_HD: require("./assets/images/machines2_hd.jpg"),
  MACHINES3_HD: require("./assets/images/machines3_hd.jpg"),
  MACHINES4_HD: require("./assets/images/machines4_hd.jpg"),
  MACHINES5_HD: require("./assets/images/machines5_hd.jpg"),
  MACHINES6_HD: require("./assets/images/machines6_hd.jpg"),
  MACHINES7_HD: require("./assets/images/machines7_hd.jpg"),
  MACHINES8_HD: require("./assets/images/machines8_hd.jpg"),
  MACHINES9_HD: require("./assets/images/machines9_hd.jpg"),
  MACHINES10_HD: require("./assets/images/machines10_hd.jpg"),

  MEN1_HD: require("./assets/images/men1_hd.jpg"),
  MEN2_HD: require("./assets/images/men2_hd.jpg"),
  MEN3_HD: require("./assets/images/men3_hd.jpg"),
  MEN4_HD: require("./assets/images/men4_hd.jpg"),
  MEN5_HD: require("./assets/images/men5_hd.jpg"),
  MEN6_HD: require("./assets/images/men6_hd.jpg"),
  MEN7_HD: require("./assets/images/men7_hd.jpg"),
  MEN8_HD: require("./assets/images/men8_hd.jpg"),
  MEN9_HD: require("./assets/images/men9_hd.jpg"),
  MEN10_HD: require("./assets/images/men10_hd.jpg"),

  MUSIC1_HD: require("./assets/images/music1_hd.jpg"),
  MUSIC2_HD: require("./assets/images/music2_hd.jpg"),
  MUSIC3_HD: require("./assets/images/music3_hd.jpg"),
  MUSIC4_HD: require("./assets/images/music4_hd.jpg"),
  MUSIC5_HD: require("./assets/images/music5_hd.jpg"),
  MUSIC6_HD: require("./assets/images/music6_hd.jpg"),
  MUSIC7_HD: require("./assets/images/music7_hd.jpg"),
  MUSIC8_HD: require("./assets/images/music8_hd.jpg"),
  MUSIC9_HD: require("./assets/images/music9_hd.jpg"),
  MUSIC10_HD: require("./assets/images/music10_hd.jpg"),

  OLD_LABELS1_HD: require("./assets/images/old_labels1_hd.jpg"),
  OLD_LABELS2_HD: require("./assets/images/old_labels2_hd.jpg"),
  OLD_LABELS3_HD: require("./assets/images/old_labels3_hd.jpg"),
  OLD_LABELS4_HD: require("./assets/images/old_labels4_hd.jpg"),
  OLD_LABELS5_HD: require("./assets/images/old_labels5_hd.jpg"),
  OLD_LABELS6_HD: require("./assets/images/old_labels6_hd.jpg"),
  OLD_LABELS7_HD: require("./assets/images/old_labels7_hd.jpg"),
  OLD_LABELS8_HD: require("./assets/images/old_labels8_hd.jpg"),
  OLD_LABELS9_HD: require("./assets/images/old_labels9_hd.jpg"),
  OLD_LABELS10_HD: require("./assets/images/old_labels10_hd.jpg"),

  SPORTS1_HD: require("./assets/images/sports1_hd.jpg"),
  SPORTS2_HD: require("./assets/images/sports2_hd.jpg"),
  SPORTS3_HD: require("./assets/images/sports3_hd.jpg"),
  SPORTS4_HD: require("./assets/images/sports4_hd.jpg"),
  SPORTS5_HD: require("./assets/images/sports5_hd.jpg"),
  SPORTS6_HD: require("./assets/images/sports6_hd.jpg"),
  SPORTS7_HD: require("./assets/images/sports7_hd.jpg"),
  SPORTS8_HD: require("./assets/images/sports8_hd.jpg"),
  SPORTS9_HD: require("./assets/images/sports9_hd.jpg"),
  SPORTS10_HD: require("./assets/images/sports10_hd.jpg"),

  SYMBOLS1_HD: require("./assets/images/symbols1_hd.jpg"),
  SYMBOLS2_HD: require("./assets/images/symbols2_hd.jpg"),
  SYMBOLS3_HD: require("./assets/images/symbols3_hd.jpg"),
  SYMBOLS4_HD: require("./assets/images/symbols4_hd.jpg"),
  SYMBOLS5_HD: require("./assets/images/symbols5_hd.jpg"),
  SYMBOLS6_HD: require("./assets/images/symbols6_hd.jpg"),
  SYMBOLS7_HD: require("./assets/images/symbols7_hd.jpg"),
  SYMBOLS8_HD: require("./assets/images/symbols8_hd.jpg"),
  SYMBOLS9_HD: require("./assets/images/symbols9_hd.jpg"),
  SYMBOLS10_HD: require("./assets/images/symbols10_hd.jpg"),

  TOOLS1_HD: require("./assets/images/tools1_hd.jpg"),
  TOOLS2_HD: require("./assets/images/tools2_hd.jpg"),
  TOOLS3_HD: require("./assets/images/tools3_hd.jpg"),
  TOOLS4_HD: require("./assets/images/tools4_hd.jpg"),
  TOOLS5_HD: require("./assets/images/tools5_hd.jpg"),
  TOOLS6_HD: require("./assets/images/tools6_hd.jpg"),
  TOOLS7_HD: require("./assets/images/tools7_hd.jpg"),
  TOOLS8_HD: require("./assets/images/tools8_hd.jpg"),
  TOOLS9_HD: require("./assets/images/tools9_hd.jpg"),
  TOOLS10_HD: require("./assets/images/tools10_hd.jpg"),

  TRANSPORT1_HD: require("./assets/images/transport1_hd.jpg"),
  TRANSPORT2_HD: require("./assets/images/transport2_hd.jpg"),
  TRANSPORT3_HD: require("./assets/images/transport3_hd.jpg"),
  TRANSPORT4_HD: require("./assets/images/transport4_hd.jpg"),
  TRANSPORT5_HD: require("./assets/images/transport5_hd.jpg"),
  TRANSPORT6_HD: require("./assets/images/transport6_hd.jpg"),
  TRANSPORT7_HD: require("./assets/images/transport7_hd.jpg"),
  TRANSPORT8_HD: require("./assets/images/transport8_hd.jpg"),
  TRANSPORT9_HD: require("./assets/images/transport9_hd.jpg"),
  TRANSPORT10_HD: require("./assets/images/transport10_hd.jpg"),

  WILDLIFE1_HD: require("./assets/images/wildlife1_hd.jpg"),
  WILDLIFE2_HD: require("./assets/images/wildlife2_hd.jpg"),
  WILDLIFE3_HD: require("./assets/images/wildlife3_hd.jpg"),
  WILDLIFE4_HD: require("./assets/images/wildlife4_hd.jpg"),
  WILDLIFE5_HD: require("./assets/images/wildlife5_hd.jpg"),
  WILDLIFE6_HD: require("./assets/images/wildlife6_hd.jpg"),
  WILDLIFE7_HD: require("./assets/images/wildlife7_hd.jpg"),
  WILDLIFE8_HD: require("./assets/images/wildlife8_hd.jpg"),
  WILDLIFE9_HD: require("./assets/images/wildlife9_hd.jpg"),
  WILDLIFE10_HD: require("./assets/images/wildlife10_hd.jpg"),

  WOMEN1_HD: require("./assets/images/women1_hd.jpg"),
  WOMEN2_HD: require("./assets/images/women2_hd.jpg"),
  WOMEN3_HD: require("./assets/images/women3_hd.jpg"),
  WOMEN4_HD: require("./assets/images/women4_hd.jpg"),
  WOMEN5_HD: require("./assets/images/women5_hd.jpg"),
  WOMEN6_HD: require("./assets/images/women6_hd.jpg"),
  WOMEN7_HD: require("./assets/images/women7_hd.jpg"),
  WOMEN8_HD: require("./assets/images/women8_hd.jpg"),
  WOMEN9_HD: require("./assets/images/women9_hd.jpg"),
  WOMEN10_HD: require("./assets/images/women10_hd.jpg"),

  // Update Boards
  BOARD1: require("./assets/images/music.png"),
  BOARD2: require("./assets/images/wildlife.png"),
  BOARD3: require("./assets/images/symbols.png"),
  BOARD4: require("./assets/images/tools.png"),
  BOARD5: require("./assets/images/farming.png"),
  BOARD6: require("./assets/images/sports.png"),
  BOARD7: require("./assets/images/women.png"),
  BOARD8: require("./assets/images/men.png"),
  BOARD9: require("./assets/images/India.png"),
  BOARD10: require("./assets/images/transport.png"),
  BOARD11: require("./assets/images/flowers.png"),
  BOARD12: require("./assets/images/advertisement.png"),
  BOARD13: require("./assets/images/cinema.png"),
  BOARD14: require("./assets/images/buildings.png"),
  BOARD15: require("./assets/images/lamps.png"),
  BOARD16: require("./assets/images/babies.png"),
  BOARD17: require("./assets/images/machines.png"),
  BOARD18: require("./assets/images/old_labels.png"),
  BOARD19: require("./assets/images/food.png"),

  //Board1 Quiz

  BOARD1_QUESTION1ICON: require("./assets/images/board1_question1icon.webp"),
  BOARD1_QUESTION1FULL: require("./assets/images/board1_question1full.webp"),
  BOARD1_QUESTION1BLANK: require("./assets/images/board1_question1blank.webp"),

  BOARD1_QUESTION2ICON: require("./assets/images/board1_question2icon.webp"),
  BOARD1_QUESTION2FULL: require("./assets/images/board1_question2full.webp"),
  BOARD1_QUESTION2BLANK: require("./assets/images/board1_question2blank.webp"),

  BOARD1_QUESTION3ICON: require("./assets/images/board1_question3icon.webp"),
  BOARD1_QUESTION3FULL: require("./assets/images/board1_question3full.webp"),
  BOARD1_QUESTION3BLANK: require("./assets/images/board1_question3blank.webp"),

  BOARD1_QUESTION4ICON: require("./assets/images/board1_question4icon.webp"),
  BOARD1_QUESTION4FULL: require("./assets/images/board1_question4full.webp"),
  BOARD1_QUESTION4BLANK: require("./assets/images/board1_question4blank.webp"),

  BOARD1_QUESTION5ICON: require("./assets/images/board1_question5icon.webp"),
  BOARD1_QUESTION5FULL: require("./assets/images/board1_question5full.webp"),
  BOARD1_QUESTION5BLANK: require("./assets/images/board1_question5blank.webp"),

  BOARD1_QUESTION6ICON: require("./assets/images/board1_question6icon.webp"),
  BOARD1_QUESTION6FULL: require("./assets/images/board1_question6full.webp"),
  BOARD1_QUESTION6BLANK: require("./assets/images/board1_question6blank.webp"),

  BOARD1_QUESTION7ICON: require("./assets/images/board1_question7icon.webp"),
  BOARD1_QUESTION7FULL: require("./assets/images/board1_question7full.webp"),
  BOARD1_QUESTION7BLANK: require("./assets/images/board1_question7blank.webp"),

  BOARD1_QUESTION8ICON: require("./assets/images/board1_question8icon.webp"),
  BOARD1_QUESTION8FULL: require("./assets/images/board1_question8full.webp"),
  BOARD1_QUESTION8BLANK: require("./assets/images/board1_question8blank.webp"),

  BOARD1_QUESTION9ICON: require("./assets/images/board1_question9icon.webp"),
  BOARD1_QUESTION9FULL: require("./assets/images/board1_question9full.webp"),
  BOARD1_QUESTION9BLANK: require("./assets/images/board1_question9blank.webp"),

  BOARD1_QUESTION10ICON: require("./assets/images/board1_question10icon.webp"),
  BOARD1_QUESTION10FULL: require("./assets/images/board1_question10full.webp"),
  BOARD1_QUESTION10BLANK: require("./assets/images/board1_question10blank.webp"),

  BOARD1_QUESTION11ICON: require("./assets/images/board1_question11icon.webp"),
  BOARD1_QUESTION11FULL: require("./assets/images/board1_question11full.webp"),
  BOARD1_QUESTION11BLANK: require("./assets/images/board1_question11blank.webp"),

  BOARD1_QUESTION12ICON: require("./assets/images/board1_question12icon.webp"),
  BOARD1_QUESTION12FULL: require("./assets/images/board1_question12full.webp"),
  BOARD1_QUESTION12BLANK: require("./assets/images/board1_question12blank.webp"),

  BOARD1_QUESTION13ICON: require("./assets/images/board1_question13icon.webp"),
  BOARD1_QUESTION13FULL: require("./assets/images/board1_question13full.webp"),
  BOARD1_QUESTION13BLANK: require("./assets/images/board1_question13blank.webp"),

  BOARD1_QUESTION14ICON: require("./assets/images/board1_question14icon.webp"),
  BOARD1_QUESTION14FULL: require("./assets/images/board1_question14full.webp"),
  BOARD1_QUESTION14BLANK: require("./assets/images/board1_question14blank.webp"),

  BOARD1_QUESTION15ICON: require("./assets/images/board1_question15icon.webp"),
  BOARD1_QUESTION15FULL: require("./assets/images/board1_question15full.webp"),
  BOARD1_QUESTION15BLANK: require("./assets/images/board1_question15blank.webp"),

  BOARD1_QUESTION16ICON: require("./assets/images/board1_question16icon.webp"),
  BOARD1_QUESTION16FULL: require("./assets/images/board1_question16full.webp"),
  BOARD1_QUESTION16BLANK: require("./assets/images/board1_question16blank.webp"),

  BOARD1_QUESTION17ICON: require("./assets/images/board1_question17icon.webp"),
  BOARD1_QUESTION17FULL: require("./assets/images/board1_question17full.webp"),
  BOARD1_QUESTION17BLANK: require("./assets/images/board1_question17blank.webp"),

  BOARD1_QUESTION18ICON: require("./assets/images/board1_question18icon.webp"),
  BOARD1_QUESTION18FULL: require("./assets/images/board1_question18full.webp"),
  BOARD1_QUESTION18BLANK: require("./assets/images/board1_question18blank.webp"),

  BOARD2_QUESTION1ICON: require("./assets/images/board2_question1icon.webp"),
  BOARD2_QUESTION1FULL: require("./assets/images/board2_question1full.webp"),
  BOARD2_QUESTION1BLANK: require("./assets/images/board2_question1blank.webp"),

  BOARD2_QUESTION2ICON: require("./assets/images/board2_question2icon.webp"),
  BOARD2_QUESTION2FULL: require("./assets/images/board2_question2full.webp"),
  BOARD2_QUESTION2BLANK: require("./assets/images/board2_question2blank.webp"),

  BOARD2_QUESTION3ICON: require("./assets/images/board2_question3icon.webp"),
  BOARD2_QUESTION3FULL: require("./assets/images/board2_question3full.webp"),
  BOARD2_QUESTION3BLANK: require("./assets/images/board2_question3blank.webp"),

  BOARD2_QUESTION4ICON: require("./assets/images/board2_question4icon.webp"),
  BOARD2_QUESTION4FULL: require("./assets/images/board2_question4full.webp"),
  BOARD2_QUESTION4BLANK: require("./assets/images/board2_question4blank.webp"),

  BOARD2_QUESTION5ICON: require("./assets/images/board2_question5icon.webp"),
  BOARD2_QUESTION5FULL: require("./assets/images/board2_question5full.webp"),
  BOARD2_QUESTION5BLANK: require("./assets/images/board2_question5blank.webp"),

  BOARD2_QUESTION6ICON: require("./assets/images/board2_question6icon.webp"),
  BOARD2_QUESTION6FULL: require("./assets/images/board2_question6full.webp"),
  BOARD2_QUESTION6BLANK: require("./assets/images/board2_question6blank.webp"),

  BOARD2_QUESTION7ICON: require("./assets/images/board2_question7icon.webp"),
  BOARD2_QUESTION7FULL: require("./assets/images/board2_question7full.webp"),
  BOARD2_QUESTION7BLANK: require("./assets/images/board2_question7blank.webp"),

  BOARD2_QUESTION8ICON: require("./assets/images/board2_question8icon.webp"),
  BOARD2_QUESTION8FULL: require("./assets/images/board2_question8full.webp"),
  BOARD2_QUESTION8BLANK: require("./assets/images/board2_question8blank.webp"),

  BOARD2_QUESTION9ICON: require("./assets/images/board2_question9icon.webp"),
  BOARD2_QUESTION9FULL: require("./assets/images/board2_question9full.webp"),
  BOARD2_QUESTION9BLANK: require("./assets/images/board2_question9blank.webp"),

  BOARD2_QUESTION10ICON: require("./assets/images/board2_question10icon.webp"),
  BOARD2_QUESTION10FULL: require("./assets/images/board2_question10full.webp"),
  BOARD2_QUESTION10BLANK: require("./assets/images/board2_question10blank.webp"),

  BOARD2_QUESTION11ICON: require("./assets/images/board2_question11icon.webp"),
  BOARD2_QUESTION11FULL: require("./assets/images/board2_question11full.webp"),
  BOARD2_QUESTION11BLANK: require("./assets/images/board2_question11blank.webp"),

  BOARD2_QUESTION12ICON: require("./assets/images/board2_question12icon.webp"),
  BOARD2_QUESTION12FULL: require("./assets/images/board2_question12full.webp"),
  BOARD2_QUESTION12BLANK: require("./assets/images/board2_question12blank.webp"),

  BOARD2_QUESTION13ICON: require("./assets/images/board2_question13icon.webp"),
  BOARD2_QUESTION13FULL: require("./assets/images/board2_question13full.webp"),
  BOARD2_QUESTION13BLANK: require("./assets/images/board2_question13blank.webp"),

  BOARD2_QUESTION14ICON: require("./assets/images/board2_question14icon.webp"),
  BOARD2_QUESTION14FULL: require("./assets/images/board2_question14full.webp"),
  BOARD2_QUESTION14BLANK: require("./assets/images/board2_question14blank.webp"),

  BOARD2_QUESTION15ICON: require("./assets/images/board2_question15icon.webp"),
  BOARD2_QUESTION15FULL: require("./assets/images/board2_question15full.webp"),
  BOARD2_QUESTION15BLANK: require("./assets/images/board2_question15blank.webp"),

  BOARD2_QUESTION16ICON: require("./assets/images/board2_question16icon.webp"),
  BOARD2_QUESTION16FULL: require("./assets/images/board2_question16full.webp"),
  BOARD2_QUESTION16BLANK: require("./assets/images/board2_question16blank.webp"),

  BOARD2_QUESTION17ICON: require("./assets/images/board2_question17icon.webp"),
  BOARD2_QUESTION17FULL: require("./assets/images/board2_question17full.webp"),
  BOARD2_QUESTION17BLANK: require("./assets/images/board2_question17blank.webp"),

  BOARD2_QUESTION18ICON: require("./assets/images/board2_question18icon.webp"),
  BOARD2_QUESTION18FULL: require("./assets/images/board2_question18full.webp"),
  BOARD2_QUESTION18BLANK: require("./assets/images/board2_question18blank.webp"),

  BOARD3_QUESTION1ICON: require("./assets/images/board3_question1icon.webp"),
  BOARD3_QUESTION1FULL: require("./assets/images/board3_question1full.webp"),
  BOARD3_QUESTION1BLANK: require("./assets/images/board3_question1blank.webp"),

  BOARD3_QUESTION2ICON: require("./assets/images/board3_question2icon.webp"),
  BOARD3_QUESTION2FULL: require("./assets/images/board3_question2full.webp"),
  BOARD3_QUESTION2BLANK: require("./assets/images/board3_question2blank.webp"),

  BOARD3_QUESTION3ICON: require("./assets/images/board3_question3icon.webp"),
  BOARD3_QUESTION3FULL: require("./assets/images/board3_question3full.webp"),
  BOARD3_QUESTION3BLANK: require("./assets/images/board3_question3blank.webp"),

  BOARD3_QUESTION4ICON: require("./assets/images/board3_question4icon.webp"),
  BOARD3_QUESTION4FULL: require("./assets/images/board3_question4full.webp"),
  BOARD3_QUESTION4BLANK: require("./assets/images/board3_question4blank.webp"),

  BOARD3_QUESTION5ICON: require("./assets/images/board3_question5icon.webp"),
  BOARD3_QUESTION5FULL: require("./assets/images/board3_question5full.webp"),
  BOARD3_QUESTION5BLANK: require("./assets/images/board3_question5blank.webp"),

  BOARD3_QUESTION6ICON: require("./assets/images/board3_question6icon.webp"),
  BOARD3_QUESTION6FULL: require("./assets/images/board3_question6full.webp"),
  BOARD3_QUESTION6BLANK: require("./assets/images/board3_question6blank.webp"),

  BOARD3_QUESTION7ICON: require("./assets/images/board3_question7icon.webp"),
  BOARD3_QUESTION7FULL: require("./assets/images/board3_question7full.webp"),
  BOARD3_QUESTION7BLANK: require("./assets/images/board3_question7blank.webp"),

  BOARD3_QUESTION8ICON: require("./assets/images/board3_question8icon.webp"),
  BOARD3_QUESTION8FULL: require("./assets/images/board3_question8full.webp"),
  BOARD3_QUESTION8BLANK: require("./assets/images/board3_question8blank.webp"),

  BOARD3_QUESTION9ICON: require("./assets/images/board3_question9icon.webp"),
  BOARD3_QUESTION9FULL: require("./assets/images/board3_question9full.webp"),
  BOARD3_QUESTION9BLANK: require("./assets/images/board3_question9blank.webp"),

  BOARD3_QUESTION10ICON: require("./assets/images/board3_question10icon.webp"),
  BOARD3_QUESTION10FULL: require("./assets/images/board3_question10full.webp"),
  BOARD3_QUESTION10BLANK: require("./assets/images/board3_question10blank.webp"),

  BOARD3_QUESTION11ICON: require("./assets/images/board3_question11icon.webp"),
  BOARD3_QUESTION11FULL: require("./assets/images/board3_question11full.webp"),
  BOARD3_QUESTION11BLANK: require("./assets/images/board3_question11blank.webp"),

  BOARD3_QUESTION12ICON: require("./assets/images/board3_question12icon.webp"),
  BOARD3_QUESTION12FULL: require("./assets/images/board3_question12full.webp"),
  BOARD3_QUESTION12BLANK: require("./assets/images/board3_question12blank.webp"),

  BOARD3_QUESTION13ICON: require("./assets/images/board3_question13icon.webp"),
  BOARD3_QUESTION13FULL: require("./assets/images/board3_question13full.webp"),
  BOARD3_QUESTION13BLANK: require("./assets/images/board3_question13blank.webp"),

  BOARD3_QUESTION14ICON: require("./assets/images/board3_question14icon.webp"),
  BOARD3_QUESTION14FULL: require("./assets/images/board3_question14full.webp"),
  BOARD3_QUESTION14BLANK: require("./assets/images/board3_question14blank.webp"),

  BOARD3_QUESTION15ICON: require("./assets/images/board3_question15icon.webp"),
  BOARD3_QUESTION15FULL: require("./assets/images/board3_question15full.webp"),
  BOARD3_QUESTION15BLANK: require("./assets/images/board3_question15blank.webp"),

  BOARD3_QUESTION16ICON: require("./assets/images/board3_question16icon.webp"),
  BOARD3_QUESTION16FULL: require("./assets/images/board3_question16full.webp"),
  BOARD3_QUESTION16BLANK: require("./assets/images/board3_question16blank.webp"),

  BOARD3_QUESTION17ICON: require("./assets/images/board3_question17icon.webp"),
  BOARD3_QUESTION17FULL: require("./assets/images/board3_question17full.webp"),
  BOARD3_QUESTION17BLANK: require("./assets/images/board3_question17blank.webp"),

  BOARD3_QUESTION18ICON: require("./assets/images/board3_question18icon.webp"),
  BOARD3_QUESTION18FULL: require("./assets/images/board3_question18full.webp"),
  BOARD3_QUESTION18BLANK: require("./assets/images/board3_question18blank.webp"),

  BOARD4_QUESTION1ICON: require("./assets/images/board4_question1icon.webp"),
  BOARD4_QUESTION1FULL: require("./assets/images/board4_question1full.webp"),
  BOARD4_QUESTION1BLANK: require("./assets/images/board4_question1blank.webp"),

  BOARD4_QUESTION2ICON: require("./assets/images/board4_question2icon.webp"),
  BOARD4_QUESTION2FULL: require("./assets/images/board4_question2full.webp"),
  BOARD4_QUESTION2BLANK: require("./assets/images/board4_question2blank.webp"),

  BOARD4_QUESTION3ICON: require("./assets/images/board4_question3icon.webp"),
  BOARD4_QUESTION3FULL: require("./assets/images/board4_question3full.webp"),
  BOARD4_QUESTION3BLANK: require("./assets/images/board4_question3blank.webp"),

  BOARD4_QUESTION4ICON: require("./assets/images/board4_question4icon.webp"),
  BOARD4_QUESTION4FULL: require("./assets/images/board4_question4full.webp"),
  BOARD4_QUESTION4BLANK: require("./assets/images/board4_question4blank.webp"),

  BOARD4_QUESTION5ICON: require("./assets/images/board4_question5icon.webp"),
  BOARD4_QUESTION5FULL: require("./assets/images/board4_question5full.webp"),
  BOARD4_QUESTION5BLANK: require("./assets/images/board4_question5blank.webp"),

  BOARD4_QUESTION6ICON: require("./assets/images/board4_question6icon.webp"),
  BOARD4_QUESTION6FULL: require("./assets/images/board4_question6full.webp"),
  BOARD4_QUESTION6BLANK: require("./assets/images/board4_question6blank.webp"),

  BOARD4_QUESTION7ICON: require("./assets/images/board4_question7icon.webp"),
  BOARD4_QUESTION7FULL: require("./assets/images/board4_question7full.webp"),
  BOARD4_QUESTION7BLANK: require("./assets/images/board4_question7blank.webp"),

  BOARD4_QUESTION8ICON: require("./assets/images/board4_question8icon.webp"),
  BOARD4_QUESTION8FULL: require("./assets/images/board4_question8full.webp"),
  BOARD4_QUESTION8BLANK: require("./assets/images/board4_question8blank.webp"),

  BOARD4_QUESTION9ICON: require("./assets/images/board4_question9icon.webp"),
  BOARD4_QUESTION9FULL: require("./assets/images/board4_question9full.webp"),
  BOARD4_QUESTION9BLANK: require("./assets/images/board4_question9blank.webp"),

  BOARD4_QUESTION10ICON: require("./assets/images/board4_question10icon.webp"),
  BOARD4_QUESTION10FULL: require("./assets/images/board4_question10full.webp"),
  BOARD4_QUESTION10BLANK: require("./assets/images/board4_question10blank.webp"),

  BOARD4_QUESTION11ICON: require("./assets/images/board4_question11icon.webp"),
  BOARD4_QUESTION11FULL: require("./assets/images/board4_question11full.webp"),
  BOARD4_QUESTION11BLANK: require("./assets/images/board4_question11blank.webp"),

  BOARD4_QUESTION12ICON: require("./assets/images/board4_question12icon.webp"),
  BOARD4_QUESTION12FULL: require("./assets/images/board4_question12full.webp"),
  BOARD4_QUESTION12BLANK: require("./assets/images/board4_question12blank.webp"),

  BOARD4_QUESTION13ICON: require("./assets/images/board4_question13icon.webp"),
  BOARD4_QUESTION13FULL: require("./assets/images/board4_question13full.webp"),
  BOARD4_QUESTION13BLANK: require("./assets/images/board4_question13blank.webp"),

  BOARD4_QUESTION14ICON: require("./assets/images/board4_question14icon.webp"),
  BOARD4_QUESTION14FULL: require("./assets/images/board4_question14full.webp"),
  BOARD4_QUESTION14BLANK: require("./assets/images/board4_question14blank.webp"),

  BOARD4_QUESTION15ICON: require("./assets/images/board4_question15icon.webp"),
  BOARD4_QUESTION15FULL: require("./assets/images/board4_question15full.webp"),
  BOARD4_QUESTION15BLANK: require("./assets/images/board4_question15blank.webp"),

  BOARD4_QUESTION16ICON: require("./assets/images/board4_question16icon.webp"),
  BOARD4_QUESTION16FULL: require("./assets/images/board4_question16full.webp"),
  BOARD4_QUESTION16BLANK: require("./assets/images/board4_question16blank.webp"),

  BOARD4_QUESTION17ICON: require("./assets/images/board4_question17icon.webp"),
  BOARD4_QUESTION17FULL: require("./assets/images/board4_question17full.webp"),
  BOARD4_QUESTION17BLANK: require("./assets/images/board4_question17blank.webp"),

  BOARD4_QUESTION18ICON: require("./assets/images/board4_question18icon.webp"),
  BOARD4_QUESTION18FULL: require("./assets/images/board4_question18full.webp"),
  BOARD4_QUESTION18BLANK: require("./assets/images/board4_question18blank.webp"),

  BOARD5_QUESTION1ICON: require("./assets/images/board5_question1icon.webp"),
  BOARD5_QUESTION1FULL: require("./assets/images/board5_question1full.webp"),
  BOARD5_QUESTION1BLANK: require("./assets/images/board5_question1blank.webp"),

  BOARD5_QUESTION2ICON: require("./assets/images/board5_question2icon.webp"),
  BOARD5_QUESTION2FULL: require("./assets/images/board5_question2full.webp"),
  BOARD5_QUESTION2BLANK: require("./assets/images/board5_question2blank.webp"),

  BOARD5_QUESTION3ICON: require("./assets/images/board5_question3icon.webp"),
  BOARD5_QUESTION3FULL: require("./assets/images/board5_question3full.webp"),
  BOARD5_QUESTION3BLANK: require("./assets/images/board5_question3blank.webp"),

  BOARD5_QUESTION4ICON: require("./assets/images/board5_question4icon.webp"),
  BOARD5_QUESTION4FULL: require("./assets/images/board5_question4full.webp"),
  BOARD5_QUESTION4BLANK: require("./assets/images/board5_question4blank.webp"),

  BOARD5_QUESTION5ICON: require("./assets/images/board5_question5icon.webp"),
  BOARD5_QUESTION5FULL: require("./assets/images/board5_question5full.webp"),
  BOARD5_QUESTION5BLANK: require("./assets/images/board5_question5blank.webp"),

  BOARD5_QUESTION6ICON: require("./assets/images/board5_question6icon.webp"),
  BOARD5_QUESTION6FULL: require("./assets/images/board5_question6full.webp"),
  BOARD5_QUESTION6BLANK: require("./assets/images/board5_question6blank.webp"),

  BOARD5_QUESTION7ICON: require("./assets/images/board5_question7icon.webp"),
  BOARD5_QUESTION7FULL: require("./assets/images/board5_question7full.webp"),
  BOARD5_QUESTION7BLANK: require("./assets/images/board5_question7blank.webp"),

  BOARD5_QUESTION8ICON: require("./assets/images/board5_question8icon.webp"),
  BOARD5_QUESTION8FULL: require("./assets/images/board5_question8full.webp"),
  BOARD5_QUESTION8BLANK: require("./assets/images/board5_question8blank.webp"),

  BOARD5_QUESTION9ICON: require("./assets/images/board5_question9icon.webp"),
  BOARD5_QUESTION9FULL: require("./assets/images/board5_question9full.webp"),
  BOARD5_QUESTION9BLANK: require("./assets/images/board5_question9blank.webp"),

  BOARD5_QUESTION10ICON: require("./assets/images/board5_question10icon.webp"),
  BOARD5_QUESTION10FULL: require("./assets/images/board5_question10full.webp"),
  BOARD5_QUESTION10BLANK: require("./assets/images/board5_question10blank.webp"),

  BOARD5_QUESTION11ICON: require("./assets/images/board5_question11icon.webp"),
  BOARD5_QUESTION11FULL: require("./assets/images/board5_question11full.webp"),
  BOARD5_QUESTION11BLANK: require("./assets/images/board5_question11blank.webp"),

  BOARD5_QUESTION12ICON: require("./assets/images/board5_question12icon.webp"),
  BOARD5_QUESTION12FULL: require("./assets/images/board5_question12full.webp"),
  BOARD5_QUESTION12BLANK: require("./assets/images/board5_question12blank.webp"),

  BOARD5_QUESTION13ICON: require("./assets/images/board5_question13icon.webp"),
  BOARD5_QUESTION13FULL: require("./assets/images/board5_question13full.webp"),
  BOARD5_QUESTION13BLANK: require("./assets/images/board5_question13blank.webp"),

  BOARD5_QUESTION14ICON: require("./assets/images/board5_question14icon.webp"),
  BOARD5_QUESTION14FULL: require("./assets/images/board5_question14full.webp"),
  BOARD5_QUESTION14BLANK: require("./assets/images/board5_question14blank.webp"),

  BOARD5_QUESTION15ICON: require("./assets/images/board5_question15icon.webp"),
  BOARD5_QUESTION15FULL: require("./assets/images/board5_question15full.webp"),
  BOARD5_QUESTION15BLANK: require("./assets/images/board5_question15blank.webp"),

  BOARD5_QUESTION16ICON: require("./assets/images/board5_question16icon.webp"),
  BOARD5_QUESTION16FULL: require("./assets/images/board5_question16full.webp"),
  BOARD5_QUESTION16BLANK: require("./assets/images/board5_question16blank.webp"),

  BOARD5_QUESTION17ICON: require("./assets/images/board5_question17icon.webp"),
  BOARD5_QUESTION17FULL: require("./assets/images/board5_question17full.webp"),
  BOARD5_QUESTION17BLANK: require("./assets/images/board5_question17blank.webp"),

  BOARD5_QUESTION18ICON: require("./assets/images/board5_question18icon.webp"),
  BOARD5_QUESTION18FULL: require("./assets/images/board5_question18full.webp"),
  BOARD5_QUESTION18BLANK: require("./assets/images/board5_question18blank.webp"),

  BOARD6_QUESTION1ICON: require("./assets/images/board6_question1icon.webp"),
  BOARD6_QUESTION1FULL: require("./assets/images/board6_question1full.webp"),
  BOARD6_QUESTION1BLANK: require("./assets/images/board6_question1blank.webp"),

  BOARD6_QUESTION2ICON: require("./assets/images/board6_question2icon.webp"),
  BOARD6_QUESTION2FULL: require("./assets/images/board6_question2full.webp"),
  BOARD6_QUESTION2BLANK: require("./assets/images/board6_question2blank.webp"),

  BOARD6_QUESTION3ICON: require("./assets/images/board6_question3icon.webp"),
  BOARD6_QUESTION3FULL: require("./assets/images/board6_question3full.webp"),
  BOARD6_QUESTION3BLANK: require("./assets/images/board6_question3blank.webp"),

  BOARD6_QUESTION4ICON: require("./assets/images/board6_question4icon.webp"),
  BOARD6_QUESTION4FULL: require("./assets/images/board6_question4full.webp"),
  BOARD6_QUESTION4BLANK: require("./assets/images/board6_question4blank.webp"),

  BOARD6_QUESTION5ICON: require("./assets/images/board6_question5icon.webp"),
  BOARD6_QUESTION5FULL: require("./assets/images/board6_question5full.webp"),
  BOARD6_QUESTION5BLANK: require("./assets/images/board6_question5blank.webp"),

  BOARD6_QUESTION6ICON: require("./assets/images/board6_question6icon.webp"),
  BOARD6_QUESTION6FULL: require("./assets/images/board6_question6full.webp"),
  BOARD6_QUESTION6BLANK: require("./assets/images/board6_question6blank.webp"),

  BOARD6_QUESTION7ICON: require("./assets/images/board6_question7icon.webp"),
  BOARD6_QUESTION7FULL: require("./assets/images/board6_question7full.webp"),
  BOARD6_QUESTION7BLANK: require("./assets/images/board6_question7blank.webp"),

  BOARD6_QUESTION8ICON: require("./assets/images/board6_question8icon.webp"),
  BOARD6_QUESTION8FULL: require("./assets/images/board6_question8full.webp"),
  BOARD6_QUESTION8BLANK: require("./assets/images/board6_question8blank.webp"),

  BOARD6_QUESTION9ICON: require("./assets/images/board6_question9icon.webp"),
  BOARD6_QUESTION9FULL: require("./assets/images/board6_question9full.webp"),
  BOARD6_QUESTION9BLANK: require("./assets/images/board6_question9blank.webp"),

  BOARD6_QUESTION10ICON: require("./assets/images/board6_question10icon.webp"),
  BOARD6_QUESTION10FULL: require("./assets/images/board6_question10full.webp"),
  BOARD6_QUESTION10BLANK: require("./assets/images/board6_question10blank.webp"),

  BOARD6_QUESTION11ICON: require("./assets/images/board6_question11icon.webp"),
  BOARD6_QUESTION11FULL: require("./assets/images/board6_question11full.webp"),
  BOARD6_QUESTION11BLANK: require("./assets/images/board6_question11blank.webp"),

  BOARD6_QUESTION12ICON: require("./assets/images/board6_question12icon.webp"),
  BOARD6_QUESTION12FULL: require("./assets/images/board6_question12full.webp"),
  BOARD6_QUESTION12BLANK: require("./assets/images/board6_question12blank.webp"),

  BOARD6_QUESTION13ICON: require("./assets/images/board6_question13icon.webp"),
  BOARD6_QUESTION13FULL: require("./assets/images/board6_question13full.webp"),
  BOARD6_QUESTION13BLANK: require("./assets/images/board6_question13blank.webp"),

  BOARD6_QUESTION14ICON: require("./assets/images/board6_question14icon.webp"),
  BOARD6_QUESTION14FULL: require("./assets/images/board6_question14full.webp"),
  BOARD6_QUESTION14BLANK: require("./assets/images/board6_question14blank.webp"),

  BOARD6_QUESTION15ICON: require("./assets/images/board6_question15icon.webp"),
  BOARD6_QUESTION15FULL: require("./assets/images/board6_question15full.webp"),
  BOARD6_QUESTION15BLANK: require("./assets/images/board6_question15blank.webp"),

  BOARD6_QUESTION16ICON: require("./assets/images/board6_question16icon.webp"),
  BOARD6_QUESTION16FULL: require("./assets/images/board6_question16full.webp"),
  BOARD6_QUESTION16BLANK: require("./assets/images/board6_question16blank.webp"),

  BOARD6_QUESTION17ICON: require("./assets/images/board6_question17icon.webp"),
  BOARD6_QUESTION17FULL: require("./assets/images/board6_question17full.webp"),
  BOARD6_QUESTION17BLANK: require("./assets/images/board6_question17blank.webp"),

  BOARD6_QUESTION18ICON: require("./assets/images/board6_question18icon.webp"),
  BOARD6_QUESTION18FULL: require("./assets/images/board6_question18full.webp"),
  BOARD6_QUESTION18BLANK: require("./assets/images/board6_question18blank.webp"),

  BOARD7_QUESTION1ICON: require("./assets/images/board7_question1icon.webp"),
  BOARD7_QUESTION1FULL: require("./assets/images/board7_question1full.webp"),
  BOARD7_QUESTION1BLANK: require("./assets/images/board7_question1blank.webp"),

  BOARD7_QUESTION2ICON: require("./assets/images/board7_question2icon.webp"),
  BOARD7_QUESTION2FULL: require("./assets/images/board7_question2full.webp"),
  BOARD7_QUESTION2BLANK: require("./assets/images/board7_question2blank.webp"),

  BOARD7_QUESTION3ICON: require("./assets/images/board7_question3icon.webp"),
  BOARD7_QUESTION3FULL: require("./assets/images/board7_question3full.webp"),
  BOARD7_QUESTION3BLANK: require("./assets/images/board7_question3blank.webp"),

  BOARD7_QUESTION4ICON: require("./assets/images/board7_question4icon.webp"),
  BOARD7_QUESTION4FULL: require("./assets/images/board7_question4full.webp"),
  BOARD7_QUESTION4BLANK: require("./assets/images/board7_question4blank.webp"),

  BOARD7_QUESTION5ICON: require("./assets/images/board7_question5icon.webp"),
  BOARD7_QUESTION5FULL: require("./assets/images/board7_question5full.webp"),
  BOARD7_QUESTION5BLANK: require("./assets/images/board7_question5blank.webp"),

  BOARD7_QUESTION6ICON: require("./assets/images/board7_question6icon.webp"),
  BOARD7_QUESTION6FULL: require("./assets/images/board7_question6full.webp"),
  BOARD7_QUESTION6BLANK: require("./assets/images/board7_question6blank.webp"),

  BOARD7_QUESTION7ICON: require("./assets/images/board7_question7icon.webp"),
  BOARD7_QUESTION7FULL: require("./assets/images/board7_question7full.webp"),
  BOARD7_QUESTION7BLANK: require("./assets/images/board7_question7blank.webp"),

  BOARD7_QUESTION8ICON: require("./assets/images/board7_question8icon.webp"),
  BOARD7_QUESTION8FULL: require("./assets/images/board7_question8full.webp"),
  BOARD7_QUESTION8BLANK: require("./assets/images/board7_question8blank.webp"),

  BOARD7_QUESTION9ICON: require("./assets/images/board7_question9icon.webp"),
  BOARD7_QUESTION9FULL: require("./assets/images/board7_question9full.webp"),
  BOARD7_QUESTION9BLANK: require("./assets/images/board7_question9blank.webp"),

  BOARD7_QUESTION10ICON: require("./assets/images/board7_question10icon.webp"),
  BOARD7_QUESTION10FULL: require("./assets/images/board7_question10full.webp"),
  BOARD7_QUESTION10BLANK: require("./assets/images/board7_question10blank.webp"),

  BOARD7_QUESTION11ICON: require("./assets/images/board7_question11icon.webp"),
  BOARD7_QUESTION11FULL: require("./assets/images/board7_question11full.webp"),
  BOARD7_QUESTION11BLANK: require("./assets/images/board7_question11blank.webp"),

  BOARD7_QUESTION12ICON: require("./assets/images/board7_question12icon.webp"),
  BOARD7_QUESTION12FULL: require("./assets/images/board7_question12full.webp"),
  BOARD7_QUESTION12BLANK: require("./assets/images/board7_question12blank.webp"),

  BOARD7_QUESTION13ICON: require("./assets/images/board7_question13icon.webp"),
  BOARD7_QUESTION13FULL: require("./assets/images/board7_question13full.webp"),
  BOARD7_QUESTION13BLANK: require("./assets/images/board7_question13blank.webp"),

  BOARD7_QUESTION14ICON: require("./assets/images/board7_question14icon.webp"),
  BOARD7_QUESTION14FULL: require("./assets/images/board7_question14full.webp"),
  BOARD7_QUESTION14BLANK: require("./assets/images/board7_question14blank.webp"),

  BOARD7_QUESTION15ICON: require("./assets/images/board7_question15icon.webp"),
  BOARD7_QUESTION15FULL: require("./assets/images/board7_question15full.webp"),
  BOARD7_QUESTION15BLANK: require("./assets/images/board7_question15blank.webp"),

  BOARD7_QUESTION16ICON: require("./assets/images/board7_question16icon.webp"),
  BOARD7_QUESTION16FULL: require("./assets/images/board7_question16full.webp"),
  BOARD7_QUESTION16BLANK: require("./assets/images/board7_question16blank.webp"),

  BOARD7_QUESTION17ICON: require("./assets/images/board7_question17icon.webp"),
  BOARD7_QUESTION17FULL: require("./assets/images/board7_question17full.webp"),
  BOARD7_QUESTION17BLANK: require("./assets/images/board7_question17blank.webp"),

  BOARD7_QUESTION18ICON: require("./assets/images/board7_question18icon.webp"),
  BOARD7_QUESTION18FULL: require("./assets/images/board7_question18full.webp"),
  BOARD7_QUESTION18BLANK: require("./assets/images/board7_question18blank.webp"),

  BOARD8_QUESTION1ICON: require("./assets/images/board8_question1icon.webp"),
  BOARD8_QUESTION1FULL: require("./assets/images/board8_question1full.webp"),
  BOARD8_QUESTION1BLANK: require("./assets/images/board8_question1blank.webp"),

  BOARD8_QUESTION2ICON: require("./assets/images/board8_question2icon.webp"),
  BOARD8_QUESTION2FULL: require("./assets/images/board8_question2full.webp"),
  BOARD8_QUESTION2BLANK: require("./assets/images/board8_question2blank.webp"),

  BOARD8_QUESTION3ICON: require("./assets/images/board8_question3icon.webp"),
  BOARD8_QUESTION3FULL: require("./assets/images/board8_question3full.webp"),
  BOARD8_QUESTION3BLANK: require("./assets/images/board8_question3blank.webp"),

  BOARD8_QUESTION4ICON: require("./assets/images/board8_question4icon.webp"),
  BOARD8_QUESTION4FULL: require("./assets/images/board8_question4full.webp"),
  BOARD8_QUESTION4BLANK: require("./assets/images/board8_question4blank.webp"),

  BOARD8_QUESTION5ICON: require("./assets/images/board8_question5icon.webp"),
  BOARD8_QUESTION5FULL: require("./assets/images/board8_question5full.webp"),
  BOARD8_QUESTION5BLANK: require("./assets/images/board8_question5blank.webp"),

  BOARD8_QUESTION6ICON: require("./assets/images/board8_question6icon.webp"),
  BOARD8_QUESTION6FULL: require("./assets/images/board8_question6full.webp"),
  BOARD8_QUESTION6BLANK: require("./assets/images/board8_question6blank.webp"),

  BOARD8_QUESTION7ICON: require("./assets/images/board8_question7icon.webp"),
  BOARD8_QUESTION7FULL: require("./assets/images/board8_question7full.webp"),
  BOARD8_QUESTION7BLANK: require("./assets/images/board8_question7blank.webp"),

  BOARD8_QUESTION8ICON: require("./assets/images/board8_question8icon.webp"),
  BOARD8_QUESTION8FULL: require("./assets/images/board8_question8full.webp"),
  BOARD8_QUESTION8BLANK: require("./assets/images/board8_question8blank.webp"),

  BOARD8_QUESTION9ICON: require("./assets/images/board8_question9icon.webp"),
  BOARD8_QUESTION9FULL: require("./assets/images/board8_question9full.webp"),
  BOARD8_QUESTION9BLANK: require("./assets/images/board8_question9blank.webp"),

  BOARD8_QUESTION10ICON: require("./assets/images/board8_question10icon.webp"),
  BOARD8_QUESTION10FULL: require("./assets/images/board8_question10full.webp"),
  BOARD8_QUESTION10BLANK: require("./assets/images/board8_question10blank.webp"),

  BOARD8_QUESTION11ICON: require("./assets/images/board8_question11icon.webp"),
  BOARD8_QUESTION11FULL: require("./assets/images/board8_question11full.webp"),
  BOARD8_QUESTION11BLANK: require("./assets/images/board8_question11blank.webp"),

  BOARD8_QUESTION12ICON: require("./assets/images/board8_question12icon.webp"),
  BOARD8_QUESTION12FULL: require("./assets/images/board8_question12full.webp"),
  BOARD8_QUESTION12BLANK: require("./assets/images/board8_question12blank.webp"),

  BOARD8_QUESTION13ICON: require("./assets/images/board8_question13icon.webp"),
  BOARD8_QUESTION13FULL: require("./assets/images/board8_question13full.webp"),
  BOARD8_QUESTION13BLANK: require("./assets/images/board8_question13blank.webp"),

  BOARD8_QUESTION14ICON: require("./assets/images/board8_question14icon.webp"),
  BOARD8_QUESTION14FULL: require("./assets/images/board8_question14full.webp"),
  BOARD8_QUESTION14BLANK: require("./assets/images/board8_question14blank.webp"),

  BOARD8_QUESTION15ICON: require("./assets/images/board8_question15icon.webp"),
  BOARD8_QUESTION15FULL: require("./assets/images/board8_question15full.webp"),
  BOARD8_QUESTION15BLANK: require("./assets/images/board8_question15blank.webp"),

  BOARD8_QUESTION16ICON: require("./assets/images/board8_question16icon.webp"),
  BOARD8_QUESTION16FULL: require("./assets/images/board8_question16full.webp"),
  BOARD8_QUESTION16BLANK: require("./assets/images/board8_question16blank.webp"),

  BOARD8_QUESTION17ICON: require("./assets/images/board8_question17icon.webp"),
  BOARD8_QUESTION17FULL: require("./assets/images/board8_question17full.webp"),
  BOARD8_QUESTION17BLANK: require("./assets/images/board8_question17blank.webp"),

  BOARD8_QUESTION18ICON: require("./assets/images/board8_question18icon.webp"),
  BOARD8_QUESTION18FULL: require("./assets/images/board8_question18full.webp"),
  BOARD8_QUESTION18BLANK: require("./assets/images/board8_question18blank.webp"),

  BOARD9_QUESTION1ICON: require("./assets/images/board9_question1icon.webp"),
  BOARD9_QUESTION1FULL: require("./assets/images/board9_question1full.webp"),
  BOARD9_QUESTION1BLANK: require("./assets/images/board9_question1blank.webp"),

  BOARD9_QUESTION2ICON: require("./assets/images/board9_question2icon.webp"),
  BOARD9_QUESTION2FULL: require("./assets/images/board9_question2full.webp"),
  BOARD9_QUESTION2BLANK: require("./assets/images/board9_question2blank.webp"),

  BOARD9_QUESTION3ICON: require("./assets/images/board9_question3icon.webp"),
  BOARD9_QUESTION3FULL: require("./assets/images/board9_question3full.webp"),
  BOARD9_QUESTION3BLANK: require("./assets/images/board9_question3blank.webp"),

  BOARD9_QUESTION4ICON: require("./assets/images/board9_question4icon.webp"),
  BOARD9_QUESTION4FULL: require("./assets/images/board9_question4full.webp"),
  BOARD9_QUESTION4BLANK: require("./assets/images/board9_question4blank.webp"),

  BOARD9_QUESTION5ICON: require("./assets/images/board9_question5icon.webp"),
  BOARD9_QUESTION5FULL: require("./assets/images/board9_question5full.webp"),
  BOARD9_QUESTION5BLANK: require("./assets/images/board9_question5blank.webp"),

  BOARD9_QUESTION6ICON: require("./assets/images/board9_question6icon.webp"),
  BOARD9_QUESTION6FULL: require("./assets/images/board9_question6full.webp"),
  BOARD9_QUESTION6BLANK: require("./assets/images/board9_question6blank.webp"),

  BOARD9_QUESTION7ICON: require("./assets/images/board9_question7icon.webp"),
  BOARD9_QUESTION7FULL: require("./assets/images/board9_question7full.webp"),
  BOARD9_QUESTION7BLANK: require("./assets/images/board9_question7blank.webp"),

  BOARD9_QUESTION8ICON: require("./assets/images/board9_question8icon.webp"),
  BOARD9_QUESTION8FULL: require("./assets/images/board9_question8full.webp"),
  BOARD9_QUESTION8BLANK: require("./assets/images/board9_question8blank.webp"),

  BOARD9_QUESTION9ICON: require("./assets/images/board9_question9icon.webp"),
  BOARD9_QUESTION9FULL: require("./assets/images/board9_question9full.webp"),
  BOARD9_QUESTION9BLANK: require("./assets/images/board9_question9blank.webp"),

  BOARD9_QUESTION10ICON: require("./assets/images/board9_question10icon.webp"),
  BOARD9_QUESTION10FULL: require("./assets/images/board9_question10full.webp"),
  BOARD9_QUESTION10BLANK: require("./assets/images/board9_question10blank.webp"),

  BOARD9_QUESTION11ICON: require("./assets/images/board9_question11icon.webp"),
  BOARD9_QUESTION11FULL: require("./assets/images/board9_question11full.webp"),
  BOARD9_QUESTION11BLANK: require("./assets/images/board9_question11blank.webp"),

  BOARD9_QUESTION12ICON: require("./assets/images/board9_question12icon.webp"),
  BOARD9_QUESTION12FULL: require("./assets/images/board9_question12full.webp"),
  BOARD9_QUESTION12BLANK: require("./assets/images/board9_question12blank.webp"),

  BOARD9_QUESTION13ICON: require("./assets/images/board9_question13icon.webp"),
  BOARD9_QUESTION13FULL: require("./assets/images/board9_question13full.webp"),
  BOARD9_QUESTION13BLANK: require("./assets/images/board9_question13blank.webp"),

  BOARD9_QUESTION14ICON: require("./assets/images/board9_question14icon.webp"),
  BOARD9_QUESTION14FULL: require("./assets/images/board9_question14full.webp"),
  BOARD9_QUESTION14BLANK: require("./assets/images/board9_question14blank.webp"),

  BOARD9_QUESTION15ICON: require("./assets/images/board9_question15icon.webp"),
  BOARD9_QUESTION15FULL: require("./assets/images/board9_question15full.webp"),
  BOARD9_QUESTION15BLANK: require("./assets/images/board9_question15blank.webp"),

  BOARD9_QUESTION16ICON: require("./assets/images/board9_question16icon.webp"),
  BOARD9_QUESTION16FULL: require("./assets/images/board9_question16full.webp"),
  BOARD9_QUESTION16BLANK: require("./assets/images/board9_question16blank.webp"),

  BOARD9_QUESTION17ICON: require("./assets/images/board9_question17icon.webp"),
  BOARD9_QUESTION17FULL: require("./assets/images/board9_question17full.webp"),
  BOARD9_QUESTION17BLANK: require("./assets/images/board9_question17blank.webp"),

  BOARD9_QUESTION18ICON: require("./assets/images/board9_question18icon.webp"),
  BOARD9_QUESTION18FULL: require("./assets/images/board9_question18full.webp"),
  BOARD9_QUESTION18BLANK: require("./assets/images/board9_question18blank.webp"),

  BOARD10_QUESTION1ICON: require("./assets/images/board10_question1icon.webp"),
  BOARD10_QUESTION1FULL: require("./assets/images/board10_question1full.webp"),
  BOARD10_QUESTION1BLANK: require("./assets/images/board10_question1blank.webp"),

  BOARD10_QUESTION2ICON: require("./assets/images/board10_question2icon.webp"),
  BOARD10_QUESTION2FULL: require("./assets/images/board10_question2full.webp"),
  BOARD10_QUESTION2BLANK: require("./assets/images/board10_question2blank.webp"),

  BOARD10_QUESTION3ICON: require("./assets/images/board10_question3icon.webp"),
  BOARD10_QUESTION3FULL: require("./assets/images/board10_question3full.webp"),
  BOARD10_QUESTION3BLANK: require("./assets/images/board10_question3blank.webp"),

  BOARD10_QUESTION4ICON: require("./assets/images/board10_question4icon.webp"),
  BOARD10_QUESTION4FULL: require("./assets/images/board10_question4full.webp"),
  BOARD10_QUESTION4BLANK: require("./assets/images/board10_question4blank.webp"),

  BOARD10_QUESTION5ICON: require("./assets/images/board10_question5icon.webp"),
  BOARD10_QUESTION5FULL: require("./assets/images/board10_question5full.webp"),
  BOARD10_QUESTION5BLANK: require("./assets/images/board10_question5blank.webp"),

  BOARD10_QUESTION6ICON: require("./assets/images/board10_question6icon.webp"),
  BOARD10_QUESTION6FULL: require("./assets/images/board10_question6full.webp"),
  BOARD10_QUESTION6BLANK: require("./assets/images/board10_question6blank.webp"),

  BOARD10_QUESTION7ICON: require("./assets/images/board10_question7icon.webp"),
  BOARD10_QUESTION7FULL: require("./assets/images/board10_question7full.webp"),
  BOARD10_QUESTION7BLANK: require("./assets/images/board10_question7blank.webp"),

  BOARD10_QUESTION8ICON: require("./assets/images/board10_question8icon.webp"),
  BOARD10_QUESTION8FULL: require("./assets/images/board10_question8full.webp"),
  BOARD10_QUESTION8BLANK: require("./assets/images/board10_question8blank.webp"),

  BOARD10_QUESTION9ICON: require("./assets/images/board10_question9icon.webp"),
  BOARD10_QUESTION9FULL: require("./assets/images/board10_question9full.webp"),
  BOARD10_QUESTION9BLANK: require("./assets/images/board10_question9blank.webp"),

  BOARD10_QUESTION10ICON: require("./assets/images/board10_question10icon.webp"),
  BOARD10_QUESTION10FULL: require("./assets/images/board10_question10full.webp"),
  BOARD10_QUESTION10BLANK: require("./assets/images/board10_question10blank.webp"),

  BOARD10_QUESTION11ICON: require("./assets/images/board10_question11icon.webp"),
  BOARD10_QUESTION11FULL: require("./assets/images/board10_question11full.webp"),
  BOARD10_QUESTION11BLANK: require("./assets/images/board10_question11blank.webp"),

  BOARD10_QUESTION12ICON: require("./assets/images/board10_question12icon.webp"),
  BOARD10_QUESTION12FULL: require("./assets/images/board10_question12full.webp"),
  BOARD10_QUESTION12BLANK: require("./assets/images/board10_question12blank.webp"),

  BOARD10_QUESTION13ICON: require("./assets/images/board10_question13icon.webp"),
  BOARD10_QUESTION13FULL: require("./assets/images/board10_question13full.webp"),
  BOARD10_QUESTION13BLANK: require("./assets/images/board10_question13blank.webp"),

  BOARD10_QUESTION14ICON: require("./assets/images/board10_question14icon.webp"),
  BOARD10_QUESTION14FULL: require("./assets/images/board10_question14full.webp"),
  BOARD10_QUESTION14BLANK: require("./assets/images/board10_question14blank.webp"),

  BOARD10_QUESTION15ICON: require("./assets/images/board10_question15icon.webp"),
  BOARD10_QUESTION15FULL: require("./assets/images/board10_question15full.webp"),
  BOARD10_QUESTION15BLANK: require("./assets/images/board10_question15blank.webp"),

  BOARD10_QUESTION16ICON: require("./assets/images/board10_question16icon.webp"),
  BOARD10_QUESTION16FULL: require("./assets/images/board10_question16full.webp"),
  BOARD10_QUESTION16BLANK: require("./assets/images/board10_question16blank.webp"),

  BOARD10_QUESTION17ICON: require("./assets/images/board10_question17icon.webp"),
  BOARD10_QUESTION17FULL: require("./assets/images/board10_question17full.webp"),
  BOARD10_QUESTION17BLANK: require("./assets/images/board10_question17blank.webp"),

  BOARD10_QUESTION18ICON: require("./assets/images/board10_question18icon.webp"),
  BOARD10_QUESTION18FULL: require("./assets/images/board10_question18full.webp"),
  BOARD10_QUESTION18BLANK: require("./assets/images/board10_question18blank.webp"),

  BOARD11_QUESTION1ICON: require("./assets/images/board11_question1icon.webp"),
  BOARD11_QUESTION1FULL: require("./assets/images/board11_question1full.webp"),
  BOARD11_QUESTION1BLANK: require("./assets/images/board11_question1blank.webp"),

  BOARD11_QUESTION2ICON: require("./assets/images/board11_question2icon.webp"),
  BOARD11_QUESTION2FULL: require("./assets/images/board11_question2full.webp"),
  BOARD11_QUESTION2BLANK: require("./assets/images/board11_question2blank.webp"),

  BOARD11_QUESTION3ICON: require("./assets/images/board11_question3icon.webp"),
  BOARD11_QUESTION3FULL: require("./assets/images/board11_question3full.webp"),
  BOARD11_QUESTION3BLANK: require("./assets/images/board11_question3blank.webp"),

  BOARD11_QUESTION4ICON: require("./assets/images/board11_question4icon.webp"),
  BOARD11_QUESTION4FULL: require("./assets/images/board11_question4full.webp"),
  BOARD11_QUESTION4BLANK: require("./assets/images/board11_question4blank.webp"),

  BOARD11_QUESTION5ICON: require("./assets/images/board11_question5icon.webp"),
  BOARD11_QUESTION5FULL: require("./assets/images/board11_question5full.webp"),
  BOARD11_QUESTION5BLANK: require("./assets/images/board11_question5blank.webp"),

  BOARD11_QUESTION6ICON: require("./assets/images/board11_question6icon.webp"),
  BOARD11_QUESTION6FULL: require("./assets/images/board11_question6full.webp"),
  BOARD11_QUESTION6BLANK: require("./assets/images/board11_question6blank.webp"),

  BOARD11_QUESTION7ICON: require("./assets/images/board11_question7icon.webp"),
  BOARD11_QUESTION7FULL: require("./assets/images/board11_question7full.webp"),
  BOARD11_QUESTION7BLANK: require("./assets/images/board11_question7blank.webp"),

  BOARD11_QUESTION8ICON: require("./assets/images/board11_question8icon.webp"),
  BOARD11_QUESTION8FULL: require("./assets/images/board11_question8full.webp"),
  BOARD11_QUESTION8BLANK: require("./assets/images/board11_question8blank.webp"),

  BOARD11_QUESTION9ICON: require("./assets/images/board11_question9icon.webp"),
  BOARD11_QUESTION9FULL: require("./assets/images/board11_question9full.webp"),
  BOARD11_QUESTION9BLANK: require("./assets/images/board11_question9blank.webp"),

  BOARD11_QUESTION10ICON: require("./assets/images/board11_question10icon.webp"),
  BOARD11_QUESTION10FULL: require("./assets/images/board11_question10full.webp"),
  BOARD11_QUESTION10BLANK: require("./assets/images/board11_question10blank.webp"),

  BOARD11_QUESTION11ICON: require("./assets/images/board11_question11icon.webp"),
  BOARD11_QUESTION11FULL: require("./assets/images/board11_question11full.webp"),
  BOARD11_QUESTION11BLANK: require("./assets/images/board11_question11blank.webp"),

  BOARD11_QUESTION12ICON: require("./assets/images/board11_question12icon.webp"),
  BOARD11_QUESTION12FULL: require("./assets/images/board11_question12full.webp"),
  BOARD11_QUESTION12BLANK: require("./assets/images/board11_question12blank.webp"),

  BOARD11_QUESTION13ICON: require("./assets/images/board11_question13icon.webp"),
  BOARD11_QUESTION13FULL: require("./assets/images/board11_question13full.webp"),
  BOARD11_QUESTION13BLANK: require("./assets/images/board11_question13blank.webp"),

  BOARD11_QUESTION14ICON: require("./assets/images/board11_question14icon.webp"),
  BOARD11_QUESTION14FULL: require("./assets/images/board11_question14full.webp"),
  BOARD11_QUESTION14BLANK: require("./assets/images/board11_question14blank.webp"),

  BOARD11_QUESTION15ICON: require("./assets/images/board11_question15icon.webp"),
  BOARD11_QUESTION15FULL: require("./assets/images/board11_question15full.webp"),
  BOARD11_QUESTION15BLANK: require("./assets/images/board11_question15blank.webp"),

  BOARD11_QUESTION16ICON: require("./assets/images/board11_question16icon.webp"),
  BOARD11_QUESTION16FULL: require("./assets/images/board11_question16full.webp"),
  BOARD11_QUESTION16BLANK: require("./assets/images/board11_question16blank.webp"),

  BOARD11_QUESTION17ICON: require("./assets/images/board11_question17icon.webp"),
  BOARD11_QUESTION17FULL: require("./assets/images/board11_question17full.webp"),
  BOARD11_QUESTION17BLANK: require("./assets/images/board11_question17blank.webp"),

  BOARD11_QUESTION18ICON: require("./assets/images/board11_question18icon.webp"),
  BOARD11_QUESTION18FULL: require("./assets/images/board11_question18full.webp"),
  BOARD11_QUESTION18BLANK: require("./assets/images/board11_question18blank.webp"),

  BOARD12_QUESTION1ICON: require("./assets/images/board12_question1icon.webp"),
  BOARD12_QUESTION1FULL: require("./assets/images/board12_question1full.webp"),
  BOARD12_QUESTION1BLANK: require("./assets/images/board12_question1blank.webp"),

  BOARD12_QUESTION2ICON: require("./assets/images/board12_question2icon.webp"),
  BOARD12_QUESTION2FULL: require("./assets/images/board12_question2full.webp"),
  BOARD12_QUESTION2BLANK: require("./assets/images/board12_question2blank.webp"),

  BOARD12_QUESTION3ICON: require("./assets/images/board12_question3icon.webp"),
  BOARD12_QUESTION3FULL: require("./assets/images/board12_question3full.webp"),
  BOARD12_QUESTION3BLANK: require("./assets/images/board12_question3blank.webp"),

  BOARD12_QUESTION4ICON: require("./assets/images/board12_question4icon.webp"),
  BOARD12_QUESTION4FULL: require("./assets/images/board12_question4full.webp"),
  BOARD12_QUESTION4BLANK: require("./assets/images/board12_question4blank.webp"),

  BOARD12_QUESTION5ICON: require("./assets/images/board12_question5icon.webp"),
  BOARD12_QUESTION5FULL: require("./assets/images/board12_question5full.webp"),
  BOARD12_QUESTION5BLANK: require("./assets/images/board12_question5blank.webp"),

  BOARD12_QUESTION6ICON: require("./assets/images/board12_question6icon.webp"),
  BOARD12_QUESTION6FULL: require("./assets/images/board12_question6full.webp"),
  BOARD12_QUESTION6BLANK: require("./assets/images/board12_question6blank.webp"),

  BOARD12_QUESTION7ICON: require("./assets/images/board12_question7icon.webp"),
  BOARD12_QUESTION7FULL: require("./assets/images/board12_question7full.webp"),
  BOARD12_QUESTION7BLANK: require("./assets/images/board12_question7blank.webp"),

  BOARD12_QUESTION8ICON: require("./assets/images/board12_question8icon.webp"),
  BOARD12_QUESTION8FULL: require("./assets/images/board12_question8full.webp"),
  BOARD12_QUESTION8BLANK: require("./assets/images/board12_question8blank.webp"),

  BOARD12_QUESTION9ICON: require("./assets/images/board12_question9icon.webp"),
  BOARD12_QUESTION9FULL: require("./assets/images/board12_question9full.webp"),
  BOARD12_QUESTION9BLANK: require("./assets/images/board12_question9blank.webp"),

  BOARD12_QUESTION10ICON: require("./assets/images/board12_question10icon.webp"),
  BOARD12_QUESTION10FULL: require("./assets/images/board12_question10full.webp"),
  BOARD12_QUESTION10BLANK: require("./assets/images/board12_question10blank.webp"),

  BOARD12_QUESTION11ICON: require("./assets/images/board12_question11icon.webp"),
  BOARD12_QUESTION11FULL: require("./assets/images/board12_question11full.webp"),
  BOARD12_QUESTION11BLANK: require("./assets/images/board12_question11blank.webp"),

  BOARD12_QUESTION12ICON: require("./assets/images/board12_question12icon.webp"),
  BOARD12_QUESTION12FULL: require("./assets/images/board12_question12full.webp"),
  BOARD12_QUESTION12BLANK: require("./assets/images/board12_question12blank.webp"),

  BOARD12_QUESTION13ICON: require("./assets/images/board12_question13icon.webp"),
  BOARD12_QUESTION13FULL: require("./assets/images/board12_question13full.webp"),
  BOARD12_QUESTION13BLANK: require("./assets/images/board12_question13blank.webp"),

  BOARD12_QUESTION14ICON: require("./assets/images/board12_question14icon.webp"),
  BOARD12_QUESTION14FULL: require("./assets/images/board12_question14full.webp"),
  BOARD12_QUESTION14BLANK: require("./assets/images/board12_question14blank.webp"),

  BOARD12_QUESTION15ICON: require("./assets/images/board12_question15icon.webp"),
  BOARD12_QUESTION15FULL: require("./assets/images/board12_question15full.webp"),
  BOARD12_QUESTION15BLANK: require("./assets/images/board12_question15blank.webp"),

  BOARD12_QUESTION16ICON: require("./assets/images/board12_question16icon.webp"),
  BOARD12_QUESTION16FULL: require("./assets/images/board12_question16full.webp"),
  BOARD12_QUESTION16BLANK: require("./assets/images/board12_question16blank.webp"),

  BOARD12_QUESTION17ICON: require("./assets/images/board12_question17icon.webp"),
  BOARD12_QUESTION17FULL: require("./assets/images/board12_question17full.webp"),
  BOARD12_QUESTION17BLANK: require("./assets/images/board12_question17blank.webp"),

  BOARD12_QUESTION18ICON: require("./assets/images/board12_question18icon.webp"),
  BOARD12_QUESTION18FULL: require("./assets/images/board12_question18full.webp"),
  BOARD12_QUESTION18BLANK: require("./assets/images/board12_question18blank.webp"),

  BOARD13_QUESTION1ICON: require("./assets/images/board13_question1icon.webp"),
  BOARD13_QUESTION1FULL: require("./assets/images/board13_question1full.webp"),
  BOARD13_QUESTION1BLANK: require("./assets/images/board13_question1blank.webp"),

  BOARD13_QUESTION2ICON: require("./assets/images/board13_question2icon.webp"),
  BOARD13_QUESTION2FULL: require("./assets/images/board13_question2full.webp"),
  BOARD13_QUESTION2BLANK: require("./assets/images/board13_question2blank.webp"),

  BOARD13_QUESTION3ICON: require("./assets/images/board13_question3icon.webp"),
  BOARD13_QUESTION3FULL: require("./assets/images/board13_question3full.webp"),
  BOARD13_QUESTION3BLANK: require("./assets/images/board13_question3blank.webp"),

  BOARD13_QUESTION4ICON: require("./assets/images/board13_question4icon.webp"),
  BOARD13_QUESTION4FULL: require("./assets/images/board13_question4full.webp"),
  BOARD13_QUESTION4BLANK: require("./assets/images/board13_question4blank.webp"),

  BOARD13_QUESTION5ICON: require("./assets/images/board13_question5icon.webp"),
  BOARD13_QUESTION5FULL: require("./assets/images/board13_question5full.webp"),
  BOARD13_QUESTION5BLANK: require("./assets/images/board13_question5blank.webp"),

  BOARD13_QUESTION6ICON: require("./assets/images/board13_question6icon.webp"),
  BOARD13_QUESTION6FULL: require("./assets/images/board13_question6full.webp"),
  BOARD13_QUESTION6BLANK: require("./assets/images/board13_question6blank.webp"),

  BOARD13_QUESTION7ICON: require("./assets/images/board13_question7icon.webp"),
  BOARD13_QUESTION7FULL: require("./assets/images/board13_question7full.webp"),
  BOARD13_QUESTION7BLANK: require("./assets/images/board13_question7blank.webp"),

  BOARD13_QUESTION8ICON: require("./assets/images/board13_question8icon.webp"),
  BOARD13_QUESTION8FULL: require("./assets/images/board13_question8full.webp"),
  BOARD13_QUESTION8BLANK: require("./assets/images/board13_question8blank.webp"),

  BOARD13_QUESTION9ICON: require("./assets/images/board13_question9icon.webp"),
  BOARD13_QUESTION9FULL: require("./assets/images/board13_question9full.webp"),
  BOARD13_QUESTION9BLANK: require("./assets/images/board13_question9blank.webp"),

  BOARD13_QUESTION10ICON: require("./assets/images/board13_question10icon.webp"),
  BOARD13_QUESTION10FULL: require("./assets/images/board13_question10full.webp"),
  BOARD13_QUESTION10BLANK: require("./assets/images/board13_question10blank.webp"),

  BOARD13_QUESTION11ICON: require("./assets/images/board13_question11icon.webp"),
  BOARD13_QUESTION11FULL: require("./assets/images/board13_question11full.webp"),
  BOARD13_QUESTION11BLANK: require("./assets/images/board13_question11blank.webp"),

  BOARD13_QUESTION12ICON: require("./assets/images/board13_question12icon.webp"),
  BOARD13_QUESTION12FULL: require("./assets/images/board13_question12full.webp"),
  BOARD13_QUESTION12BLANK: require("./assets/images/board13_question12blank.webp"),

  BOARD13_QUESTION13ICON: require("./assets/images/board13_question13icon.webp"),
  BOARD13_QUESTION13FULL: require("./assets/images/board13_question13full.webp"),
  BOARD13_QUESTION13BLANK: require("./assets/images/board13_question13blank.webp"),

  BOARD13_QUESTION14ICON: require("./assets/images/board13_question14icon.webp"),
  BOARD13_QUESTION14FULL: require("./assets/images/board13_question14full.webp"),
  BOARD13_QUESTION14BLANK: require("./assets/images/board13_question14blank.webp"),

  BOARD13_QUESTION15ICON: require("./assets/images/board13_question15icon.webp"),
  BOARD13_QUESTION15FULL: require("./assets/images/board13_question15full.webp"),
  BOARD13_QUESTION15BLANK: require("./assets/images/board13_question15blank.webp"),

  BOARD13_QUESTION16ICON: require("./assets/images/board13_question16icon.webp"),
  BOARD13_QUESTION16FULL: require("./assets/images/board13_question16full.webp"),
  BOARD13_QUESTION16BLANK: require("./assets/images/board13_question16blank.webp"),

  BOARD13_QUESTION17ICON: require("./assets/images/board13_question17icon.webp"),
  BOARD13_QUESTION17FULL: require("./assets/images/board13_question17full.webp"),
  BOARD13_QUESTION17BLANK: require("./assets/images/board13_question17blank.webp"),

  BOARD13_QUESTION18ICON: require("./assets/images/board13_question18icon.webp"),
  BOARD13_QUESTION18FULL: require("./assets/images/board13_question18full.webp"),
  BOARD13_QUESTION18BLANK: require("./assets/images/board13_question18blank.webp"),

  BOARD14_QUESTION1ICON: require("./assets/images/board14_question1icon.webp"),
  BOARD14_QUESTION1FULL: require("./assets/images/board14_question1full.webp"),
  BOARD14_QUESTION1BLANK: require("./assets/images/board14_question1blank.webp"),

  BOARD14_QUESTION2ICON: require("./assets/images/board14_question2icon.webp"),
  BOARD14_QUESTION2FULL: require("./assets/images/board14_question2full.webp"),
  BOARD14_QUESTION2BLANK: require("./assets/images/board14_question2blank.webp"),

  BOARD14_QUESTION3ICON: require("./assets/images/board14_question3icon.webp"),
  BOARD14_QUESTION3FULL: require("./assets/images/board14_question3full.webp"),
  BOARD14_QUESTION3BLANK: require("./assets/images/board14_question3blank.webp"),

  BOARD14_QUESTION4ICON: require("./assets/images/board14_question4icon.webp"),
  BOARD14_QUESTION4FULL: require("./assets/images/board14_question4full.webp"),
  BOARD14_QUESTION4BLANK: require("./assets/images/board14_question4blank.webp"),

  BOARD14_QUESTION5ICON: require("./assets/images/board14_question5icon.webp"),
  BOARD14_QUESTION5FULL: require("./assets/images/board14_question5full.webp"),
  BOARD14_QUESTION5BLANK: require("./assets/images/board14_question5blank.webp"),

  BOARD14_QUESTION6ICON: require("./assets/images/board14_question6icon.webp"),
  BOARD14_QUESTION6FULL: require("./assets/images/board14_question6full.webp"),
  BOARD14_QUESTION6BLANK: require("./assets/images/board14_question6blank.webp"),

  BOARD14_QUESTION7ICON: require("./assets/images/board14_question7icon.webp"),
  BOARD14_QUESTION7FULL: require("./assets/images/board14_question7full.webp"),
  BOARD14_QUESTION7BLANK: require("./assets/images/board14_question7blank.webp"),

  BOARD14_QUESTION8ICON: require("./assets/images/board14_question8icon.webp"),
  BOARD14_QUESTION8FULL: require("./assets/images/board14_question8full.webp"),
  BOARD14_QUESTION8BLANK: require("./assets/images/board14_question8blank.webp"),

  BOARD14_QUESTION9ICON: require("./assets/images/board14_question9icon.webp"),
  BOARD14_QUESTION9FULL: require("./assets/images/board14_question9full.webp"),
  BOARD14_QUESTION9BLANK: require("./assets/images/board14_question9blank.webp"),

  BOARD14_QUESTION10ICON: require("./assets/images/board14_question10icon.webp"),
  BOARD14_QUESTION10FULL: require("./assets/images/board14_question10full.webp"),
  BOARD14_QUESTION10BLANK: require("./assets/images/board14_question10blank.webp"),

  BOARD14_QUESTION11ICON: require("./assets/images/board14_question11icon.webp"),
  BOARD14_QUESTION11FULL: require("./assets/images/board14_question11full.webp"),
  BOARD14_QUESTION11BLANK: require("./assets/images/board14_question11blank.webp"),

  BOARD14_QUESTION12ICON: require("./assets/images/board14_question12icon.webp"),
  BOARD14_QUESTION12FULL: require("./assets/images/board14_question12full.webp"),
  BOARD14_QUESTION12BLANK: require("./assets/images/board14_question12blank.webp"),

  BOARD14_QUESTION13ICON: require("./assets/images/board14_question13icon.webp"),
  BOARD14_QUESTION13FULL: require("./assets/images/board14_question13full.webp"),
  BOARD14_QUESTION13BLANK: require("./assets/images/board14_question13blank.webp"),

  BOARD14_QUESTION14ICON: require("./assets/images/board14_question14icon.webp"),
  BOARD14_QUESTION14FULL: require("./assets/images/board14_question14full.webp"),
  BOARD14_QUESTION14BLANK: require("./assets/images/board14_question14blank.webp"),

  BOARD14_QUESTION15ICON: require("./assets/images/board14_question15icon.webp"),
  BOARD14_QUESTION15FULL: require("./assets/images/board14_question15full.webp"),
  BOARD14_QUESTION15BLANK: require("./assets/images/board14_question15blank.webp"),

  BOARD14_QUESTION16ICON: require("./assets/images/board14_question16icon.webp"),
  BOARD14_QUESTION16FULL: require("./assets/images/board14_question16full.webp"),
  BOARD14_QUESTION16BLANK: require("./assets/images/board14_question16blank.webp"),

  BOARD14_QUESTION17ICON: require("./assets/images/board14_question17icon.webp"),
  BOARD14_QUESTION17FULL: require("./assets/images/board14_question17full.webp"),
  BOARD14_QUESTION17BLANK: require("./assets/images/board14_question17blank.webp"),

  BOARD14_QUESTION18ICON: require("./assets/images/board14_question18icon.webp"),
  BOARD14_QUESTION18FULL: require("./assets/images/board14_question18full.webp"),
  BOARD14_QUESTION18BLANK: require("./assets/images/board14_question18blank.webp"),

  BOARD15_QUESTION1ICON: require("./assets/images/board15_question1icon.webp"),
  BOARD15_QUESTION1FULL: require("./assets/images/board15_question1full.webp"),
  BOARD15_QUESTION1BLANK: require("./assets/images/board15_question1blank.webp"),

  BOARD15_QUESTION2ICON: require("./assets/images/board15_question2icon.webp"),
  BOARD15_QUESTION2FULL: require("./assets/images/board15_question2full.webp"),
  BOARD15_QUESTION2BLANK: require("./assets/images/board15_question2blank.webp"),

  BOARD15_QUESTION3ICON: require("./assets/images/board15_question3icon.webp"),
  BOARD15_QUESTION3FULL: require("./assets/images/board15_question3full.webp"),
  BOARD15_QUESTION3BLANK: require("./assets/images/board15_question3blank.webp"),

  BOARD15_QUESTION4ICON: require("./assets/images/board15_question4icon.webp"),
  BOARD15_QUESTION4FULL: require("./assets/images/board15_question4full.webp"),
  BOARD15_QUESTION4BLANK: require("./assets/images/board15_question4blank.webp"),

  BOARD15_QUESTION5ICON: require("./assets/images/board15_question5icon.webp"),
  BOARD15_QUESTION5FULL: require("./assets/images/board15_question5full.webp"),
  BOARD15_QUESTION5BLANK: require("./assets/images/board15_question5blank.webp"),

  BOARD15_QUESTION6ICON: require("./assets/images/board15_question6icon.webp"),
  BOARD15_QUESTION6FULL: require("./assets/images/board15_question6full.webp"),
  BOARD15_QUESTION6BLANK: require("./assets/images/board15_question6blank.webp"),

  BOARD15_QUESTION7ICON: require("./assets/images/board15_question7icon.webp"),
  BOARD15_QUESTION7FULL: require("./assets/images/board15_question7full.webp"),
  BOARD15_QUESTION7BLANK: require("./assets/images/board15_question7blank.webp"),

  BOARD15_QUESTION8ICON: require("./assets/images/board15_question8icon.webp"),
  BOARD15_QUESTION8FULL: require("./assets/images/board15_question8full.webp"),
  BOARD15_QUESTION8BLANK: require("./assets/images/board15_question8blank.webp"),

  BOARD15_QUESTION9ICON: require("./assets/images/board15_question9icon.webp"),
  BOARD15_QUESTION9FULL: require("./assets/images/board15_question9full.webp"),
  BOARD15_QUESTION9BLANK: require("./assets/images/board15_question9blank.webp"),

  BOARD15_QUESTION10ICON: require("./assets/images/board15_question10icon.webp"),
  BOARD15_QUESTION10FULL: require("./assets/images/board15_question10full.webp"),
  BOARD15_QUESTION10BLANK: require("./assets/images/board15_question10blank.webp"),

  BOARD15_QUESTION11ICON: require("./assets/images/board15_question11icon.webp"),
  BOARD15_QUESTION11FULL: require("./assets/images/board15_question11full.webp"),
  BOARD15_QUESTION11BLANK: require("./assets/images/board15_question11blank.webp"),

  BOARD15_QUESTION12ICON: require("./assets/images/board15_question12icon.webp"),
  BOARD15_QUESTION12FULL: require("./assets/images/board15_question12full.webp"),
  BOARD15_QUESTION12BLANK: require("./assets/images/board15_question12blank.webp"),

  BOARD15_QUESTION13ICON: require("./assets/images/board15_question13icon.webp"),
  BOARD15_QUESTION13FULL: require("./assets/images/board15_question13full.webp"),
  BOARD15_QUESTION13BLANK: require("./assets/images/board15_question13blank.webp"),

  BOARD15_QUESTION14ICON: require("./assets/images/board15_question14icon.webp"),
  BOARD15_QUESTION14FULL: require("./assets/images/board15_question14full.webp"),
  BOARD15_QUESTION14BLANK: require("./assets/images/board15_question14blank.webp"),

  BOARD15_QUESTION15ICON: require("./assets/images/board15_question15icon.webp"),
  BOARD15_QUESTION15FULL: require("./assets/images/board15_question15full.webp"),
  BOARD15_QUESTION15BLANK: require("./assets/images/board15_question15blank.webp"),

  BOARD15_QUESTION16ICON: require("./assets/images/board15_question16icon.webp"),
  BOARD15_QUESTION16FULL: require("./assets/images/board15_question16full.webp"),
  BOARD15_QUESTION16BLANK: require("./assets/images/board15_question16blank.webp"),

  BOARD15_QUESTION17ICON: require("./assets/images/board15_question17icon.webp"),
  BOARD15_QUESTION17FULL: require("./assets/images/board15_question17full.webp"),
  BOARD15_QUESTION17BLANK: require("./assets/images/board15_question17blank.webp"),

  BOARD15_QUESTION18ICON: require("./assets/images/board15_question18icon.webp"),
  BOARD15_QUESTION18FULL: require("./assets/images/board15_question18full.webp"),
  BOARD15_QUESTION18BLANK: require("./assets/images/board15_question18blank.webp"),

  BOARD16_QUESTION1ICON: require("./assets/images/board16_question1icon.webp"),
  BOARD16_QUESTION1FULL: require("./assets/images/board16_question1full.webp"),
  BOARD16_QUESTION1BLANK: require("./assets/images/board16_question1blank.webp"),

  BOARD16_QUESTION2ICON: require("./assets/images/board16_question2icon.webp"),
  BOARD16_QUESTION2FULL: require("./assets/images/board16_question2full.webp"),
  BOARD16_QUESTION2BLANK: require("./assets/images/board16_question2blank.webp"),

  BOARD16_QUESTION3ICON: require("./assets/images/board16_question3icon.webp"),
  BOARD16_QUESTION3FULL: require("./assets/images/board16_question3full.webp"),
  BOARD16_QUESTION3BLANK: require("./assets/images/board16_question3blank.webp"),

  BOARD16_QUESTION4ICON: require("./assets/images/board16_question4icon.webp"),
  BOARD16_QUESTION4FULL: require("./assets/images/board16_question4full.webp"),
  BOARD16_QUESTION4BLANK: require("./assets/images/board16_question4blank.webp"),

  BOARD16_QUESTION5ICON: require("./assets/images/board16_question5icon.webp"),
  BOARD16_QUESTION5FULL: require("./assets/images/board16_question5full.webp"),
  BOARD16_QUESTION5BLANK: require("./assets/images/board16_question5blank.webp"),

  BOARD16_QUESTION6ICON: require("./assets/images/board16_question6icon.webp"),
  BOARD16_QUESTION6FULL: require("./assets/images/board16_question6full.webp"),
  BOARD16_QUESTION6BLANK: require("./assets/images/board16_question6blank.webp"),

  BOARD16_QUESTION7ICON: require("./assets/images/board16_question7icon.webp"),
  BOARD16_QUESTION7FULL: require("./assets/images/board16_question7full.webp"),
  BOARD16_QUESTION7BLANK: require("./assets/images/board16_question7blank.webp"),

  BOARD16_QUESTION8ICON: require("./assets/images/board16_question8icon.webp"),
  BOARD16_QUESTION8FULL: require("./assets/images/board16_question8full.webp"),
  BOARD16_QUESTION8BLANK: require("./assets/images/board16_question8blank.webp"),

  BOARD16_QUESTION9ICON: require("./assets/images/board16_question9icon.webp"),
  BOARD16_QUESTION9FULL: require("./assets/images/board16_question9full.webp"),
  BOARD16_QUESTION9BLANK: require("./assets/images/board16_question9blank.webp"),

  BOARD16_QUESTION10ICON: require("./assets/images/board16_question10icon.webp"),
  BOARD16_QUESTION10FULL: require("./assets/images/board16_question10full.webp"),
  BOARD16_QUESTION10BLANK: require("./assets/images/board16_question10blank.webp"),

  BOARD16_QUESTION11ICON: require("./assets/images/board16_question11icon.webp"),
  BOARD16_QUESTION11FULL: require("./assets/images/board16_question11full.webp"),
  BOARD16_QUESTION11BLANK: require("./assets/images/board16_question11blank.webp"),

  BOARD16_QUESTION12ICON: require("./assets/images/board16_question12icon.webp"),
  BOARD16_QUESTION12FULL: require("./assets/images/board16_question12full.webp"),
  BOARD16_QUESTION12BLANK: require("./assets/images/board16_question12blank.webp"),

  BOARD16_QUESTION13ICON: require("./assets/images/board16_question13icon.webp"),
  BOARD16_QUESTION13FULL: require("./assets/images/board16_question13full.webp"),
  BOARD16_QUESTION13BLANK: require("./assets/images/board16_question13blank.webp"),

  BOARD16_QUESTION14ICON: require("./assets/images/board16_question14icon.webp"),
  BOARD16_QUESTION14FULL: require("./assets/images/board16_question14full.webp"),
  BOARD16_QUESTION14BLANK: require("./assets/images/board16_question14blank.webp"),

  BOARD16_QUESTION15ICON: require("./assets/images/board16_question15icon.webp"),
  BOARD16_QUESTION15FULL: require("./assets/images/board16_question15full.webp"),
  BOARD16_QUESTION15BLANK: require("./assets/images/board16_question15blank.webp"),

  BOARD16_QUESTION16ICON: require("./assets/images/board16_question16icon.webp"),
  BOARD16_QUESTION16FULL: require("./assets/images/board16_question16full.webp"),
  BOARD16_QUESTION16BLANK: require("./assets/images/board16_question16blank.webp"),

  BOARD16_QUESTION17ICON: require("./assets/images/board16_question17icon.webp"),
  BOARD16_QUESTION17FULL: require("./assets/images/board16_question17full.webp"),
  BOARD16_QUESTION17BLANK: require("./assets/images/board16_question17blank.webp"),

  BOARD16_QUESTION18ICON: require("./assets/images/board16_question18icon.webp"),
  BOARD16_QUESTION18FULL: require("./assets/images/board16_question18full.webp"),
  BOARD16_QUESTION18BLANK: require("./assets/images/board16_question18blank.webp"),

  BOARD17_QUESTION1ICON: require("./assets/images/board17_question1icon.webp"),
  BOARD17_QUESTION1FULL: require("./assets/images/board17_question1full.webp"),
  BOARD17_QUESTION1BLANK: require("./assets/images/board17_question1blank.webp"),

  BOARD17_QUESTION2ICON: require("./assets/images/board17_question2icon.webp"),
  BOARD17_QUESTION2FULL: require("./assets/images/board17_question2full.webp"),
  BOARD17_QUESTION2BLANK: require("./assets/images/board17_question2blank.webp"),

  BOARD17_QUESTION3ICON: require("./assets/images/board17_question3icon.webp"),
  BOARD17_QUESTION3FULL: require("./assets/images/board17_question3full.webp"),
  BOARD17_QUESTION3BLANK: require("./assets/images/board17_question3blank.webp"),

  BOARD17_QUESTION4ICON: require("./assets/images/board17_question4icon.webp"),
  BOARD17_QUESTION4FULL: require("./assets/images/board17_question4full.webp"),
  BOARD17_QUESTION4BLANK: require("./assets/images/board17_question4blank.webp"),

  BOARD17_QUESTION5ICON: require("./assets/images/board17_question5icon.webp"),
  BOARD17_QUESTION5FULL: require("./assets/images/board17_question5full.webp"),
  BOARD17_QUESTION5BLANK: require("./assets/images/board17_question5blank.webp"),

  BOARD17_QUESTION6ICON: require("./assets/images/board17_question6icon.webp"),
  BOARD17_QUESTION6FULL: require("./assets/images/board17_question6full.webp"),
  BOARD17_QUESTION6BLANK: require("./assets/images/board17_question6blank.webp"),

  BOARD17_QUESTION7ICON: require("./assets/images/board17_question7icon.webp"),
  BOARD17_QUESTION7FULL: require("./assets/images/board17_question7full.webp"),
  BOARD17_QUESTION7BLANK: require("./assets/images/board17_question7blank.webp"),

  BOARD17_QUESTION8ICON: require("./assets/images/board17_question8icon.webp"),
  BOARD17_QUESTION8FULL: require("./assets/images/board17_question8full.webp"),
  BOARD17_QUESTION8BLANK: require("./assets/images/board17_question8blank.webp"),

  BOARD17_QUESTION9ICON: require("./assets/images/board17_question9icon.webp"),
  BOARD17_QUESTION9FULL: require("./assets/images/board17_question9full.webp"),
  BOARD17_QUESTION9BLANK: require("./assets/images/board17_question9blank.webp"),

  BOARD17_QUESTION10ICON: require("./assets/images/board17_question10icon.webp"),
  BOARD17_QUESTION10FULL: require("./assets/images/board17_question10full.webp"),
  BOARD17_QUESTION10BLANK: require("./assets/images/board17_question10blank.webp"),

  BOARD17_QUESTION11ICON: require("./assets/images/board17_question11icon.webp"),
  BOARD17_QUESTION11FULL: require("./assets/images/board17_question11full.webp"),
  BOARD17_QUESTION11BLANK: require("./assets/images/board17_question11blank.webp"),

  BOARD17_QUESTION12ICON: require("./assets/images/board17_question12icon.webp"),
  BOARD17_QUESTION12FULL: require("./assets/images/board17_question12full.webp"),
  BOARD17_QUESTION12BLANK: require("./assets/images/board17_question12blank.webp"),

  BOARD17_QUESTION13ICON: require("./assets/images/board17_question13icon.webp"),
  BOARD17_QUESTION13FULL: require("./assets/images/board17_question13full.webp"),
  BOARD17_QUESTION13BLANK: require("./assets/images/board17_question13blank.webp"),

  BOARD17_QUESTION14ICON: require("./assets/images/board17_question14icon.webp"),
  BOARD17_QUESTION14FULL: require("./assets/images/board17_question14full.webp"),
  BOARD17_QUESTION14BLANK: require("./assets/images/board17_question14blank.webp"),

  BOARD17_QUESTION15ICON: require("./assets/images/board17_question15icon.webp"),
  BOARD17_QUESTION15FULL: require("./assets/images/board17_question15full.webp"),
  BOARD17_QUESTION15BLANK: require("./assets/images/board17_question15blank.webp"),

  BOARD17_QUESTION16ICON: require("./assets/images/board17_question16icon.webp"),
  BOARD17_QUESTION16FULL: require("./assets/images/board17_question16full.webp"),
  BOARD17_QUESTION16BLANK: require("./assets/images/board17_question16blank.webp"),

  BOARD17_QUESTION17ICON: require("./assets/images/board17_question17icon.webp"),
  BOARD17_QUESTION17FULL: require("./assets/images/board17_question17full.webp"),
  BOARD17_QUESTION17BLANK: require("./assets/images/board17_question17blank.webp"),

  BOARD17_QUESTION18ICON: require("./assets/images/board17_question18icon.webp"),
  BOARD17_QUESTION18FULL: require("./assets/images/board17_question18full.webp"),
  BOARD17_QUESTION18BLANK: require("./assets/images/board17_question18blank.webp"),

  BOARD18_QUESTION1ICON: require("./assets/images/board18_question1icon.webp"),
  BOARD18_QUESTION1FULL: require("./assets/images/board18_question1full.webp"),
  BOARD18_QUESTION1BLANK: require("./assets/images/board18_question1blank.webp"),

  BOARD18_QUESTION2ICON: require("./assets/images/board18_question2icon.webp"),
  BOARD18_QUESTION2FULL: require("./assets/images/board18_question2full.webp"),
  BOARD18_QUESTION2BLANK: require("./assets/images/board18_question2blank.webp"),

  BOARD18_QUESTION3ICON: require("./assets/images/board18_question3icon.webp"),
  BOARD18_QUESTION3FULL: require("./assets/images/board18_question3full.webp"),
  BOARD18_QUESTION3BLANK: require("./assets/images/board18_question3blank.webp"),

  BOARD18_QUESTION4ICON: require("./assets/images/board18_question4icon.webp"),
  BOARD18_QUESTION4FULL: require("./assets/images/board18_question4full.webp"),
  BOARD18_QUESTION4BLANK: require("./assets/images/board18_question4blank.webp"),

  BOARD18_QUESTION5ICON: require("./assets/images/board18_question5icon.webp"),
  BOARD18_QUESTION5FULL: require("./assets/images/board18_question5full.webp"),
  BOARD18_QUESTION5BLANK: require("./assets/images/board18_question5blank.webp"),

  BOARD18_QUESTION6ICON: require("./assets/images/board18_question6icon.webp"),
  BOARD18_QUESTION6FULL: require("./assets/images/board18_question6full.webp"),
  BOARD18_QUESTION6BLANK: require("./assets/images/board18_question6blank.webp"),

  BOARD18_QUESTION7ICON: require("./assets/images/board18_question7icon.webp"),
  BOARD18_QUESTION7FULL: require("./assets/images/board18_question7full.webp"),
  BOARD18_QUESTION7BLANK: require("./assets/images/board18_question7blank.webp"),

  BOARD18_QUESTION8ICON: require("./assets/images/board18_question8icon.webp"),
  BOARD18_QUESTION8FULL: require("./assets/images/board18_question8full.webp"),
  BOARD18_QUESTION8BLANK: require("./assets/images/board18_question8blank.webp"),

  BOARD18_QUESTION9ICON: require("./assets/images/board18_question9icon.webp"),
  BOARD18_QUESTION9FULL: require("./assets/images/board18_question9full.webp"),
  BOARD18_QUESTION9BLANK: require("./assets/images/board18_question9blank.webp"),

  BOARD18_QUESTION10ICON: require("./assets/images/board18_question10icon.webp"),
  BOARD18_QUESTION10FULL: require("./assets/images/board18_question10full.webp"),
  BOARD18_QUESTION10BLANK: require("./assets/images/board18_question10blank.webp"),

  BOARD18_QUESTION11ICON: require("./assets/images/board18_question11icon.webp"),
  BOARD18_QUESTION11FULL: require("./assets/images/board18_question11full.webp"),
  BOARD18_QUESTION11BLANK: require("./assets/images/board18_question11blank.webp"),

  BOARD18_QUESTION12ICON: require("./assets/images/board18_question12icon.webp"),
  BOARD18_QUESTION12FULL: require("./assets/images/board18_question12full.webp"),
  BOARD18_QUESTION12BLANK: require("./assets/images/board18_question12blank.webp"),

  BOARD18_QUESTION13ICON: require("./assets/images/board18_question13icon.webp"),
  BOARD18_QUESTION13FULL: require("./assets/images/board18_question13full.webp"),
  BOARD18_QUESTION13BLANK: require("./assets/images/board18_question13blank.webp"),

  BOARD18_QUESTION14ICON: require("./assets/images/board18_question14icon.webp"),
  BOARD18_QUESTION14FULL: require("./assets/images/board18_question14full.webp"),
  BOARD18_QUESTION14BLANK: require("./assets/images/board18_question14blank.webp"),

  BOARD18_QUESTION15ICON: require("./assets/images/board18_question15icon.webp"),
  BOARD18_QUESTION15FULL: require("./assets/images/board18_question15full.webp"),
  BOARD18_QUESTION15BLANK: require("./assets/images/board18_question15blank.webp"),

  BOARD18_QUESTION16ICON: require("./assets/images/board18_question16icon.webp"),
  BOARD18_QUESTION16FULL: require("./assets/images/board18_question16full.webp"),
  BOARD18_QUESTION16BLANK: require("./assets/images/board18_question16blank.webp"),

  BOARD18_QUESTION17ICON: require("./assets/images/board18_question17icon.webp"),
  BOARD18_QUESTION17FULL: require("./assets/images/board18_question17full.webp"),
  BOARD18_QUESTION17BLANK: require("./assets/images/board18_question17blank.webp"),

  BOARD18_QUESTION18ICON: require("./assets/images/board18_question18icon.webp"),
  BOARD18_QUESTION18FULL: require("./assets/images/board18_question18full.webp"),
  BOARD18_QUESTION18BLANK: require("./assets/images/board18_question18blank.webp"),

  BOARD19_QUESTION1ICON: require("./assets/images/board19_question1icon.webp"),
  BOARD19_QUESTION1FULL: require("./assets/images/board19_question1full.webp"),
  BOARD19_QUESTION1BLANK: require("./assets/images/board19_question1blank.webp"),

  BOARD19_QUESTION2ICON: require("./assets/images/board19_question2icon.webp"),
  BOARD19_QUESTION2FULL: require("./assets/images/board19_question2full.webp"),
  BOARD19_QUESTION2BLANK: require("./assets/images/board19_question2blank.webp"),

  BOARD19_QUESTION3ICON: require("./assets/images/board19_question3icon.webp"),
  BOARD19_QUESTION3FULL: require("./assets/images/board19_question3full.webp"),
  BOARD19_QUESTION3BLANK: require("./assets/images/board19_question3blank.webp"),

  BOARD19_QUESTION4ICON: require("./assets/images/board19_question4icon.webp"),
  BOARD19_QUESTION4FULL: require("./assets/images/board19_question4full.webp"),
  BOARD19_QUESTION4BLANK: require("./assets/images/board19_question4blank.webp"),

  BOARD19_QUESTION5ICON: require("./assets/images/board19_question5icon.webp"),
  BOARD19_QUESTION5FULL: require("./assets/images/board19_question5full.webp"),
  BOARD19_QUESTION5BLANK: require("./assets/images/board19_question5blank.webp"),

  BOARD19_QUESTION6ICON: require("./assets/images/board19_question6icon.webp"),
  BOARD19_QUESTION6FULL: require("./assets/images/board19_question6full.webp"),
  BOARD19_QUESTION6BLANK: require("./assets/images/board19_question6blank.webp"),

  BOARD19_QUESTION7ICON: require("./assets/images/board19_question7icon.webp"),
  BOARD19_QUESTION7FULL: require("./assets/images/board19_question7full.webp"),
  BOARD19_QUESTION7BLANK: require("./assets/images/board19_question7blank.webp"),

  BOARD19_QUESTION8ICON: require("./assets/images/board19_question8icon.webp"),
  BOARD19_QUESTION8FULL: require("./assets/images/board19_question8full.webp"),
  BOARD19_QUESTION8BLANK: require("./assets/images/board19_question8blank.webp"),

  BOARD19_QUESTION9ICON: require("./assets/images/board19_question9icon.webp"),
  BOARD19_QUESTION9FULL: require("./assets/images/board19_question9full.webp"),
  BOARD19_QUESTION9BLANK: require("./assets/images/board19_question9blank.webp"),

  BOARD19_QUESTION10ICON: require("./assets/images/board19_question10icon.webp"),
  BOARD19_QUESTION10FULL: require("./assets/images/board19_question10full.webp"),
  BOARD19_QUESTION10BLANK: require("./assets/images/board19_question10blank.webp"),

  BOARD19_QUESTION11ICON: require("./assets/images/board19_question11icon.webp"),
  BOARD19_QUESTION11FULL: require("./assets/images/board19_question11full.webp"),
  BOARD19_QUESTION11BLANK: require("./assets/images/board19_question11blank.webp"),

  BOARD19_QUESTION12ICON: require("./assets/images/board19_question12icon.webp"),
  BOARD19_QUESTION12FULL: require("./assets/images/board19_question12full.webp"),
  BOARD19_QUESTION12BLANK: require("./assets/images/board19_question12blank.webp"),

  BOARD19_QUESTION13ICON: require("./assets/images/board19_question13icon.webp"),
  BOARD19_QUESTION13FULL: require("./assets/images/board19_question13full.webp"),
  BOARD19_QUESTION13BLANK: require("./assets/images/board19_question13blank.webp"),

  BOARD19_QUESTION14ICON: require("./assets/images/board19_question14icon.webp"),
  BOARD19_QUESTION14FULL: require("./assets/images/board19_question14full.webp"),
  BOARD19_QUESTION14BLANK: require("./assets/images/board19_question14blank.webp"),

  BOARD19_QUESTION15ICON: require("./assets/images/board19_question15icon.webp"),
  BOARD19_QUESTION15FULL: require("./assets/images/board19_question15full.webp"),
  BOARD19_QUESTION15BLANK: require("./assets/images/board19_question15blank.webp"),

  BOARD19_QUESTION16ICON: require("./assets/images/board19_question16icon.webp"),
  BOARD19_QUESTION16FULL: require("./assets/images/board19_question16full.webp"),
  BOARD19_QUESTION16BLANK: require("./assets/images/board19_question16blank.webp"),

  BOARD19_QUESTION17ICON: require("./assets/images/board19_question17icon.webp"),
  BOARD19_QUESTION17FULL: require("./assets/images/board19_question17full.webp"),
  BOARD19_QUESTION17BLANK: require("./assets/images/board19_question17blank.webp"),

  BOARD19_QUESTION18ICON: require("./assets/images/board19_question18icon.webp"),
  BOARD19_QUESTION18FULL: require("./assets/images/board19_question18full.webp"),
  BOARD19_QUESTION18BLANK: require("./assets/images/board19_question18blank.webp"),

  //Board 1
  BOARD1_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board1_question1fullwithouttape.webp"),
  BOARD1_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board1_question2fullwithouttape.webp"),
  BOARD1_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board1_question3fullwithouttape.webp"),
  BOARD1_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board1_question4fullwithouttape.webp"),
  BOARD1_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board1_question5fullwithouttape.webp"),
  BOARD1_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board1_question6fullwithouttape.webp"),
  BOARD1_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board1_question7fullwithouttape.webp"),
  BOARD1_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board1_question8fullwithouttape.webp"),
  BOARD1_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board1_question9fullwithouttape.webp"),
  BOARD1_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board1_question10fullwithouttape.webp"),
  BOARD1_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board1_question11fullwithouttape.webp"),
  BOARD1_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board1_question12fullwithouttape.webp"),
  BOARD1_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board1_question13fullwithouttape.webp"),
  BOARD1_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board1_question14fullwithouttape.webp"),
  BOARD1_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board1_question15fullwithouttape.webp"),
  BOARD1_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board1_question16fullwithouttape.webp"),
  BOARD1_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board1_question17fullwithouttape.webp"),
  BOARD1_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board1_question18fullwithouttape.webp"),

  //Board 2
  BOARD2_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board2_question1fullwithouttape.webp"),
  BOARD2_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board2_question2fullwithouttape.webp"),
  BOARD2_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board2_question3fullwithouttape.webp"),
  BOARD2_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board2_question4fullwithouttape.webp"),
  BOARD2_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board2_question5fullwithouttape.webp"),
  BOARD2_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board2_question6fullwithouttape.webp"),
  BOARD2_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board2_question7fullwithouttape.webp"),
  BOARD2_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board2_question8fullwithouttape.webp"),
  BOARD2_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board2_question9fullwithouttape.webp"),
  BOARD2_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board2_question10fullwithouttape.webp"),
  BOARD2_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board2_question11fullwithouttape.webp"),
  BOARD2_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board2_question12fullwithouttape.webp"),
  BOARD2_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board2_question13fullwithouttape.webp"),
  BOARD2_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board2_question14fullwithouttape.webp"),
  BOARD2_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board2_question15fullwithouttape.webp"),
  BOARD2_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board2_question16fullwithouttape.webp"),
  BOARD2_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board2_question17fullwithouttape.webp"),
  BOARD2_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board2_question18fullwithouttape.webp"),

  //Board 3
  BOARD3_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board3_question1fullwithouttape.webp"),
  BOARD3_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board3_question2fullwithouttape.webp"),
  BOARD3_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board3_question3fullwithouttape.webp"),
  BOARD3_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board3_question4fullwithouttape.webp"),
  BOARD3_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board3_question5fullwithouttape.webp"),
  BOARD3_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board3_question6fullwithouttape.webp"),
  BOARD3_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board3_question7fullwithouttape.webp"),
  BOARD3_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board3_question8fullwithouttape.webp"),
  BOARD3_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board3_question9fullwithouttape.webp"),
  BOARD3_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board3_question10fullwithouttape.webp"),
  BOARD3_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board3_question11fullwithouttape.webp"),
  BOARD3_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board3_question12fullwithouttape.webp"),
  BOARD3_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board3_question13fullwithouttape.webp"),
  BOARD3_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board3_question14fullwithouttape.webp"),
  BOARD3_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board3_question15fullwithouttape.webp"),
  BOARD3_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board3_question16fullwithouttape.webp"),
  BOARD3_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board3_question17fullwithouttape.webp"),
  BOARD3_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board3_question18fullwithouttape.webp"),

  //Board 4
  BOARD4_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board4_question1fullwithouttape.webp"),
  BOARD4_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board4_question2fullwithouttape.webp"),
  BOARD4_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board4_question3fullwithouttape.webp"),
  BOARD4_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board4_question4fullwithouttape.webp"),
  BOARD4_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board4_question5fullwithouttape.webp"),
  BOARD4_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board4_question6fullwithouttape.webp"),
  BOARD4_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board4_question7fullwithouttape.webp"),
  BOARD4_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board4_question8fullwithouttape.webp"),
  BOARD4_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board4_question9fullwithouttape.webp"),
  BOARD4_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board4_question10fullwithouttape.webp"),
  BOARD4_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board4_question11fullwithouttape.webp"),
  BOARD4_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board4_question12fullwithouttape.webp"),
  BOARD4_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board4_question13fullwithouttape.webp"),
  BOARD4_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board4_question14fullwithouttape.webp"),
  BOARD4_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board4_question15fullwithouttape.webp"),
  BOARD4_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board4_question16fullwithouttape.webp"),
  BOARD4_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board4_question17fullwithouttape.webp"),
  BOARD4_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board4_question18fullwithouttape.webp"),

  //Board 5
  BOARD5_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board5_question1fullwithouttape.webp"),
  BOARD5_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board5_question2fullwithouttape.webp"),
  BOARD5_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board5_question3fullwithouttape.webp"),
  BOARD5_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board5_question4fullwithouttape.webp"),
  BOARD5_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board5_question5fullwithouttape.webp"),
  BOARD5_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board5_question6fullwithouttape.webp"),
  BOARD5_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board5_question7fullwithouttape.webp"),
  BOARD5_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board5_question8fullwithouttape.webp"),
  BOARD5_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board5_question9fullwithouttape.webp"),
  BOARD5_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board5_question10fullwithouttape.webp"),
  BOARD5_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board5_question11fullwithouttape.webp"),
  BOARD5_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board5_question12fullwithouttape.webp"),
  BOARD5_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board5_question13fullwithouttape.webp"),
  BOARD5_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board5_question14fullwithouttape.webp"),
  BOARD5_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board5_question15fullwithouttape.webp"),
  BOARD5_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board5_question16fullwithouttape.webp"),
  BOARD5_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board5_question17fullwithouttape.webp"),
  BOARD5_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board5_question18fullwithouttape.webp"),

  //Board 6
  BOARD6_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board6_question1fullwithouttape.webp"),
  BOARD6_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board6_question2fullwithouttape.webp"),
  BOARD6_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board6_question3fullwithouttape.webp"),
  BOARD6_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board6_question4fullwithouttape.webp"),
  BOARD6_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board6_question5fullwithouttape.webp"),
  BOARD6_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board6_question6fullwithouttape.webp"),
  BOARD6_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board6_question7fullwithouttape.webp"),
  BOARD6_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board6_question8fullwithouttape.webp"),
  BOARD6_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board6_question9fullwithouttape.webp"),
  BOARD6_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board6_question10fullwithouttape.webp"),
  BOARD6_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board6_question11fullwithouttape.webp"),
  BOARD6_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board6_question12fullwithouttape.webp"),
  BOARD6_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board6_question13fullwithouttape.webp"),
  BOARD6_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board6_question14fullwithouttape.webp"),
  BOARD6_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board6_question15fullwithouttape.webp"),
  BOARD6_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board6_question16fullwithouttape.webp"),
  BOARD6_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board6_question17fullwithouttape.webp"),
  BOARD6_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board6_question18fullwithouttape.webp"),

  //Board 7
  BOARD7_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board7_question1fullwithouttape.webp"),
  BOARD7_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board7_question2fullwithouttape.webp"),
  BOARD7_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board7_question3fullwithouttape.webp"),
  BOARD7_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board7_question4fullwithouttape.webp"),
  BOARD7_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board7_question5fullwithouttape.webp"),
  BOARD7_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board7_question6fullwithouttape.webp"),
  BOARD7_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board7_question7fullwithouttape.webp"),
  BOARD7_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board7_question8fullwithouttape.webp"),
  BOARD7_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board7_question9fullwithouttape.webp"),
  BOARD7_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board7_question10fullwithouttape.webp"),
  BOARD7_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board7_question11fullwithouttape.webp"),
  BOARD7_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board7_question12fullwithouttape.webp"),
  BOARD7_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board7_question13fullwithouttape.webp"),
  BOARD7_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board7_question14fullwithouttape.webp"),
  BOARD7_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board7_question15fullwithouttape.webp"),
  BOARD7_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board7_question16fullwithouttape.webp"),
  BOARD7_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board7_question17fullwithouttape.webp"),
  BOARD7_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board7_question18fullwithouttape.webp"),

  //Board 8
  BOARD8_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board8_question1fullwithouttape.webp"),
  BOARD8_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board8_question2fullwithouttape.webp"),
  BOARD8_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board8_question3fullwithouttape.webp"),
  BOARD8_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board8_question4fullwithouttape.webp"),
  BOARD8_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board8_question5fullwithouttape.webp"),
  BOARD8_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board8_question6fullwithouttape.webp"),
  BOARD8_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board8_question7fullwithouttape.webp"),
  BOARD8_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board8_question8fullwithouttape.webp"),
  BOARD8_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board8_question9fullwithouttape.webp"),
  BOARD8_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board8_question10fullwithouttape.webp"),
  BOARD8_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board8_question11fullwithouttape.webp"),
  BOARD8_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board8_question12fullwithouttape.webp"),
  BOARD8_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board8_question13fullwithouttape.webp"),
  BOARD8_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board8_question14fullwithouttape.webp"),
  BOARD8_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board8_question15fullwithouttape.webp"),
  BOARD8_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board8_question16fullwithouttape.webp"),
  BOARD8_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board8_question17fullwithouttape.webp"),
  BOARD8_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board8_question18fullwithouttape.webp"),

  //Board 9
  BOARD9_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board9_question1fullwithouttape.webp"),
  BOARD9_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board9_question2fullwithouttape.webp"),
  BOARD9_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board9_question3fullwithouttape.webp"),
  BOARD9_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board9_question4fullwithouttape.webp"),
  BOARD9_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board9_question5fullwithouttape.webp"),
  BOARD9_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board9_question6fullwithouttape.webp"),
  BOARD9_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board9_question7fullwithouttape.webp"),
  BOARD9_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board9_question8fullwithouttape.webp"),
  BOARD9_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board9_question9fullwithouttape.webp"),
  BOARD9_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board9_question10fullwithouttape.webp"),
  BOARD9_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board9_question11fullwithouttape.webp"),
  BOARD9_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board9_question12fullwithouttape.webp"),
  BOARD9_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board9_question13fullwithouttape.webp"),
  BOARD9_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board9_question14fullwithouttape.webp"),
  BOARD9_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board9_question15fullwithouttape.webp"),
  BOARD9_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board9_question16fullwithouttape.webp"),
  BOARD9_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board9_question17fullwithouttape.webp"),
  BOARD9_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board9_question18fullwithouttape.webp"),

  //Board 10
  BOARD10_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board10_question1fullwithouttape.webp"),
  BOARD10_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board10_question2fullwithouttape.webp"),
  BOARD10_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board10_question3fullwithouttape.webp"),
  BOARD10_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board10_question4fullwithouttape.webp"),
  BOARD10_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board10_question5fullwithouttape.webp"),
  BOARD10_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board10_question6fullwithouttape.webp"),
  BOARD10_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board10_question7fullwithouttape.webp"),
  BOARD10_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board10_question8fullwithouttape.webp"),
  BOARD10_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board10_question9fullwithouttape.webp"),
  BOARD10_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board10_question10fullwithouttape.webp"),
  BOARD10_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board10_question11fullwithouttape.webp"),
  BOARD10_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board10_question12fullwithouttape.webp"),
  BOARD10_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board10_question13fullwithouttape.webp"),
  BOARD10_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board10_question14fullwithouttape.webp"),
  BOARD10_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board10_question15fullwithouttape.webp"),
  BOARD10_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board10_question16fullwithouttape.webp"),
  BOARD10_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board10_question17fullwithouttape.webp"),
  BOARD10_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board10_question18fullwithouttape.webp"),

  //Board 11
  BOARD11_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board11_question1fullwithouttape.webp"),
  BOARD11_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board11_question2fullwithouttape.webp"),
  BOARD11_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board11_question3fullwithouttape.webp"),
  BOARD11_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board11_question4fullwithouttape.webp"),
  BOARD11_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board11_question5fullwithouttape.webp"),
  BOARD11_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board11_question6fullwithouttape.webp"),
  BOARD11_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board11_question7fullwithouttape.webp"),
  BOARD11_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board11_question8fullwithouttape.webp"),
  BOARD11_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board11_question9fullwithouttape.webp"),
  BOARD11_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board11_question10fullwithouttape.webp"),
  BOARD11_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board11_question11fullwithouttape.webp"),
  BOARD11_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board11_question12fullwithouttape.webp"),
  BOARD11_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board11_question13fullwithouttape.webp"),
  BOARD11_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board11_question14fullwithouttape.webp"),
  BOARD11_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board11_question15fullwithouttape.webp"),
  BOARD11_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board11_question16fullwithouttape.webp"),
  BOARD11_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board11_question17fullwithouttape.webp"),
  BOARD11_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board11_question18fullwithouttape.webp"),

  //Board 12
  BOARD12_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board12_question1fullwithouttape.webp"),
  BOARD12_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board12_question2fullwithouttape.webp"),
  BOARD12_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board12_question3fullwithouttape.webp"),
  BOARD12_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board12_question4fullwithouttape.webp"),
  BOARD12_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board12_question5fullwithouttape.webp"),
  BOARD12_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board12_question6fullwithouttape.webp"),
  BOARD12_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board12_question7fullwithouttape.webp"),
  BOARD12_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board12_question8fullwithouttape.webp"),
  BOARD12_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board12_question9fullwithouttape.webp"),
  BOARD12_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board12_question10fullwithouttape.webp"),
  BOARD12_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board12_question11fullwithouttape.webp"),
  BOARD12_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board12_question12fullwithouttape.webp"),
  BOARD12_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board12_question13fullwithouttape.webp"),
  BOARD12_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board12_question14fullwithouttape.webp"),
  BOARD12_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board12_question15fullwithouttape.webp"),
  BOARD12_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board12_question16fullwithouttape.webp"),
  BOARD12_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board12_question17fullwithouttape.webp"),
  BOARD12_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board12_question18fullwithouttape.webp"),

  //Board 13
  BOARD13_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board13_question1fullwithouttape.webp"),
  BOARD13_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board13_question2fullwithouttape.webp"),
  BOARD13_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board13_question3fullwithouttape.webp"),
  BOARD13_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board13_question4fullwithouttape.webp"),
  BOARD13_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board13_question5fullwithouttape.webp"),
  BOARD13_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board13_question6fullwithouttape.webp"),
  BOARD13_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board13_question7fullwithouttape.webp"),
  BOARD13_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board13_question8fullwithouttape.webp"),
  BOARD13_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board13_question9fullwithouttape.webp"),
  BOARD13_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board13_question10fullwithouttape.webp"),
  BOARD13_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board13_question11fullwithouttape.webp"),
  BOARD13_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board13_question12fullwithouttape.webp"),
  BOARD13_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board13_question13fullwithouttape.webp"),
  BOARD13_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board13_question14fullwithouttape.webp"),
  BOARD13_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board13_question15fullwithouttape.webp"),
  BOARD13_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board13_question16fullwithouttape.webp"),
  BOARD13_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board13_question17fullwithouttape.webp"),
  BOARD13_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board13_question18fullwithouttape.webp"),

  //Board 14
  BOARD14_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board14_question1fullwithouttape.webp"),
  BOARD14_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board14_question2fullwithouttape.webp"),
  BOARD14_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board14_question3fullwithouttape.webp"),
  BOARD14_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board14_question4fullwithouttape.webp"),
  BOARD14_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board14_question5fullwithouttape.webp"),
  BOARD14_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board14_question6fullwithouttape.webp"),
  BOARD14_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board14_question7fullwithouttape.webp"),
  BOARD14_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board14_question8fullwithouttape.webp"),
  BOARD14_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board14_question9fullwithouttape.webp"),
  BOARD14_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board14_question10fullwithouttape.webp"),
  BOARD14_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board14_question11fullwithouttape.webp"),
  BOARD14_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board14_question12fullwithouttape.webp"),
  BOARD14_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board14_question13fullwithouttape.webp"),
  BOARD14_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board14_question14fullwithouttape.webp"),
  BOARD14_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board14_question15fullwithouttape.webp"),
  BOARD14_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board14_question16fullwithouttape.webp"),
  BOARD14_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board14_question17fullwithouttape.webp"),
  BOARD14_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board14_question18fullwithouttape.webp"),

  //Board 15
  BOARD15_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board15_question1fullwithouttape.webp"),
  BOARD15_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board15_question2fullwithouttape.webp"),
  BOARD15_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board15_question3fullwithouttape.webp"),
  BOARD15_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board15_question4fullwithouttape.webp"),
  BOARD15_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board15_question5fullwithouttape.webp"),
  BOARD15_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board15_question6fullwithouttape.webp"),
  BOARD15_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board15_question7fullwithouttape.webp"),
  BOARD15_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board15_question8fullwithouttape.webp"),
  BOARD15_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board15_question9fullwithouttape.webp"),
  BOARD15_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board15_question10fullwithouttape.webp"),
  BOARD15_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board15_question11fullwithouttape.webp"),
  BOARD15_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board15_question12fullwithouttape.webp"),
  BOARD15_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board15_question13fullwithouttape.webp"),
  BOARD15_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board15_question14fullwithouttape.webp"),
  BOARD15_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board15_question15fullwithouttape.webp"),
  BOARD15_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board15_question16fullwithouttape.webp"),
  BOARD15_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board15_question17fullwithouttape.webp"),
  BOARD15_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board15_question18fullwithouttape.webp"),

  //Board 16
  BOARD16_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board16_question1fullwithouttape.webp"),
  BOARD16_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board16_question2fullwithouttape.webp"),
  BOARD16_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board16_question3fullwithouttape.webp"),
  BOARD16_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board16_question4fullwithouttape.webp"),
  BOARD16_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board16_question5fullwithouttape.webp"),
  BOARD16_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board16_question6fullwithouttape.webp"),
  BOARD16_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board16_question7fullwithouttape.webp"),
  BOARD16_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board16_question8fullwithouttape.webp"),
  BOARD16_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board16_question9fullwithouttape.webp"),
  BOARD16_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board16_question10fullwithouttape.webp"),
  BOARD16_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board16_question11fullwithouttape.webp"),
  BOARD16_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board16_question12fullwithouttape.webp"),
  BOARD16_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board16_question13fullwithouttape.webp"),
  BOARD16_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board16_question14fullwithouttape.webp"),
  BOARD16_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board16_question15fullwithouttape.webp"),
  BOARD16_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board16_question16fullwithouttape.webp"),
  BOARD16_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board16_question17fullwithouttape.webp"),
  BOARD16_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board16_question18fullwithouttape.webp"),

  //Board 17
  BOARD17_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board17_question1fullwithouttape.webp"),
  BOARD17_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board17_question2fullwithouttape.webp"),
  BOARD17_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board17_question3fullwithouttape.webp"),
  BOARD17_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board17_question4fullwithouttape.webp"),
  BOARD17_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board17_question5fullwithouttape.webp"),
  BOARD17_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board17_question6fullwithouttape.webp"),
  BOARD17_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board17_question7fullwithouttape.webp"),
  BOARD17_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board17_question8fullwithouttape.webp"),
  BOARD17_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board17_question9fullwithouttape.webp"),
  BOARD17_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board17_question10fullwithouttape.webp"),
  BOARD17_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board17_question11fullwithouttape.webp"),
  BOARD17_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board17_question12fullwithouttape.webp"),
  BOARD17_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board17_question13fullwithouttape.webp"),
  BOARD17_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board17_question14fullwithouttape.webp"),
  BOARD17_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board17_question15fullwithouttape.webp"),
  BOARD17_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board17_question16fullwithouttape.webp"),
  BOARD17_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board17_question17fullwithouttape.webp"),
  BOARD17_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board17_question18fullwithouttape.webp"),

  //Board 18
  BOARD18_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board18_question1fullwithouttape.webp"),
  BOARD18_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board18_question2fullwithouttape.webp"),
  BOARD18_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board18_question3fullwithouttape.webp"),
  BOARD18_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board18_question4fullwithouttape.webp"),
  BOARD18_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board18_question5fullwithouttape.webp"),
  BOARD18_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board18_question6fullwithouttape.webp"),
  BOARD18_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board18_question7fullwithouttape.webp"),
  BOARD18_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board18_question8fullwithouttape.webp"),
  BOARD18_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board18_question9fullwithouttape.webp"),
  BOARD18_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board18_question10fullwithouttape.webp"),
  BOARD18_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board18_question11fullwithouttape.webp"),
  BOARD18_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board18_question12fullwithouttape.webp"),
  BOARD18_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board18_question13fullwithouttape.webp"),
  BOARD18_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board18_question14fullwithouttape.webp"),
  BOARD18_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board18_question15fullwithouttape.webp"),
  BOARD18_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board18_question16fullwithouttape.webp"),
  BOARD18_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board18_question17fullwithouttape.webp"),
  BOARD18_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board18_question18fullwithouttape.webp"),

  //Board 19
  BOARD19_QUESTION1FULLWITHOUT_TAPE: require("./assets/images/board19_question1fullwithouttape.webp"),
  BOARD19_QUESTION2FULLWITHOUT_TAPE: require("./assets/images/board19_question2fullwithouttape.webp"),
  BOARD19_QUESTION3FULLWITHOUT_TAPE: require("./assets/images/board19_question3fullwithouttape.webp"),
  BOARD19_QUESTION4FULLWITHOUT_TAPE: require("./assets/images/board19_question4fullwithouttape.webp"),
  BOARD19_QUESTION5FULLWITHOUT_TAPE: require("./assets/images/board19_question5fullwithouttape.webp"),
  BOARD19_QUESTION6FULLWITHOUT_TAPE: require("./assets/images/board19_question6fullwithouttape.webp"),
  BOARD19_QUESTION7FULLWITHOUT_TAPE: require("./assets/images/board19_question7fullwithouttape.webp"),
  BOARD19_QUESTION8FULLWITHOUT_TAPE: require("./assets/images/board19_question8fullwithouttape.webp"),
  BOARD19_QUESTION9FULLWITHOUT_TAPE: require("./assets/images/board19_question9fullwithouttape.webp"),
  BOARD19_QUESTION10FULLWITHOUT_TAPE: require("./assets/images/board19_question10fullwithouttape.webp"),
  BOARD19_QUESTION11FULLWITHOUT_TAPE: require("./assets/images/board19_question11fullwithouttape.webp"),
  BOARD19_QUESTION12FULLWITHOUT_TAPE: require("./assets/images/board19_question12fullwithouttape.webp"),
  BOARD19_QUESTION13FULLWITHOUT_TAPE: require("./assets/images/board19_question13fullwithouttape.webp"),
  BOARD19_QUESTION14FULLWITHOUT_TAPE: require("./assets/images/board19_question14fullwithouttape.webp"),
  BOARD19_QUESTION15FULLWITHOUT_TAPE: require("./assets/images/board19_question15fullwithouttape.webp"),
  BOARD19_QUESTION16FULLWITHOUT_TAPE: require("./assets/images/board19_question16fullwithouttape.webp"),
  BOARD19_QUESTION17FULLWITHOUT_TAPE: require("./assets/images/board19_question17fullwithouttape.webp"),
  BOARD19_QUESTION18FULLWITHOUT_TAPE: require("./assets/images/board19_question18fullwithouttape.webp"),

  //Boards without tape HD

  //Board 1
  BOARD1_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question1fullwithouttape_hd.jpg"),
  BOARD1_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question2fullwithouttape_hd.jpg"),
  BOARD1_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question3fullwithouttape_hd.jpg"),
  BOARD1_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question4fullwithouttape_hd.jpg"),
  BOARD1_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question5fullwithouttape_hd.jpg"),
  BOARD1_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question6fullwithouttape_hd.jpg"),
  BOARD1_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question7fullwithouttape_hd.jpg"),
  BOARD1_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question8fullwithouttape_hd.jpg"),
  BOARD1_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question9fullwithouttape_hd.jpg"),
  BOARD1_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question10fullwithouttape_hd.jpg"),
  BOARD1_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question11fullwithouttape_hd.jpg"),
  BOARD1_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question12fullwithouttape_hd.jpg"),
  BOARD1_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question13fullwithouttape_hd.jpg"),
  BOARD1_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question14fullwithouttape_hd.jpg"),
  BOARD1_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question15fullwithouttape_hd.jpg"),
  BOARD1_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question16fullwithouttape_hd.jpg"),
  BOARD1_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question17fullwithouttape_hd.jpg"),
  BOARD1_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board1_question18fullwithouttape_hd.jpg"),

  //Board 2
  BOARD2_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question1fullwithouttape_hd.jpg"),
  BOARD2_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question2fullwithouttape_hd.jpg"),
  BOARD2_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question3fullwithouttape_hd.jpg"),
  BOARD2_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question4fullwithouttape_hd.jpg"),
  BOARD2_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question5fullwithouttape_hd.jpg"),
  BOARD2_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question6fullwithouttape_hd.jpg"),
  BOARD2_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question7fullwithouttape_hd.jpg"),
  BOARD2_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question8fullwithouttape_hd.jpg"),
  BOARD2_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question9fullwithouttape_hd.jpg"),
  BOARD2_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question10fullwithouttape_hd.jpg"),
  BOARD2_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question11fullwithouttape_hd.jpg"),
  BOARD2_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question12fullwithouttape_hd.jpg"),
  BOARD2_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question13fullwithouttape_hd.jpg"),
  BOARD2_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question14fullwithouttape_hd.jpg"),
  BOARD2_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question15fullwithouttape_hd.jpg"),
  BOARD2_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question16fullwithouttape_hd.jpg"),
  BOARD2_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question17fullwithouttape_hd.jpg"),
  BOARD2_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board2_question18fullwithouttape_hd.jpg"),

  //Board 3
  BOARD3_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question1fullwithouttape_hd.jpg"),
  BOARD3_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question2fullwithouttape_hd.jpg"),
  BOARD3_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question3fullwithouttape_hd.jpg"),
  BOARD3_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question4fullwithouttape_hd.jpg"),
  BOARD3_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question5fullwithouttape_hd.jpg"),
  BOARD3_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question6fullwithouttape_hd.jpg"),
  BOARD3_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question7fullwithouttape_hd.jpg"),
  BOARD3_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question8fullwithouttape_hd.jpg"),
  BOARD3_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question9fullwithouttape_hd.jpg"),
  BOARD3_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question10fullwithouttape_hd.jpg"),
  BOARD3_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question11fullwithouttape_hd.jpg"),
  BOARD3_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question12fullwithouttape_hd.jpg"),
  BOARD3_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question13fullwithouttape_hd.jpg"),
  BOARD3_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question14fullwithouttape_hd.jpg"),
  BOARD3_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question15fullwithouttape_hd.jpg"),
  BOARD3_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question16fullwithouttape_hd.jpg"),
  BOARD3_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question17fullwithouttape_hd.jpg"),
  BOARD3_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board3_question18fullwithouttape_hd.jpg"),

  //Board 4
  BOARD4_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question1fullwithouttape_hd.jpg"),
  BOARD4_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question2fullwithouttape_hd.jpg"),
  BOARD4_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question3fullwithouttape_hd.jpg"),
  BOARD4_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question4fullwithouttape_hd.jpg"),
  BOARD4_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question5fullwithouttape_hd.jpg"),
  BOARD4_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question6fullwithouttape_hd.jpg"),
  BOARD4_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question7fullwithouttape_hd.jpg"),
  BOARD4_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question8fullwithouttape_hd.jpg"),
  BOARD4_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question9fullwithouttape_hd.jpg"),
  BOARD4_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question10fullwithouttape_hd.jpg"),
  BOARD4_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question11fullwithouttape_hd.jpg"),
  BOARD4_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question12fullwithouttape_hd.jpg"),
  BOARD4_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question13fullwithouttape_hd.jpg"),
  BOARD4_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question14fullwithouttape_hd.jpg"),
  BOARD4_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question15fullwithouttape_hd.jpg"),
  BOARD4_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question16fullwithouttape_hd.jpg"),
  BOARD4_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question17fullwithouttape_hd.jpg"),
  BOARD4_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board4_question18fullwithouttape_hd.jpg"),

  //Board 5
  BOARD5_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question1fullwithouttape_hd.jpg"),
  BOARD5_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question2fullwithouttape_hd.jpg"),
  BOARD5_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question3fullwithouttape_hd.jpg"),
  BOARD5_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question4fullwithouttape_hd.jpg"),
  BOARD5_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question5fullwithouttape_hd.jpg"),
  BOARD5_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question6fullwithouttape_hd.jpg"),
  BOARD5_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question7fullwithouttape_hd.jpg"),
  BOARD5_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question8fullwithouttape_hd.jpg"),
  BOARD5_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question9fullwithouttape_hd.jpg"),
  BOARD5_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question10fullwithouttape_hd.jpg"),
  BOARD5_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question11fullwithouttape_hd.jpg"),
  BOARD5_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question12fullwithouttape_hd.jpg"),
  BOARD5_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question13fullwithouttape_hd.jpg"),
  BOARD5_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question14fullwithouttape_hd.jpg"),
  BOARD5_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question15fullwithouttape_hd.jpg"),
  BOARD5_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question16fullwithouttape_hd.jpg"),
  BOARD5_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question17fullwithouttape_hd.jpg"),
  BOARD5_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board5_question18fullwithouttape_hd.jpg"),

  //Board 6
  BOARD6_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question1fullwithouttape_hd.jpg"),
  BOARD6_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question2fullwithouttape_hd.jpg"),
  BOARD6_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question3fullwithouttape_hd.jpg"),
  BOARD6_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question4fullwithouttape_hd.jpg"),
  BOARD6_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question5fullwithouttape_hd.jpg"),
  BOARD6_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question6fullwithouttape_hd.jpg"),
  BOARD6_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question7fullwithouttape_hd.jpg"),
  BOARD6_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question8fullwithouttape_hd.jpg"),
  BOARD6_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question9fullwithouttape_hd.jpg"),
  BOARD6_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question10fullwithouttape_hd.jpg"),
  BOARD6_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question11fullwithouttape_hd.jpg"),
  BOARD6_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question12fullwithouttape_hd.jpg"),
  BOARD6_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question13fullwithouttape_hd.jpg"),
  BOARD6_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question14fullwithouttape_hd.jpg"),
  BOARD6_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question15fullwithouttape_hd.jpg"),
  BOARD6_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question16fullwithouttape_hd.jpg"),
  BOARD6_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question17fullwithouttape_hd.jpg"),
  BOARD6_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board6_question18fullwithouttape_hd.jpg"),

  //Board 7
  BOARD7_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question1fullwithouttape_hd.jpg"),
  BOARD7_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question2fullwithouttape_hd.jpg"),
  BOARD7_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question3fullwithouttape_hd.jpg"),
  BOARD7_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question4fullwithouttape_hd.jpg"),
  BOARD7_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question5fullwithouttape_hd.jpg"),
  BOARD7_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question6fullwithouttape_hd.jpg"),
  BOARD7_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question7fullwithouttape_hd.jpg"),
  BOARD7_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question8fullwithouttape_hd.jpg"),
  BOARD7_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question9fullwithouttape_hd.jpg"),
  BOARD7_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question10fullwithouttape_hd.jpg"),
  BOARD7_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question11fullwithouttape_hd.jpg"),
  BOARD7_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question12fullwithouttape_hd.jpg"),
  BOARD7_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question13fullwithouttape_hd.jpg"),
  BOARD7_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question14fullwithouttape_hd.jpg"),
  BOARD7_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question15fullwithouttape_hd.jpg"),
  BOARD7_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question16fullwithouttape_hd.jpg"),
  BOARD7_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question17fullwithouttape_hd.jpg"),
  BOARD7_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board7_question18fullwithouttape_hd.jpg"),

  //Board 8
  BOARD8_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question1fullwithouttape_hd.jpg"),
  BOARD8_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question2fullwithouttape_hd.jpg"),
  BOARD8_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question3fullwithouttape_hd.jpg"),
  BOARD8_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question4fullwithouttape_hd.jpg"),
  BOARD8_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question5fullwithouttape_hd.jpg"),
  BOARD8_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question6fullwithouttape_hd.jpg"),
  BOARD8_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question7fullwithouttape_hd.jpg"),
  BOARD8_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question8fullwithouttape_hd.jpg"),
  BOARD8_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question9fullwithouttape_hd.jpg"),
  BOARD8_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question10fullwithouttape_hd.jpg"),
  BOARD8_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question11fullwithouttape_hd.jpg"),
  BOARD8_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question12fullwithouttape_hd.jpg"),
  BOARD8_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question13fullwithouttape_hd.jpg"),
  BOARD8_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question14fullwithouttape_hd.jpg"),
  BOARD8_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question15fullwithouttape_hd.jpg"),
  BOARD8_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question16fullwithouttape_hd.jpg"),
  BOARD8_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question17fullwithouttape_hd.jpg"),
  BOARD8_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board8_question18fullwithouttape_hd.jpg"),

  //Board 9
  BOARD9_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question1fullwithouttape_hd.jpg"),
  BOARD9_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question2fullwithouttape_hd.jpg"),
  BOARD9_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question3fullwithouttape_hd.jpg"),
  BOARD9_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question4fullwithouttape_hd.jpg"),
  BOARD9_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question5fullwithouttape_hd.jpg"),
  BOARD9_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question6fullwithouttape_hd.jpg"),
  BOARD9_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question7fullwithouttape_hd.jpg"),
  BOARD9_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question8fullwithouttape_hd.jpg"),
  BOARD9_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question9fullwithouttape_hd.jpg"),
  BOARD9_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question10fullwithouttape_hd.jpg"),
  BOARD9_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question11fullwithouttape_hd.jpg"),
  BOARD9_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question12fullwithouttape_hd.jpg"),
  BOARD9_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question13fullwithouttape_hd.jpg"),
  BOARD9_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question14fullwithouttape_hd.jpg"),
  BOARD9_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question15fullwithouttape_hd.jpg"),
  BOARD9_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question16fullwithouttape_hd.jpg"),
  BOARD9_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question17fullwithouttape_hd.jpg"),
  BOARD9_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board9_question18fullwithouttape_hd.jpg"),

  //Board 10
  BOARD10_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question1fullwithouttape_hd.jpg"),
  BOARD10_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question2fullwithouttape_hd.jpg"),
  BOARD10_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question3fullwithouttape_hd.jpg"),
  BOARD10_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question4fullwithouttape_hd.jpg"),
  BOARD10_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question5fullwithouttape_hd.jpg"),
  BOARD10_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question6fullwithouttape_hd.jpg"),
  BOARD10_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question7fullwithouttape_hd.jpg"),
  BOARD10_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question8fullwithouttape_hd.jpg"),
  BOARD10_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question9fullwithouttape_hd.jpg"),
  BOARD10_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question10fullwithouttape_hd.jpg"),
  BOARD10_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question11fullwithouttape_hd.jpg"),
  BOARD10_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question12fullwithouttape_hd.jpg"),
  BOARD10_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question13fullwithouttape_hd.jpg"),
  BOARD10_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question14fullwithouttape_hd.jpg"),
  BOARD10_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question15fullwithouttape_hd.jpg"),
  BOARD10_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question16fullwithouttape_hd.jpg"),
  BOARD10_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question17fullwithouttape_hd.jpg"),
  BOARD10_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board10_question18fullwithouttape_hd.jpg"),

  //Board 11
  BOARD11_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question1fullwithouttape_hd.jpg"),
  BOARD11_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question2fullwithouttape_hd.jpg"),
  BOARD11_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question3fullwithouttape_hd.jpg"),
  BOARD11_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question4fullwithouttape_hd.jpg"),
  BOARD11_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question5fullwithouttape_hd.jpg"),
  BOARD11_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question6fullwithouttape_hd.jpg"),
  BOARD11_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question7fullwithouttape_hd.jpg"),
  BOARD11_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question8fullwithouttape_hd.jpg"),
  BOARD11_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question9fullwithouttape_hd.jpg"),
  BOARD11_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question10fullwithouttape_hd.jpg"),
  BOARD11_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question11fullwithouttape_hd.jpg"),
  BOARD11_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question12fullwithouttape_hd.jpg"),
  BOARD11_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question13fullwithouttape_hd.jpg"),
  BOARD11_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question14fullwithouttape_hd.jpg"),
  BOARD11_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question15fullwithouttape_hd.jpg"),
  BOARD11_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question16fullwithouttape_hd.jpg"),
  BOARD11_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question17fullwithouttape_hd.jpg"),
  BOARD11_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board11_question18fullwithouttape_hd.jpg"),

  //Board 12
  BOARD12_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question1fullwithouttape_hd.jpg"),
  BOARD12_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question2fullwithouttape_hd.jpg"),
  BOARD12_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question3fullwithouttape_hd.jpg"),
  BOARD12_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question4fullwithouttape_hd.jpg"),
  BOARD12_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question5fullwithouttape_hd.jpg"),
  BOARD12_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question6fullwithouttape_hd.jpg"),
  BOARD12_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question7fullwithouttape_hd.jpg"),
  BOARD12_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question8fullwithouttape_hd.jpg"),
  BOARD12_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question9fullwithouttape_hd.jpg"),
  BOARD12_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question10fullwithouttape_hd.jpg"),
  BOARD12_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question11fullwithouttape_hd.jpg"),
  BOARD12_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question12fullwithouttape_hd.jpg"),
  BOARD12_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question13fullwithouttape_hd.jpg"),
  BOARD12_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question14fullwithouttape_hd.jpg"),
  BOARD12_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question15fullwithouttape_hd.jpg"),
  BOARD12_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question16fullwithouttape_hd.jpg"),
  BOARD12_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question17fullwithouttape_hd.jpg"),
  BOARD12_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board12_question18fullwithouttape_hd.jpg"),

  //Board 13
  BOARD13_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question1fullwithouttape_hd.jpg"),
  BOARD13_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question2fullwithouttape_hd.jpg"),
  BOARD13_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question3fullwithouttape_hd.jpg"),
  BOARD13_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question4fullwithouttape_hd.jpg"),
  BOARD13_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question5fullwithouttape_hd.jpg"),
  BOARD13_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question6fullwithouttape_hd.jpg"),
  BOARD13_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question7fullwithouttape_hd.jpg"),
  BOARD13_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question8fullwithouttape_hd.jpg"),
  BOARD13_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question9fullwithouttape_hd.jpg"),
  BOARD13_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question10fullwithouttape_hd.jpg"),
  BOARD13_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question11fullwithouttape_hd.jpg"),
  BOARD13_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question12fullwithouttape_hd.jpg"),
  BOARD13_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question13fullwithouttape_hd.jpg"),
  BOARD13_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question14fullwithouttape_hd.jpg"),
  BOARD13_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question15fullwithouttape_hd.jpg"),
  BOARD13_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question16fullwithouttape_hd.jpg"),
  BOARD13_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question17fullwithouttape_hd.jpg"),
  BOARD13_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board13_question18fullwithouttape_hd.jpg"),

  //Board 14
  BOARD14_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question1fullwithouttape_hd.jpg"),
  BOARD14_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question2fullwithouttape_hd.jpg"),
  BOARD14_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question3fullwithouttape_hd.jpg"),
  BOARD14_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question4fullwithouttape_hd.jpg"),
  BOARD14_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question5fullwithouttape_hd.jpg"),
  BOARD14_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question6fullwithouttape_hd.jpg"),
  BOARD14_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question7fullwithouttape_hd.jpg"),
  BOARD14_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question8fullwithouttape_hd.jpg"),
  BOARD14_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question9fullwithouttape_hd.jpg"),
  BOARD14_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question10fullwithouttape_hd.jpg"),
  BOARD14_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question11fullwithouttape_hd.jpg"),
  BOARD14_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question12fullwithouttape_hd.jpg"),
  BOARD14_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question13fullwithouttape_hd.jpg"),
  BOARD14_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question14fullwithouttape_hd.jpg"),
  BOARD14_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question15fullwithouttape_hd.jpg"),
  BOARD14_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question16fullwithouttape_hd.jpg"),
  BOARD14_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question17fullwithouttape_hd.jpg"),
  BOARD14_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board14_question18fullwithouttape_hd.jpg"),

  //Board 15
  BOARD15_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question1fullwithouttape_hd.jpg"),
  BOARD15_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question2fullwithouttape_hd.jpg"),
  BOARD15_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question3fullwithouttape_hd.jpg"),
  BOARD15_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question4fullwithouttape_hd.jpg"),
  BOARD15_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question5fullwithouttape_hd.jpg"),
  BOARD15_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question6fullwithouttape_hd.jpg"),
  BOARD15_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question7fullwithouttape_hd.jpg"),
  BOARD15_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question8fullwithouttape_hd.jpg"),
  BOARD15_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question9fullwithouttape_hd.jpg"),
  BOARD15_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question10fullwithouttape_hd.jpg"),
  BOARD15_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question11fullwithouttape_hd.jpg"),
  BOARD15_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question12fullwithouttape_hd.jpg"),
  BOARD15_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question13fullwithouttape_hd.jpg"),
  BOARD15_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question14ifullwithouttape_hd.jpg"),
  BOARD15_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question15fullwithouttape_hd.jpg"),
  BOARD15_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question16fullwithouttape_hd.jpg"),
  BOARD15_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question17fullwithouttape_hd.jpg"),
  BOARD15_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board15_question18fullwithouttape_hd.jpg"),

  //Board 16
  BOARD16_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question1fullwithouttape_hd.jpg"),
  BOARD16_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question2fullwithouttape_hd.jpg"),
  BOARD16_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question3fullwithouttape_hd.jpg"),
  BOARD16_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question4fullwithouttape_hd.jpg"),
  BOARD16_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question5fullwithouttape_hd.jpg"),
  BOARD16_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question6fullwithouttape_hd.jpg"),
  BOARD16_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question7fullwithouttape_hd.jpg"),
  BOARD16_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question8fullwithouttape_hd.jpg"),
  BOARD16_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question9fullwithouttape_hd.jpg"),
  BOARD16_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question10fullwithouttape_hd.jpg"),
  BOARD16_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question11fullwithouttape_hd.jpg"),
  BOARD16_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question12fullwithouttape_hd.jpg"),
  BOARD16_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question13fullwithouttape_hd.jpg"),
  BOARD16_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question14fullwithouttape_hd.jpg"),
  BOARD16_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question15fullwithouttape_hd.jpg"),
  BOARD16_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question16fullwithouttape_hd.jpg"),
  BOARD16_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question17fullwithouttape_hd.jpg"),
  BOARD16_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board16_question18fullwithouttape_hd.jpg"),

  //Board 17
  BOARD17_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question1fullwithouttape_hd.jpg"),
  BOARD17_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question2fullwithouttape_hd.jpg"),
  BOARD17_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question3fullwithouttape_hd.jpg"),
  BOARD17_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question4fullwithouttape_hd.jpg"),
  BOARD17_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question5fullwithouttape_hd.jpg"),
  BOARD17_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question6fullwithouttape_hd.jpg"),
  BOARD17_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question7fullwithouttape_hd.jpg"),
  BOARD17_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question8fullwithouttape_hd.jpg"),
  BOARD17_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question9fullwithouttape_hd.jpg"),
  BOARD17_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question10fullwithouttape_hd.jpg"),
  BOARD17_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question11fullwithouttape_hd.jpg"),
  BOARD17_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question12fullwithouttape_hd.jpg"),
  BOARD17_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question13fullwithouttape_hd.jpg"),
  BOARD17_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question14fullwithouttape_hd.jpg"),
  BOARD17_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question15fullwithouttape_hd.jpg"),
  BOARD17_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question16fullwithouttape_hd.jpg"),
  BOARD17_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question17fullwithouttape_hd.jpg"),
  BOARD17_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board17_question18fullwithouttape_hd.jpg"),

  //Board 18
  BOARD18_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question1fullwithouttape_hd.jpg"),
  BOARD18_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question2fullwithouttape_hd.jpg"),
  BOARD18_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question3fullwithouttape_hd.jpg"),
  BOARD18_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question4fullwithouttape_hd.jpg"),
  BOARD18_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question5fullwithouttape_hd.jpg"),
  BOARD18_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question6fullwithouttape_hd.jpg"),
  BOARD18_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question7fullwithouttape_hd.jpg"),
  BOARD18_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question8fullwithouttape_hd.jpg"),
  BOARD18_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question9fullwithouttape_hd.jpg"),
  BOARD18_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question10fullwithouttape_hd.jpg"),
  BOARD18_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question11fullwithouttape_hd.jpg"),
  BOARD18_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question12fullwithouttape_hd.jpg"),
  BOARD18_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question13fullwithouttape_hd.jpg"),
  BOARD18_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question14fullwithouttape_hd.jpg"),
  BOARD18_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question15fullwithouttape_hd.jpg"),
  BOARD18_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question16fullwithouttape_hd.jpg"),
  BOARD18_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question17fullwithouttape_hd.jpg"),
  BOARD18_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board18_question18fullwithouttape_hd.jpg"),

  //Board 19
  BOARD19_QUESTION1FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question1fullwithouttape_hd.jpg"),
  BOARD19_QUESTION2FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question2fullwithouttape_hd.jpg"),
  BOARD19_QUESTION3FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question3fullwithouttape_hd.jpg"),
  BOARD19_QUESTION4FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question4fullwithouttape_hd.jpg"),
  BOARD19_QUESTION5FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question5fullwithouttape_hd.jpg"),
  BOARD19_QUESTION6FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question6fullwithouttape_hd.jpg"),
  BOARD19_QUESTION7FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question7fullwithouttape_hd.jpg"),
  BOARD19_QUESTION8FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question8fullwithouttape_hd.jpg"),
  BOARD19_QUESTION9FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question9fullwithouttape_hd.jpg"),
  BOARD19_QUESTION10FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question10fullwithouttape_hd.jpg"),
  BOARD19_QUESTION11FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question11fullwithouttape_hd.jpg"),
  BOARD19_QUESTION12FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question12fullwithouttape_hd.jpg"),
  BOARD19_QUESTION13FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question13fullwithouttape_hd.jpg"),
  BOARD19_QUESTION14FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question14fullwithouttape_hd.jpg"),
  BOARD19_QUESTION15FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question15fullwithouttape_hd.jpg"),
  BOARD19_QUESTION16FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question16fullwithouttape_hd.jpg"),
  BOARD19_QUESTION17FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question17fullwithouttape_hd.jpg"),
  BOARD19_QUESTION18FULLWITHOUT_TAPE_HD: require("./assets/images/board19_question18fullwithouttape_hd.jpg"),

  //Room vise Artwork Images
  ROOM_ADS1: require("./assets/images/room_ads1.webp"),
  ROOM_ADS2: require("./assets/images/room_ads2.webp"),
  ROOM_ADS3: require("./assets/images/room_ads3.webp"),
  ROOM_ADS4: require("./assets/images/room_ads4.webp"),
  ROOM_ADS5: require("./assets/images/room_ads5.webp"),
  ROOM_ADS6: require("./assets/images/room_ads6.webp"),
  ROOM_ADS7: require("./assets/images/room_ads7.webp"),
  ROOM_ADS8: require("./assets/images/room_ads8.webp"),
  ROOM_ADS9: require("./assets/images/room_ads9.webp"),
  ROOM_ADS10: require("./assets/images/room_ads10.webp"),

  ROOM_BABIES1: require("./assets/images/room_babies1.webp"),
  ROOM_BABIES2: require("./assets/images/room_babies2.webp"),
  ROOM_BABIES3: require("./assets/images/room_babies3.webp"),
  ROOM_BABIES4: require("./assets/images/room_babies4.webp"),
  ROOM_BABIES5: require("./assets/images/room_babies5.webp"),
  ROOM_BABIES6: require("./assets/images/room_babies6.webp"),
  ROOM_BABIES7: require("./assets/images/room_babies7.webp"),
  ROOM_BABIES8: require("./assets/images/room_babies8.webp"),
  ROOM_BABIES9: require("./assets/images/room_babies9.webp"),
  ROOM_BABIES10: require("./assets/images/room_babies10.webp"),

  ROOM_BUILDINGS1: require("./assets/images/room_buildings1.webp"),
  ROOM_BUILDINGS2: require("./assets/images/room_buildings2.webp"),
  ROOM_BUILDINGS3: require("./assets/images/room_buildings3.webp"),
  ROOM_BUILDINGS4: require("./assets/images/room_buildings4.webp"),
  ROOM_BUILDINGS5: require("./assets/images/room_buildings5.webp"),
  ROOM_BUILDINGS6: require("./assets/images/room_buildings6.webp"),
  ROOM_BUILDINGS7: require("./assets/images/room_buildings7.webp"),
  ROOM_BUILDINGS8: require("./assets/images/room_buildings8.webp"),
  ROOM_BUILDINGS9: require("./assets/images/room_buildings9.webp"),
  ROOM_BUILDINGS10: require("./assets/images/room_buildings10.webp"),

  ROOM_CINEMA1: require("./assets/images/room_cinema1.webp"),
  ROOM_CINEMA2: require("./assets/images/room_cinema2.webp"),
  ROOM_CINEMA3: require("./assets/images/room_cinema3.webp"),
  ROOM_CINEMA4: require("./assets/images/room_cinema4.webp"),
  ROOM_CINEMA5: require("./assets/images/room_cinema5.webp"),
  ROOM_CINEMA6: require("./assets/images/room_cinema6.webp"),
  ROOM_CINEMA7: require("./assets/images/room_cinema7.webp"),
  ROOM_CINEMA8: require("./assets/images/room_cinema8.webp"),
  ROOM_CINEMA9: require("./assets/images/room_cinema9.webp"),
  ROOM_CINEMA10: require("./assets/images/room_cinema10.webp"),

  ROOM_FARMING1: require("./assets/images/room_farming1.webp"),
  ROOM_FARMING2: require("./assets/images/room_farming2.webp"),
  ROOM_FARMING3: require("./assets/images/room_farming3.webp"),
  ROOM_FARMING4: require("./assets/images/room_farming4.webp"),
  ROOM_FARMING5: require("./assets/images/room_farming5.webp"),
  ROOM_FARMING6: require("./assets/images/room_farming6.webp"),
  ROOM_FARMING7: require("./assets/images/room_farming7.webp"),
  ROOM_FARMING8: require("./assets/images/room_farming8.webp"),
  ROOM_FARMING9: require("./assets/images/room_farming9.webp"),
  ROOM_FARMING10: require("./assets/images/room_farming10.webp"),

  ROOM_FLOWERS1: require("./assets/images/room_flowers1.webp"),
  ROOM_FLOWERS2: require("./assets/images/room_flowers2.webp"),
  ROOM_FLOWERS3: require("./assets/images/room_flowers3.webp"),
  ROOM_FLOWERS4: require("./assets/images/room_flowers4.webp"),
  ROOM_FLOWERS5: require("./assets/images/room_flowers5.webp"),
  ROOM_FLOWERS6: require("./assets/images/room_flowers6.webp"),
  ROOM_FLOWERS7: require("./assets/images/room_flowers7.webp"),
  ROOM_FLOWERS8: require("./assets/images/room_flowers8.webp"),
  ROOM_FLOWERS9: require("./assets/images/room_flowers9.webp"),
  ROOM_FLOWERS10: require("./assets/images/room_flowers10.webp"),

  ROOM_FOOD1: require("./assets/images/room_food1.webp"),
  ROOM_FOOD2: require("./assets/images/room_food2.webp"),
  ROOM_FOOD3: require("./assets/images/room_food3.webp"),
  ROOM_FOOD4: require("./assets/images/room_food4.webp"),
  ROOM_FOOD5: require("./assets/images/room_food5.webp"),
  ROOM_FOOD6: require("./assets/images/room_food6.webp"),
  ROOM_FOOD7: require("./assets/images/room_food7.webp"),
  ROOM_FOOD8: require("./assets/images/room_food8.webp"),
  ROOM_FOOD9: require("./assets/images/room_food9.webp"),
  ROOM_FOOD10: require("./assets/images/room_food10.webp"),

  ROOM_INDIA1: require("./assets/images/room_india1.webp"),
  ROOM_INDIA2: require("./assets/images/room_india2.webp"),
  ROOM_INDIA3: require("./assets/images/room_india3.webp"),
  ROOM_INDIA4: require("./assets/images/room_india4.webp"),
  ROOM_INDIA5: require("./assets/images/room_india5.webp"),
  ROOM_INDIA6: require("./assets/images/room_india6.webp"),
  ROOM_INDIA7: require("./assets/images/room_india7.webp"),
  ROOM_INDIA8: require("./assets/images/room_india8.webp"),
  ROOM_INDIA9: require("./assets/images/room_india9.webp"),
  ROOM_INDIA10: require("./assets/images/room_india10.webp"),

  ROOM_LAMPS1: require("./assets/images/room_lamps1.webp"),
  ROOM_LAMPS2: require("./assets/images/room_lamps2.webp"),
  ROOM_LAMPS3: require("./assets/images/room_lamps3.webp"),
  ROOM_LAMPS4: require("./assets/images/room_lamps4.webp"),
  ROOM_LAMPS5: require("./assets/images/room_lamps5.webp"),
  ROOM_LAMPS6: require("./assets/images/room_lamps6.webp"),
  ROOM_LAMPS7: require("./assets/images/room_lamps7.webp"),
  ROOM_LAMPS8: require("./assets/images/room_lamps8.webp"),
  ROOM_LAMPS9: require("./assets/images/room_lamps9.webp"),
  ROOM_LAMPS10: require("./assets/images/room_lamps10.webp"),

  ROOM_MACHINES1: require("./assets/images/room_machines1.webp"),
  ROOM_MACHINES2: require("./assets/images/room_machines2.webp"),
  ROOM_MACHINES3: require("./assets/images/room_machines3.webp"),
  ROOM_MACHINES4: require("./assets/images/room_machines4.webp"),
  ROOM_MACHINES5: require("./assets/images/room_machines5.webp"),
  ROOM_MACHINES6: require("./assets/images/room_machines6.webp"),
  ROOM_MACHINES7: require("./assets/images/room_machines7.webp"),
  ROOM_MACHINES8: require("./assets/images/room_machines8.webp"),
  ROOM_MACHINES9: require("./assets/images/room_machines9.webp"),
  ROOM_MACHINES10: require("./assets/images/room_machines10.webp"),

  ROOM_MEN1: require("./assets/images/room_men1.webp"),
  ROOM_MEN2: require("./assets/images/room_men2.webp"),
  ROOM_MEN3: require("./assets/images/room_men3.webp"),
  ROOM_MEN4: require("./assets/images/room_men4.webp"),
  ROOM_MEN5: require("./assets/images/room_men5.webp"),
  ROOM_MEN6: require("./assets/images/room_men6.webp"),
  ROOM_MEN7: require("./assets/images/room_men7.webp"),
  ROOM_MEN8: require("./assets/images/room_men8.webp"),
  ROOM_MEN9: require("./assets/images/room_men9.webp"),
  ROOM_MEN10: require("./assets/images/room_men10.webp"),

  ROOM_MUSIC1: require("./assets/images/room_music1.webp"),
  ROOM_MUSIC2: require("./assets/images/room_music2.webp"),
  ROOM_MUSIC3: require("./assets/images/room_music3.webp"),
  ROOM_MUSIC4: require("./assets/images/room_music4.webp"),
  ROOM_MUSIC5: require("./assets/images/room_music5.webp"),
  ROOM_MUSIC6: require("./assets/images/room_music6.webp"),
  ROOM_MUSIC7: require("./assets/images/room_music7.webp"),
  ROOM_MUSIC8: require("./assets/images/room_music8.webp"),
  ROOM_MUSIC9: require("./assets/images/room_music9.webp"),
  ROOM_MUSIC10: require("./assets/images/room_music10.webp"),

  ROOM_OLD_LABELS1: require("./assets/images/room_oldlabels1.webp"),
  ROOM_OLD_LABELS2: require("./assets/images/room_oldlabels2.webp"),
  ROOM_OLD_LABELS3: require("./assets/images/room_oldlabels3.webp"),
  ROOM_OLD_LABELS4: require("./assets/images/room_oldlabels4.webp"),
  ROOM_OLD_LABELS5: require("./assets/images/room_oldlabels5.webp"),
  ROOM_OLD_LABELS6: require("./assets/images/room_oldlabels6.webp"),
  ROOM_OLD_LABELS7: require("./assets/images/room_oldlabels7.webp"),
  ROOM_OLD_LABELS8: require("./assets/images/room_oldlabels8.webp"),
  ROOM_OLD_LABELS9: require("./assets/images/room_oldlabels9.webp"),
  ROOM_OLD_LABELS10: require("./assets/images/room_oldlabels10.webp"),

  ROOM_SPORTS1: require("./assets/images/room_sports1.webp"),
  ROOM_SPORTS2: require("./assets/images/room_sports2.webp"),
  ROOM_SPORTS3: require("./assets/images/room_sports3.webp"),
  ROOM_SPORTS4: require("./assets/images/room_sports4.webp"),
  ROOM_SPORTS5: require("./assets/images/room_sports5.webp"),
  ROOM_SPORTS6: require("./assets/images/room_sports6.webp"),
  ROOM_SPORTS7: require("./assets/images/room_sports7.webp"),
  ROOM_SPORTS8: require("./assets/images/room_sports8.webp"),
  ROOM_SPORTS9: require("./assets/images/room_sports9.webp"),
  ROOM_SPORTS10: require("./assets/images/room_sports10.webp"),

  ROOM_SYMBOLS1: require("./assets/images/room_symbols1.webp"),
  ROOM_SYMBOLS2: require("./assets/images/room_symbols2.webp"),
  ROOM_SYMBOLS3: require("./assets/images/room_symbols3.webp"),
  ROOM_SYMBOLS4: require("./assets/images/room_symbols4.webp"),
  ROOM_SYMBOLS5: require("./assets/images/room_symbols5.webp"),
  ROOM_SYMBOLS6: require("./assets/images/room_symbols6.webp"),
  ROOM_SYMBOLS7: require("./assets/images/room_symbols7.webp"),
  ROOM_SYMBOLS8: require("./assets/images/room_symbols8.webp"),
  ROOM_SYMBOLS9: require("./assets/images/room_symbols9.webp"),
  ROOM_SYMBOLS10: require("./assets/images/room_symbols10.webp"),

  ROOM_TOOLS1: require("./assets/images/room_tools1.webp"),
  ROOM_TOOLS2: require("./assets/images/room_tools2.webp"),
  ROOM_TOOLS3: require("./assets/images/room_tools3.webp"),
  ROOM_TOOLS4: require("./assets/images/room_tools4.webp"),
  ROOM_TOOLS5: require("./assets/images/room_tools5.webp"),
  ROOM_TOOLS6: require("./assets/images/room_tools6.webp"),
  ROOM_TOOLS7: require("./assets/images/room_tools7.webp"),
  ROOM_TOOLS8: require("./assets/images/room_tools8.webp"),
  ROOM_TOOLS9: require("./assets/images/room_tools9.webp"),
  ROOM_TOOLS10: require("./assets/images/room_tools10.webp"),

  ROOM_TRANSPORT1: require("./assets/images/room_transport1.webp"),
  ROOM_TRANSPORT2: require("./assets/images/room_transport2.webp"),
  ROOM_TRANSPORT3: require("./assets/images/room_transport3.webp"),
  ROOM_TRANSPORT4: require("./assets/images/room_transport4.webp"),
  ROOM_TRANSPORT5: require("./assets/images/room_transport5.webp"),
  ROOM_TRANSPORT6: require("./assets/images/room_transport6.webp"),
  ROOM_TRANSPORT7: require("./assets/images/room_transport7.webp"),
  ROOM_TRANSPORT8: require("./assets/images/room_transport8.webp"),
  ROOM_TRANSPORT9: require("./assets/images/room_transport9.webp"),
  ROOM_TRANSPORT10: require("./assets/images/room_transport10.webp"),

  ROOM_WILDLIFE1: require("./assets/images/room_wildlife1.webp"),
  ROOM_WILDLIFE2: require("./assets/images/room_wildlife2.webp"),
  ROOM_WILDLIFE3: require("./assets/images/room_wildlife3.webp"),
  ROOM_WILDLIFE4: require("./assets/images/room_wildlife4.webp"),
  ROOM_WILDLIFE5: require("./assets/images/room_wildlife5.webp"),
  ROOM_WILDLIFE6: require("./assets/images/room_wildlife6.webp"),
  ROOM_WILDLIFE7: require("./assets/images/room_wildlife7.webp"),
  ROOM_WILDLIFE8: require("./assets/images/room_wildlife8.webp"),
  ROOM_WILDLIFE9: require("./assets/images/room_wildlife9.webp"),
  ROOM_WILDLIFE10: require("./assets/images/room_wildlife10.webp"),

  ROOM_WOMEN1: require("./assets/images/room_women1.webp"),
  ROOM_WOMEN2: require("./assets/images/room_women2.webp"),
  ROOM_WOMEN3: require("./assets/images/room_women3.webp"),
  ROOM_WOMEN4: require("./assets/images/room_women4.webp"),
  ROOM_WOMEN5: require("./assets/images/room_women5.webp"),
  ROOM_WOMEN6: require("./assets/images/room_women6.webp"),
  ROOM_WOMEN7: require("./assets/images/room_women7.webp"),
  ROOM_WOMEN8: require("./assets/images/room_women8.webp"),
  ROOM_WOMEN9: require("./assets/images/room_women9.webp"),
  ROOM_WOMEN10: require("./assets/images/room_women10.webp"),

  //Room vise Artwork Images HD
  ROOM_ADS1_HD: require("./assets/images/room_ads1_hd.jpg"),
  ROOM_ADS2_HD: require("./assets/images/room_ads2_hd.jpg"),
  ROOM_ADS3_HD: require("./assets/images/room_ads3_hd.jpg"),
  ROOM_ADS4_HD: require("./assets/images/room_ads4_hd.jpg"),
  ROOM_ADS5_HD: require("./assets/images/room_ads5_hd.jpg"),
  ROOM_ADS6_HD: require("./assets/images/room_ads6_hd.jpg"),
  ROOM_ADS7_HD: require("./assets/images/room_ads7_hd.jpg"),
  ROOM_ADS8_HD: require("./assets/images/room_ads8_hd.jpg"),
  ROOM_ADS9_HD: require("./assets/images/room_ads9_hd.jpg"),
  ROOM_ADS10_HD: require("./assets/images/room_ads10_hd.jpg"),

  ROOM_BABIES1_HD: require("./assets/images/room_babies1_hd.jpg"),
  ROOM_BABIES2_HD: require("./assets/images/room_babies2_hd.jpg"),
  ROOM_BABIES3_HD: require("./assets/images/room_babies3_hd.jpg"),
  ROOM_BABIES4_HD: require("./assets/images/room_babies4_hd.jpg"),
  ROOM_BABIES5_HD: require("./assets/images/room_babies5_hd.jpg"),
  ROOM_BABIES6_HD: require("./assets/images/room_babies6_hd.jpg"),
  ROOM_BABIES7_HD: require("./assets/images/room_babies7_hd.jpg"),
  ROOM_BABIES8_HD: require("./assets/images/room_babies8_hd.jpg"),
  ROOM_BABIES9_HD: require("./assets/images/room_babies9_hd.jpg"),
  ROOM_BABIES10_HD: require("./assets/images/room_babies10_hd.jpg"),

  ROOM_BUILDINGS1_HD: require("./assets/images/room_buildings1_hd.jpg"),
  ROOM_BUILDINGS2_HD: require("./assets/images/room_buildings2_hd.jpg"),
  ROOM_BUILDINGS3_HD: require("./assets/images/room_buildings3_hd.jpg"),
  ROOM_BUILDINGS4_HD: require("./assets/images/room_buildings4_hd.jpg"),
  ROOM_BUILDINGS5_HD: require("./assets/images/room_buildings5_hd.jpg"),
  ROOM_BUILDINGS6_HD: require("./assets/images/room_buildings6_hd.jpg"),
  ROOM_BUILDINGS7_HD: require("./assets/images/room_buildings7_hd.jpg"),
  ROOM_BUILDINGS8_HD: require("./assets/images/room_buildings8_hd.jpg"),
  ROOM_BUILDINGS9_HD: require("./assets/images/room_buildings9_hd.jpg"),
  ROOM_BUILDINGS10_HD: require("./assets/images/room_buildings10_hd.jpg"),

  ROOM_CINEMA1_HD: require("./assets/images/room_cinema1_hd.jpg"),
  ROOM_CINEMA2_HD: require("./assets/images/room_cinema2_hd.jpg"),
  ROOM_CINEMA3_HD: require("./assets/images/room_cinema3_hd.jpg"),
  ROOM_CINEMA4_HD: require("./assets/images/room_cinema4_hd.jpg"),
  ROOM_CINEMA5_HD: require("./assets/images/room_cinema5_hd.jpg"),
  ROOM_CINEMA6_HD: require("./assets/images/room_cinema6_hd.jpg"),
  ROOM_CINEMA7_HD: require("./assets/images/room_cinema7_hd.jpg"),
  ROOM_CINEMA8_HD: require("./assets/images/room_cinema8_hd.jpg"),
  ROOM_CINEMA9_HD: require("./assets/images/room_cinema9_hd.jpg"),
  ROOM_CINEMA10_HD: require("./assets/images/room_cinema10_hd.jpg"),

  ROOM_FARMING1_HD: require("./assets/images/room_farming1_hd.jpg"),
  ROOM_FARMING2_HD: require("./assets/images/room_farming2_hd.jpg"),
  ROOM_FARMING3_HD: require("./assets/images/room_farming3_hd.jpg"),
  ROOM_FARMING4_HD: require("./assets/images/room_farming4_hd.jpg"),
  ROOM_FARMING5_HD: require("./assets/images/room_farming5_hd.jpg"),
  ROOM_FARMING6_HD: require("./assets/images/room_farming6_hd.jpg"),
  ROOM_FARMING7_HD: require("./assets/images/room_farming7_hd.jpg"),
  ROOM_FARMING8_HD: require("./assets/images/room_farming8_hd.jpg"),
  ROOM_FARMING9_HD: require("./assets/images/room_farming9_hd.jpg"),
  ROOM_FARMING10_HD: require("./assets/images/room_farming10_hd.jpg"),

  ROOM_FLOWERS1_HD: require("./assets/images/room_flowers1_hd.jpg"),
  ROOM_FLOWERS2_HD: require("./assets/images/room_flowers2_hd.jpg"),
  ROOM_FLOWERS3_HD: require("./assets/images/room_flowers3_hd.jpg"),
  ROOM_FLOWERS4_HD: require("./assets/images/room_flowers4_hd.jpg"),
  ROOM_FLOWERS5_HD: require("./assets/images/room_flowers5_hd.jpg"),
  ROOM_FLOWERS6_HD: require("./assets/images/room_flowers6_hd.jpg"),
  ROOM_FLOWERS7_HD: require("./assets/images/room_flowers7_hd.jpg"),
  ROOM_FLOWERS8_HD: require("./assets/images/room_flowers8_hd.jpg"),
  ROOM_FLOWERS9_HD: require("./assets/images/room_flowers9_hd.jpg"),
  ROOM_FLOWERS10_HD: require("./assets/images/room_flowers10_hd.jpg"),

  ROOM_FOOD1_HD: require("./assets/images/room_food1_hd.jpg"),
  ROOM_FOOD2_HD: require("./assets/images/room_food2_hd.jpg"),
  ROOM_FOOD3_HD: require("./assets/images/room_food3_hd.jpg"),
  ROOM_FOOD4_HD: require("./assets/images/room_food4_hd.jpg"),
  ROOM_FOOD5_HD: require("./assets/images/room_food5_hd.jpg"),
  ROOM_FOOD6_HD: require("./assets/images/room_food6_hd.jpg"),
  ROOM_FOOD7_HD: require("./assets/images/room_food7_hd.jpg"),
  ROOM_FOOD8_HD: require("./assets/images/room_food8_hd.jpg"),
  ROOM_FOOD9_HD: require("./assets/images/room_food9_hd.jpg"),
  ROOM_FOOD10_HD: require("./assets/images/room_food10_hd.jpg"),

  ROOM_INDIA1_HD: require("./assets/images/room_india1_hd.jpg"),
  ROOM_INDIA2_HD: require("./assets/images/room_india2_hd.jpg"),
  ROOM_INDIA3_HD: require("./assets/images/room_india3_hd.jpg"),
  ROOM_INDIA4_HD: require("./assets/images/room_india4_hd.jpg"),
  ROOM_INDIA5_HD: require("./assets/images/room_india5_hd.jpg"),
  ROOM_INDIA6_HD: require("./assets/images/room_india6_hd.jpg"),
  ROOM_INDIA7_HD: require("./assets/images/room_india7_hd.jpg"),
  ROOM_INDIA8_HD: require("./assets/images/room_india8_hd.jpg"),
  ROOM_INDIA9_HD: require("./assets/images/room_india9_hd.jpg"),
  ROOM_INDIA10_HD: require("./assets/images/room_india10_hd.jpg"),

  ROOM_LAMPS1_HD: require("./assets/images/room_lamps1_hd.jpg"),
  ROOM_LAMPS2_HD: require("./assets/images/room_lamps2_hd.jpg"),
  ROOM_LAMPS3_HD: require("./assets/images/room_lamps3_hd.jpg"),
  ROOM_LAMPS4_HD: require("./assets/images/room_lamps4_hd.jpg"),
  ROOM_LAMPS5_HD: require("./assets/images/room_lamps5_hd.jpg"),
  ROOM_LAMPS6_HD: require("./assets/images/room_lamps6_hd.jpg"),
  ROOM_LAMPS7_HD: require("./assets/images/room_lamps7_hd.jpg"),
  ROOM_LAMPS8_HD: require("./assets/images/room_lamps8_hd.jpg"),
  ROOM_LAMPS9_HD: require("./assets/images/room_lamps9_hd.jpg"),
  ROOM_LAMPS10_HD: require("./assets/images/room_lamps10_hd.jpg"),

  ROOM_MACHINES1_HD: require("./assets/images/room_machines1_hd.jpg"),
  ROOM_MACHINES2_HD: require("./assets/images/room_machines2_hd.jpg"),
  ROOM_MACHINES3_HD: require("./assets/images/room_machines3_hd.jpg"),
  ROOM_MACHINES4_HD: require("./assets/images/room_machines4_hd.jpg"),
  ROOM_MACHINES5_HD: require("./assets/images/room_machines5_hd.jpg"),
  ROOM_MACHINES6_HD: require("./assets/images/room_machines6_hd.jpg"),
  ROOM_MACHINES7_HD: require("./assets/images/room_machines7_hd.jpg"),
  ROOM_MACHINES8_HD: require("./assets/images/room_machines8_hd.jpg"),
  ROOM_MACHINES9_HD: require("./assets/images/room_machines9_hd.jpg"),
  ROOM_MACHINES10_HD: require("./assets/images/room_machines10_hd.jpg"),

  ROOM_MEN1_HD: require("./assets/images/room_men1_hd.jpg"),
  ROOM_MEN2_HD: require("./assets/images/room_men2_hd.jpg"),
  ROOM_MEN3_HD: require("./assets/images/room_men3_hd.jpg"),
  ROOM_MEN4_HD: require("./assets/images/room_men4_hd.jpg"),
  ROOM_MEN5_HD: require("./assets/images/room_men5_hd.jpg"),
  ROOM_MEN6_HD: require("./assets/images/room_men6_hd.jpg"),
  ROOM_MEN7_HD: require("./assets/images/room_men7_hd.jpg"),
  ROOM_MEN8_HD: require("./assets/images/room_men8_hd.jpg"),
  ROOM_MEN9_HD: require("./assets/images/room_men9_hd.jpg"),
  ROOM_MEN10_HD: require("./assets/images/room_men10_hd.jpg"),

  ROOM_MUSIC1_HD: require("./assets/images/room_music1_hd.jpg"),
  ROOM_MUSIC2_HD: require("./assets/images/room_music2_hd.jpg"),
  ROOM_MUSIC3_HD: require("./assets/images/room_music3_hd.jpg"),
  ROOM_MUSIC4_HD: require("./assets/images/room_music4_hd.jpg"),
  ROOM_MUSIC5_HD: require("./assets/images/room_music5_hd.jpg"),
  ROOM_MUSIC6_HD: require("./assets/images/room_music6_hd.jpg"),
  ROOM_MUSIC7_HD: require("./assets/images/room_music7_hd.jpg"),
  ROOM_MUSIC8_HD: require("./assets/images/room_music8_hd.jpg"),
  ROOM_MUSIC9_HD: require("./assets/images/room_music9_hd.jpg"),
  ROOM_MUSIC10_HD: require("./assets/images/room_music10_hd.jpg"),

  ROOM_OLD_LABELS1_HD: require("./assets/images/room_oldlabels1_hd.jpg"),
  ROOM_OLD_LABELS2_HD: require("./assets/images/room_oldlabels2_hd.jpg"),
  ROOM_OLD_LABELS3_HD: require("./assets/images/room_oldlabels3_hd.jpg"),
  ROOM_OLD_LABELS4_HD: require("./assets/images/room_oldlabels4_hd.jpg"),
  ROOM_OLD_LABELS5_HD: require("./assets/images/room_oldlabels5_hd.jpg"),
  ROOM_OLD_LABELS6_HD: require("./assets/images/room_oldlabels6_hd.jpg"),
  ROOM_OLD_LABELS7_HD: require("./assets/images/room_oldlabels7_hd.jpg"),
  ROOM_OLD_LABELS8_HD: require("./assets/images/room_oldlabels8_hd.jpg"),
  ROOM_OLD_LABELS9_HD: require("./assets/images/room_oldlabels9_hd.jpg"),
  ROOM_OLD_LABELS10_HD: require("./assets/images/room_oldlabels10_hd.jpg"),

  ROOM_SPORTS1_HD: require("./assets/images/room_sports1_hd.jpg"),
  ROOM_SPORTS2_HD: require("./assets/images/room_sports2_hd.jpg"),
  ROOM_SPORTS3_HD: require("./assets/images/room_sports3_hd.jpg"),
  ROOM_SPORTS4_HD: require("./assets/images/room_sports4_hd.jpg"),
  ROOM_SPORTS5_HD: require("./assets/images/room_sports5_hd.jpg"),
  ROOM_SPORTS6_HD: require("./assets/images/room_sports6_hd.jpg"),
  ROOM_SPORTS7_HD: require("./assets/images/room_sports7_hd.jpg"),
  ROOM_SPORTS8_HD: require("./assets/images/room_sports8_hd.jpg"),
  ROOM_SPORTS9_HD: require("./assets/images/room_sports9_hd.jpg"),
  ROOM_SPORTS10_HD: require("./assets/images/room_sports10_hd.jpg"),

  ROOM_SYMBOLS1_HD: require("./assets/images/room_symbols1_hd.jpg"),
  ROOM_SYMBOLS2_HD: require("./assets/images/room_symbols2_hd.jpg"),
  ROOM_SYMBOLS3_HD: require("./assets/images/room_symbols3_hd.jpg"),
  ROOM_SYMBOLS4_HD: require("./assets/images/room_symbols4_hd.jpg"),
  ROOM_SYMBOLS5_HD: require("./assets/images/room_symbols5_hd.jpg"),
  ROOM_SYMBOLS6_HD: require("./assets/images/room_symbols6_hd.jpg"),
  ROOM_SYMBOLS7_HD: require("./assets/images/room_symbols7_hd.jpg"),
  ROOM_SYMBOLS8_HD: require("./assets/images/room_symbols8_hd.jpg"),
  ROOM_SYMBOLS9_HD: require("./assets/images/room_symbols9_hd.jpg"),
  ROOM_SYMBOLS10_HD: require("./assets/images/room_symbols10_hd.jpg"),

  ROOM_TOOLS1_HD: require("./assets/images/room_tools1_hd.jpg"),
  ROOM_TOOLS2_HD: require("./assets/images/room_tools2_hd.jpg"),
  ROOM_TOOLS3_HD: require("./assets/images/room_tools3_hd.jpg"),
  ROOM_TOOLS4_HD: require("./assets/images/room_tools4_hd.jpg"),
  ROOM_TOOLS5_HD: require("./assets/images/room_tools5_hd.jpg"),
  ROOM_TOOLS6_HD: require("./assets/images/room_tools6_hd.jpg"),
  ROOM_TOOLS7_HD: require("./assets/images/room_tools7_hd.jpg"),
  ROOM_TOOLS8_HD: require("./assets/images/room_tools8_hd.jpg"),
  ROOM_TOOLS9_HD: require("./assets/images/room_tools9_hd.jpg"),
  ROOM_TOOLS10_HD: require("./assets/images/room_tools10_hd.jpg"),

  ROOM_TRANSPORT1_HD: require("./assets/images/room_transport1_hd.jpg"),
  ROOM_TRANSPORT2_HD: require("./assets/images/room_transport2_hd.jpg"),
  ROOM_TRANSPORT3_HD: require("./assets/images/room_transport3_hd.jpg"),
  ROOM_TRANSPORT4_HD: require("./assets/images/room_transport4_hd.jpg"),
  ROOM_TRANSPORT5_HD: require("./assets/images/room_transport5_hd.jpg"),
  ROOM_TRANSPORT6_HD: require("./assets/images/room_transport6_hd.jpg"),
  ROOM_TRANSPORT7_HD: require("./assets/images/room_transport7_hd.jpg"),
  ROOM_TRANSPORT8_HD: require("./assets/images/room_transport8_hd.jpg"),
  ROOM_TRANSPORT9_HD: require("./assets/images/room_transport9_hd.jpg"),
  ROOM_TRANSPORT10_HD: require("./assets/images/room_transport10_hd.jpg"),

  ROOM_WILDLIFE1_HD: require("./assets/images/room_wildlife1_hd.jpg"),
  ROOM_WILDLIFE2_HD: require("./assets/images/room_wildlife2_hd.jpg"),
  ROOM_WILDLIFE3_HD: require("./assets/images/room_wildlife3_hd.jpg"),
  ROOM_WILDLIFE4_HD: require("./assets/images/room_wildlife4_hd.jpg"),
  ROOM_WILDLIFE5_HD: require("./assets/images/room_wildlife5_hd.jpg"),
  ROOM_WILDLIFE6_HD: require("./assets/images/room_wildlife6_hd.jpg"),
  ROOM_WILDLIFE7_HD: require("./assets/images/room_wildlife7_hd.jpg"),
  ROOM_WILDLIFE8_HD: require("./assets/images/room_wildlife8_hd.jpg"),
  ROOM_WILDLIFE9_HD: require("./assets/images/room_wildlife9_hd.jpg"),
  ROOM_WILDLIFE10_HD: require("./assets/images/room_wildlife10_hd.jpg"),

  ROOM_WOMEN1_HD: require("./assets/images/room_women1_hd.jpg"),
  ROOM_WOMEN2_HD: require("./assets/images/room_women2_hd.jpg"),
  ROOM_WOMEN3_HD: require("./assets/images/room_women3_hd.jpg"),
  ROOM_WOMEN4_HD: require("./assets/images/room_women4_hd.jpg"),
  ROOM_WOMEN5_HD: require("./assets/images/room_women5_hd.jpg"),
  ROOM_WOMEN6_HD: require("./assets/images/room_women6_hd.jpg"),
  ROOM_WOMEN7_HD: require("./assets/images/room_women7_hd.jpg"),
  ROOM_WOMEN8_HD: require("./assets/images/room_women8_hd.jpg"),
  ROOM_WOMEN9_HD: require("./assets/images/room_women9_hd.jpg"),
  ROOM_WOMEN10_HD: require("./assets/images/room_women10_hd.jpg"),

  // Extra images for download
  MUSIC1DOWNLOAD: require("./assets/images/artwork_music1.jpg"),
};
